
/**
 * https://github.com/FangHeXie/download
 */
export const data = {
	low: [
		["主席", ""],
		["总理", ""],
		["部长", ""],
		["锦涛", ""],
		["家宝", ""],
		["小平", ""],
		["泽东", ""],
		["泽民", ""],
		["紫阳", ""],
		["共产", ""],
		["封锁", ""],
		["Twitter", "Tw1tter"],
		["Youtube", "Yоutube"],
		["Facebook", "Facebооk"],
		["Blogger", "Blоgger"],
		["wiki", "wik1"],
		["维基", ""],
		["刘晓波", ""],
		["手枪", ""],
		["机枪", ""],
		["步枪", ""],
		["气枪", ""],
		["电狗", ""],
		["枪模", ""],
		["模型枪", ""],
		["彷真枪", ""],
		["狙击枪", ""],
		["来福枪", ""],
		["来复枪", ""],
		["冲锋枪", ""],
		["散弹枪", ""],
		["卡宾枪", ""],
		["猎枪", ""],
		["枪支", ""],
		["枪械", ""],
		["炸药", ""],
		["硝铵", ""],
		["火药", ""],
		["可燃物", ""],
		["炸弹", ""],
		["蒙汗药", ""],
		["叉咬戟", ""],
		["釜握秤", ""],
		["背仁轮", ""],
		["泥马", ""],
		["腐败", ""],
		["法克鱿", ""],
		["潜烈蟹", ""],
		["尾申鲸", ""],
		["吟稻雁", ""],
		["墙煎饭", ""],
		["干泥", ""],
		["厨女馍", ""],
		["二奶", ""],
		["协警", ""],
		["纳米比亚", ""],
		["有华龙", ""],
		["JQ的来", ""],
		["电信路", ""],
		["党鞭", ""],
		["黄巨", ""],
		["荡尽天下", ""],
		["玉皇大帝", ""],
		["李世民", ""],
		["刘刚", ""],
		["不要沉默", ""],
		["国难", ""],
		["浪漫邂逅", ""],
		["张小洋", ""],
		["炸学校", ""],
		["叫晶晶的女孩", ""],
		["国之母", ""],
		["国母", ""],
		["国姆", ""],
		["nowto", "nоwto"],
		["推翻", ""],
		["打倒", ""],
		["民运", ""],
		["维族", ""],
		["喇嘛", ""],
		["镇压", ""],
		["大纪元", ""],
		["纪元网", ""],
		["九评", ""],
		["坦克", ""],
		["金瓶梅", ""],
		["3P", "3Р"],
		["4P", "4Р"],
		["含着", ""],
		["花蕾", ""],
		["做爱", ""],
		["作爱", ""],
		["抽动", ""],
		["抽送", ""],
		["高潮", ""],
		["下身", ""],
		["下体", ""],
		["中出", ""],
		["安全套", ""],
		["打飞机", ""],
		["勃起", ""],
		["快感", ""],
		["呻吟", ""],
		["你爽", ""],
		["菊花", ""],
		["密处", ""],
		["阴道", ""],
		["阴茎", ""],
		["湿润", ""],
		["私处", ""],
		["风波", ""],
		["动乱", ""],
		["天安", ""],
		["风潮", ""],
		["汉维", ""],
		["爱液", ""],
		["精液", ""],
		["拔出", ""],
		["肉棒", ""],
		["被干", ""],
		["潮吹", ""],
		["吃精", ""],
		["大波", ""],
		["荡妇", ""],
		["荡女", ""],
		["龟头", ""],
		["A片", ""],
		["宏志", ""],
		["台独", ""],
		["伦功", ""],
		["法轮", ""],
		["法伦", ""],
		["中南海", ""],
		["异议", ""],
		["五毛", ""],
		["5毛", ""],
		["戒严", ""],
		["幽穴", ""],
		["自由", ""],
		["密醋", ""],
		["射入", ""],
		["射进", ""],
		["英九", ""],
		["水扁", ""],
		["阿扁", ""],
		["你全家", ""],
		["祖宗", ""],
		["下流", ""],
		["处女", ""],
		["处男", ""],
		["精子", ""],
		["咪咪", ""],
		["黄片", ""],
		["H片", ""],
		["民主", ""],
		["三级片", ""],
		["3级片", ""],
		["文革", ""],
		["大跃进", ""],
		["马克思", ""],
		["列宁", ""],
		["斯大林", ""],
		["变态", ""],
		["人妖", ""],
		["异见", ""],
		["学生运动", ""],
		["常委", ""],
		["老子", ""],
		["垃圾", ""],
		["游行", ""],
		["包夜", ""],
		["静坐", ""],
		["示威", ""],
		["反动", ""],
		["中共", ""],
		["独裁", ""],
		["专制", ""],
		["统治", ""],
		["西藏", ""],
		["新疆", ""],
		["藏独", ""],
		["疆独", ""],
		["绿坝", ""],
		["防火长城", ""],
		["GFW", "GFω"],
		["公安", ""],
		["打压", ""],
		["迷信", ""],
		["封建", ""],
		["89", "⑧9"],
		["八九", ""],
		["六四", ""],
		["64", "⑥4"],
		["6月4", ""],
		["六月四", ""],
		["0投资", ""],
		["零投资", ""],
		["0风险", ""],
		["零风险", ""],
		["出师表", ""],
		["187蚊你都觉得贵", ""],
		["187文你都觉得贵", ""],
		["春夏之交", ""],
		["和平奖", ""],
		["1肖", ""],
		["周年", ""],
		["週年", ""],
		["219\\\.84\\\.8\\\.146", ""],
		["宪章", ""],
		["小时上门", ""],
		["2肖", ""],
		["3\\\+1\\\+4", "③\\\+1\\\+4"],
		["6\\\+4", "⑥\\\+4"],
		["363847942", ""],
		["轮盘", ""],
		["唑仑", ""],
		["3肖", ""],
		["4肖", ""],
		["BB弹", ""],
		["外挂", ""],
		["刷人气", ""],
		["赚钱", ""],
		["赚翻", ""],
		["宏辉", ""],
		["洪辉", ""],
		["红辉", ""],
		["5肖", ""],
		["6\\\.4", "⒍4"],
		["4运动", ""],
		["四运动", ""],
		["610", "61О"],
		["洗脑", ""],
		["迫害", ""],
		["伤残", ""],
		["学潮", ""],
		["学运", ""],
		["平反", ""],
		["国保", ""],
		["陪聊", ""],
		["直接干", ""],
		["帮教", ""],
		["手抢", ""],
		["遇难", ""],
		["庄闲", ""],
		["69势", ""],
		["69式", ""],
		["6si", "⑥si"],
		["6一4", ""],
		["6一一4", ""],
		["6四", ""],
		["六4", ""],
		["6月fourth", ""],
		["6泗", ""],
		["6肖", ""],
		["77式", ""],
		["790415683", ""],
		["7·5", ""],
		["七·五", ""],
		["7肖", ""],
		["纪念", ""],
		["地震", ""],
		["8肖", ""],
		["9\\\.13", "⒐13"],
		["956660604", ""],
		["97爱", ""],
		["印尼", ""],
		["神油", ""],
		["9一i平", ""],
		["9平", ""],
		["9肖", ""],
		["9评", ""],
		["CNN", "СNN"],
		["JJ满是伤痕", ""],
		["LES", "LЕS"],
		["K粉", ""],
		["sex", "sеx"],
		["VOA", "VОA"],
		["ak74", "аk74"],
		["AV", "АV"],
		["bbgun", "ВВgun"],
		["bet365", "bеt365"],
		["caoni马", ""],
		["cao我", ""],
		["chinackinfo", "ch1nack1nfo"],
		["clearwisdom\\\.net", "c1earwsdom\\\.net"],
		["ommunist", "оmmunist"],
		["cosplay", "cоsplay"],
		["cpi上升了", ""],
		["透视", ""],
		["弹药", ""],
		["红外", ""],
		["curvybody", "curvybоdy"],
		["dajiyuan", "dàjìyuán"],
		["epochtaiwan\\\.net", "ep0chtaiwan点net"],
		["epochtimes\\\.com", "ep0chtimes.com"],
		["epochtpeseed\\\.net", "ep0chtpeseednet"],
		["TW", "ТW"],
		["一夜情", ""],
		["e圆传奇系统", ""],
		["e夜", ""],
		["商务", ""],
		["兼职", ""],
		["e畅家园", ""],
		["fa3车仑g", "fa3车仑g"],
		["FaLun", "FaLun"],
		["fapiao", "fapiao"],
		["fa工力", "fa工力"],
		["fa车仑工", "fa车仑工"],
		["fa轮", ""],
		["fl功", ""],
		["fm2粉", ""],
		["freetibet", "frеetibet"],
		["gamo密封圈", ""],
		["gamo弹簧", ""],
		["gamo皮碗", ""],
		["gardennetworks\\\.com", "gardennetw0rks.com"],
		["gay", "gаy"],
		["gbh水", ""],
		["GCD", "GСD"],
		["gdp是6\\\.1", ""],
		["ghb水", ""],
		["ghb迷幻液", ""],
		["gong\\\.产一谠", "gong产谠"],
		["gong\\\.铲谠", "gong铲谠"],
		["gongchandang", "gongchandang"],
		["gongchan", "gòngchǎn"],
		["gong产dang", ""],
		["gong产", ""],
		["gong产当", ""],
		["gong产挡", ""],
		["gong产档", ""],
		["gong产裆", ""],
		["gong产谠", ""],
		["gong惨dang", ""],
		["gong惨当", ""],
		["gong惨挡", ""],
		["gong惨档", ""],
		["gong惨裆", ""],
		["gong惨谠", ""],
		["gong掺dang", ""],
		["gong掺当", ""],
		["gong掺挡", ""],
		["gong掺档", ""],
		["gong掺裆", ""],
		["gong掺谠", ""],
		["gong残dang", ""],
		["gong残当", ""],
		["gong残挡", ""],
		["gong残档", ""],
		["gong残裆", ""],
		["gong残谠", ""],
		["gong産dang", ""],
		["gong産当", ""],
		["gong産挡", ""],
		["gong産档", ""],
		["gong産裆", ""],
		["gong産谠", ""],
		["gong铲dang", ""],
		["gong铲当", ""],
		["gong铲挡", ""],
		["gong铲档", ""],
		["gong铲裆", ""],
		["gong铲谠", ""],
		["gooton\\\.cn", "g00t0n.cn"],
		["G情", ""],
		["G点", ""],
		["G网", ""],
		["H1N1", "Н1N1"],
		["hd90", "hd9о"],
		["homeservice", "hоmeservice"],
		["hongzhi", "hóngzhì"],
		["hotbody", "hоtbody"],
		["jiqingshaofu", "jīqíngshǎofù"],
		["jiqingshipin", "jīqíngshìpín"],
		["J吧", ""],
		["J巴", ""],
		["J情", ""],
		["KB气息", ""],
		["king粉", "king粉"],
		["ktv公主", ""],
		["招聘", ""],
		["ji吧", "ji吧"],
		["ji巴", "ji巴"],
		["私服", ""],
		["二十年", ""],
		["20年", ""],
		["二十年", ""],
		["22年", ""],
		["二十二年", ""],
		["不要脸", ""],
		["人妻", ""],
		["夜总会", ""],
		["屁股", ""],
		["白皙", ""],
		["阳具", ""],
		["阴部", ""],
		["下半身", ""],
		["汁液", ""],
		["一丝不挂", ""],
		["肉洞", ""],
		["阴毛", ""],
		["硬起", ""],
		["口交", ""],
		["性交", ""],
		["阴户", ""],
		["多液", ""],
		["多汁", ""],
		["胸部", ""],
		["胸罩", ""],
		["阴蒂", ""],
		["阴唇", ""],
		["涛哥", ""],
		["宝哥", ""],
		["江哥", ""],
		["老毛", ""],
		["打炮", ""],
		["炮友", ""],
		["换妻", ""],
		["两会", ""],
		["liaoliaoxing", "liáoliáoxìng"],
		["liu4", "liù4"],
		["liusi", "liùsì"],
		["liu四", "liu四"],
		["liu泗", "liu泗"],
		["luoliao", "luǒliáo"],
		["luo聊", "luo聊"],
		["m1911", "М1911"],
		["m2增速25\\\.7", ""],
		["m3a1", "М3a1", ""],
		["makelove", "Мakelove"],
		["massage", "Мassage"],
		["maya语", "maya语"],
		["mihuen", "Мihuen"],
		["mihun", "míhún"],
		["minghui", "mínghuì"],
		["mi魂", "mi魂"],
		["MKB42", "МKB42"],
		["mm上门", ""],
		["MP38", "МP38"],
		["MP40", "МP40"],
		["MP43", "МP43"],
		["MP44", "МP44"],
		["mycool", "Мycool"],
		["nbqqqq", "nвqqqq"],
		["jingcha", "jǐngchá"],
		["jinca", "jǐncá"],
		["jincha", "jǐnchá"],
		["jingca", "jǐngcá"],
		["gongan", "gōngàn"],
		["gongang", "gōngàng"],
		["gonan", "gōnàn"],
		["gonang", "gōnàng"],
		["police", "pоlice"],
		["openminded", "оpenminded"],
		["ordnanceband", "оrdnanceband"],
		["pilibaoliao", "pilibaoliaо"],
		["ppsh41", "ppsΗ41"],
		["qqshashou", "qqshashоu"],
		["qq神通", ""],
		["SB", "Sв"],
		["sensual", "sensuαl"],
		["servebeer", "servebeeγ"],
		["shenshou", "shénshòu"],
		["shentong", "shentοng"],
		["果机", ""],
		["虎机", ""],
		["交友", ""],
		["sodjy\\\.co\\\.jp", ""],
		["springof", "springοf"],
		["tianandoor", "tiānāndoor"],
		["tiananmen", "tiānānmén"],
		["朝鲜", ""],
		["tuidan", "tuìdǎn"],
		["tui•", "tuì•"],
		["tui档", "tui档"],
		["tui谠", "tui谠"],
		["ufco", "ufcο"],
		["unusualperson", "unusualpersοn"],
		["veryqq", "verуqq"],
		["wangzhuan", "wǎngzuàn"],
		["wanzhuan", "wǎnzhuàn"],
		["webmasterhome\\\.cntoolqqliao", ""],
		["wujie", "wújiè"],
		["无界", ""],
		["xing", "xìng"],
		["xin爱", "xìn爱"],
		["xueli", "xuélì"],
		["x伴侣", ""],
		["x教", ""],
		["yaosp", "уaоsp"],
		["yhkfz", "унkfz"],
		["yindi", "уindì"],
		["yingdi", "уingdì"],
		["yinshui", "уínshui"],
		["yin毛", "yīn毛"],
		["yin道", "yīn道"],
		["yin部", "yīn部"],
		["yx5577", "уx5577"],
		["y户", ""],
		["y茎", ""],
		["y蒂", ""],
		["zen1shan2ren", "zеn1shan2ren"],
		["zenshanren", "zеnshanren"],
		["zhengjian", "zhеngjian"],
		["zhonghua999", "zhоnghua999"],
		["zhong共", "zhong共"],
		["zj50\\\.cn", ""],
		["①肖", ""],
		["②肖", ""],
		["③肖", ""],
		["④肖", ""],
		["⑤肖", ""],
		["⑥肖", ""],
		["⑦肖", ""],
		["⑧肖", ""],
		["⑨肖", ""],
		["6\\\.4", "⒍4"],
		["一中一台", ""],
		["城管", ""],
		["一肖", ""],
		["一蚕缠", ""],
		["保护费", ""],
		["丁丙诺啡", ""],
		["丁子霖", ""],
		["七\\\.五", ""],
		["七五", ""],
		["万民", ""],
		["三zuo仑", ""],
		["呆婊", ""],
		["三代轮盘", ""],
		["三利达", ""],
		["三去lung", ""],
		["三去车仑", ""],
		["三去轮", ""],
		["三和娱乐城", ""],
		["三哆论", ""],
		["三唑仑", ""],
		["三唑侖", ""],
		["三唑化", ""],
		["三坐仑", ""],
		["三挫仑", ""],
		["三棱刀", ""],
		["三棱刮刀", ""],
		["三棱尖刀", ""],
		["三民", ""],
		["三聚化", ""],
		["三聚氰胺", ""],
		["联帮", ""],
		["八荣八耻", ""],
		["壮阳", ""],
		["不作为奖", ""],
		["不发不行", ""],
		["不呛喉", ""],
		["不得不发", ""],
		["叫春", ""],
		["叫床", ""],
		["与时俱尽", ""],
		["代考", ""],
		["助考", ""],
		["洗票", ""],
		["上访", ""],
		["专治", ""],
		["专用弩", ""],
		["奴隶", ""],
		["維吾", ""],
		["维吾", ""],
		["世维", ""],
		["亡魂", ""],
		["丙吡兰", ""],
		["丙哌利定", ""],
		["东伊运", ""],
		["熟女", ""],
		["诱惑", ""],
		["拔棒", ""],
		["东突", ""],
		["丝情", ""],
		["丝袜", ""],
		["俱乐部", ""],
		["玉足", ""],
		["足推", ""],
		["丝足", ""],
		["弹性", ""],
		["手感", ""],
		["肉感", ""],
		["你的人", ""],
		["进京", ""],
		["个人崇拜", ""],
		["无码", ""],
		["有码", ""],
		["马赛克", ""],
		["黑帮", ""],
		["教主", ""],
		["访民", ""],
		["屁民", ""],
		["P民", ""],
		["刁民", ""],
		["局域网", ""],
		["信贷", ""],
		["戕害", ""],
		["治下", ""],
		["独枭", ""],
		["打手", ""],
		["烂疮", ""],
		["解体", ""],
		["迷魂", ""],
		["维稳", ""],
		["稳定压", ""],
		["邪灵", ""],
		["保镖", ""],
		["宫雾", ""],
		["鹳狸", ""],
		["清鹳", ""],
		["纳粹", ""],
		["法西斯", ""],
		["紧套", ""],
		["坚挺", ""],
		["丰满", ""],
		["丰腴", ""],
		["圆润", ""],
		["丰韵", ""],
		["少妇", ""],
		["临听王", ""],
		["丹凤朝阳", ""],
		["带套", ""],
		["为哥哥", ""],
		["涛公", ""],
		["乌伊会", ""],
		["乌鲁木齐", ""],
		["拉萨", ""],
		["九\\\.评", ""],
		["九一评", ""],
		["习仲勋", ""],
		["近平", ""],
		["乱伦", ""],
		["乱轮", ""],
		["买春", ""],
		["卖春", ""],
		["乾坤棒", ""],
		["二六", ""],
		["交合", ""],
		["二龙戏珠", ""],
		["观音坐莲", ""],
		["老汉推车", ""],
		["男上女下", ""],
		["女下男上", ""],
		["起义", ""],
		["动态网", ""],
		["大法", ""],
		["共匪", ""],
		["共妻", ""],
		["明慧", ""],
		["明思", ""],
		["明心", ""],
		["退队", ""],
		["退团", ""],
		["自焚", ""],
		["伪火", ""],
		["真、善、忍", ""],
		["奖品", ""],
		["幸运", ""],
		["彩票", ""],
		["催情", ""],
		["偷拍", ""],
		["窃听", ""],
		["代开", ""],
		["发票", ""],
		["冶坪", ""],
		["形象工程", ""],
		["翻墙", ""],
		["觉醒", ""],
		["避孕", ""],
		["怀孕", ""],
		["武藤兰", ""],
		["小泽", ""],
		["饭岛爱", ""],
		["TMD", "ТMD"],
		["anal", "аnal"],
		["奈美", ""],
		["集资", ""],
		["cet", "сеt"],
		["伊斯兰", ""],
		["清真", ""],
		["入联", ""],
		["公投", ""],
		["TNT", "ТNT"],
		["藏人", ""],
		["tibet", "tibеt"],
		["穆斯林", ""],
		["TAM", "ТAM"],
		["信访", ""],
		["周铁农", ""],
		["陈昌智", ""],
		["陈至立", ""],
		["王兆", ""],
		["刘少奇", ""],
		["习近平", ""],
		["建敏", ""],
		["贾庆林", ""],
		["树声", ""],
		["路甬祥", ""],
		["铁力瓦尔地", ""],
		["吴邦", ""],
		["乌云其木格", ""],
		["严隽琪", ""],
		["投公", ""],
		["罢免", ""],
		["李鹏", ""],
		["韩启德", ""],
		["叶剑英", ""],
		["李先念", ""],
		["张春贤", ""],
		["张德江", ""],
		["张庆伟", ""],
		["张维庆", ""],
		["张云川", ""],
		["回良玉", ""],
		["回族", ""],
		["杜青林", ""],
		["曾培炎", ""],
		["杨洁篪", ""],
		["周小川", ""],
		["周生贤", ""],
		["周永康", ""],
		["李金华", ""],
		["李克强", ""],
		["李岚清", ""],
		["李盛霖", ""],
		["李铁映", ""],
		["李学举", ""],
		["陈德铭", ""],
		["陈至立", ""],
		["陈竺", ""],
		["尹蔚民", ""],
		["王岐山", ""],
		["王学军", ""],
		["薄一波", ""],
		["黄菊", ""],
		["金人庆", ""],
		["朱镕基", ""],
		["刘家义", ""],
		["刘延东", ""],
		["华建敏", ""],
		["蔡武", ""],
		["曹刚川", ""],
		["戴秉", ""],
		["耿惠昌", ""],
		["韩长赋", ""],
		["姜伟新", ""],
		["梁光烈", ""],
		["马馼", ""],
		["孟建柱", ""],
		["孙家正", ""],
		["孙政才", ""],
		["田成平", ""],
		["汪光焘", ""],
		["吴爱英", ""],
		["吴仪", ""],
		["谢旭人", ""],
		["徐绍史", ""],
		["吾尔", ""],
		["马凯", ""],
		["周济", ""],
		["教育部", ""],
		["陈雷", ""],
		["李毅中", ""],
		["水利部", ""],
		["万钢", ""],
		["罗干", ""],
		["民族", ""],
		["李斌", ""],
		["刺激", ""],
		["张海阳", ""],
		["陈炳德", ""],
		["邓昌友", ""],
		["常万全", ""],
		["范长龙", ""],
		["郭伯雄", ""],
		["靖志远", ""],
		["梁光烈", ""],
		["廖锡龙", ""],
		["孟建柱", ""],
		["彭小枫", ""],
		["吴胜利", ""],
		["徐才厚", ""],
		["许其亮", ""],
		["张高丽", ""],
		["俞正声", ""],
		["刘淇", ""],
		["体系", ""],
		["案件", ""],
		["检察", ""],
		["案件", ""],
		["公诉", ""],
		["诉讼", ""],
		["判决", ""],
		["抗诉", ""],
		["批捕", ""],
		["侦查", ""],
		["王胜俊", ""],
		["闸北", ""],
		["朝阳", ""],
		["李源潮", ""],
		["陈炳德", ""],
		["王乐泉", ""],
		["王岐山", ""],
		["王兆", ""],
		["四人帮", ""],
		["刘少奇", ""],
		["刘云山", ""],
		["常万全", ""],
		["郭伯雄", ""],
		["耀邦", ""],
		["靖志远", ""],
		["汪东兴", ""],
		["十七大", ""],
		["十八大", ""],
		["十九大", ""],
		["十六大", ""],
		["十五大", ""],
		["十四大", ""],
		["维权", ""],
		["罢工", ""],
		["纽约时报", ""],
		["张宝顺", ""],
		["陈良宇", ""],
		["刘奇葆", ""],
		["白恩培", ""],
		["郭声琨", ""],
		["秦光荣", ""],
		["袭击", ""],
		["黄丽满", ""],
		["白景富", ""],
		["列确", ""],
		["厉无畏", ""],
		["王光亚", ""],
		["冷溶", ""],
		["林文漪", ""],
		["BBC", "BBС"],
		["高智晟", ""],
		["公开信", ""],
		["谭作人", ""],
		["李先念", ""],
		["阿旺晋美", ""],
		["粟戎生", ""],
		["刘云耕", ""],
		["曹建明", ""],
		["维汉", ""],
		["张志新", ""],
		["secom", "sеcоm"],
		["请愿", ""],
		["zedong", "zеdоng"],
		["南街村", ""],
		["何清涟", ""],
		["Tank", "Тank"],
		["民反", ""],
		["干你", ""],
		["干他", ""],
		["干她", ""],
		["开苞", ""],
		["口技", ""],
		["狂干", ""],
		["露点", ""],
		["三点", ""],
		["全露", ""],
		["学生妹", ""],
		["坐台", ""],
		["内裤", ""],
		["美联社", ""],
		["法新社", ""],
		["路透社", ""],
		["纽约时报", ""],
		["德新社", ""],
		["压倒一切", ""],
		["民工", ""],
		["欠薪", ""],
		["拖欠", ""],
		["吗啡", ""],
		["大麻", ""],
		["回派", ""],
		["天灭中", ""],
		["屄", "bī"],
		["匕首", ""],
		["幼女", ""],
		["集会", ""],
		["考题", ""],
		["群P", ""],
		["群干", ""],
		["群交", ""],
		["食精", ""],
		["偷欢", ""],
		["援交", ""],
		["九风", ""],
		["劳民伤财", ""],
		["试题", ""],
		["考卷", ""],
		["信用卡", ""],
		["走形式", ""],
		["南水北调", ""],
		["后庭", ""],
		["王丹", ""],
		["博彩", ""],
		["销售", ""],
		["抵押贷款", ""],
		["低价", ""],
		["资金短缺", ""],
		["垮台", ""],
		["倒台", ""],
		["支那", ""],
		["林彪", ""],
		["GCD", "GСD"],
		["穆罕默德", ""],
		["吹箫", ""],
		["粮荒", ""],
		["自然灾害", ""],
		["肉欲", ""],
		["自慰", ""],
		["罢课", ""],
		["罢教", ""],
		["闹事", ""],
		["爱爱", ""],
		["燃烧弹", ""],
		["雷管", ""],
		["限量", ""],
		["铃声", ""],
		["女优", ""],
		["弓弩", ""],
		["回民", ""],
		["港人", ""],
		["海洛因", ""],
		["白粉", ""],
		["汉族", ""],
		["口活", ""],
		["供产", ""],
		["火辣", ""],
		["发生关系", ""],
		["发情", ""],
		["发春", ""],
		["浑圆", ""],
		["红满堂", ""],
		["咖啡因", ""],
		["二手", ""],
		["三硝基甲苯", ""],
		["调教", ""],
		["人兽", ""],
		["煞笔", ""],
		["考中", ""],
		["绝食", ""],
		["特码", ""],
		["下注", ""],
		["假币", ""],
		["假钱", ""],
		["针刺", ""],
		["援藏", ""],
		["欲火", ""],
		["藏民", ""],
		["灾年", ""],
		["受灾", ""],
		["点招", ""],
		["一码", ""],
		["第一夫人", ""],
		["烛光", ""],
		["英灵", ""],
		["王君", ""],
		["林明月", ""],
		["勾魂", ""],
		["武侯祠", ""],
		["乱交", ""],
		["颜骑", ""],
		["老共", ""],
		["发浪", ""],
		["发嗲", ""],
		["西独", ""],
		["买春", ""],
		["卖身", ""],
		["温如春", ""],
		["强卫", ""],
		["阴精", ""],
		["藏西", ""],
		["里鹏", ""],
		["张筱雨", ""],
		["地塞米松", ""],
		["爱幼", ""],
		["baozha", "bàozhà"],
		["王胜俊", ""],
		["王千源", ""],
		["虎骑", ""],
		["G片", ""],
		["jieyan", "jiеyаn"],
		["xizang", "xizаng"],
		["xi藏", ""],
		["zemin", "zемin"],
		["ze民", ""],
		["刘维明", ""],
		["段义和", ""],
		["令计划", ""],
		["苏树林", ""],
		["罢吃", ""],
		["反奥", ""],
		["低价出售", ""],
		["东方微点", ""],
		["少年阿宾", ""],
		["援助交际", ""],
		["杨帆", ""],
		["人渣", ""],
		["应召", ""],
		["亚情", ""],
		["玉蒲团", ""],
		["手狗", ""],
		["直捣", ""],
		["悼念", ""],
		["小电影", ""],
		["欲女", ""],
		["马勒", ""],
		["玉女心经", ""],
		["双飞", ""],
		["jintao", "jintаo"],
		["jingtao", "jingtаo"],
		["jiabao", "jiаbao"],
		["找男", ""],
		["找女", ""],
		["奈美", ""],
		["麻古", ""],
		["杨思敏", ""],
		["铃木麻", ""],
		["松岛枫", ""],
		["夏川纯", ""],
		["穆罕穆德", ""],
		["酥麻", ""],
		["菊鲍", ""],
		["胡海峰", ""],
		["胡海清", ""],
		["郭金龙", ""],
		["李春城", ""],
		["韩正", ""],
		["杨利民", ""],
		["王正伟", ""],
		["刘石泉", ""],
		["尚福林", ""],
		["张荣坤", ""],
		["赵永生", ""],
		["何祚庥", ""],
		["何厚铧", ""],
		["陈奎元", ""],
		["黄孟复", ""],
		["白春礼", ""],
		["白立忱", ""],
		["储波", ""],
		["卫留成", ""],
		["李成玉", ""],
		["李景田", ""],
		["李荣融", ""],
		["李兆焯", ""],
		["刘明康", ""],
		["孔丹", ""],
		["泽慧", ""],
		["梁保华", ""],
		["卢展工", ""],
		["罗清泉", ""],
		["吕祖善", ""],
		["马万祺", ""],
		["钱运录", ""],
		["石宗源", ""],
		["彭丽媛", ""],
		["张丹红", ""],
		["张惠新", ""],
		["张立昌", ""],
		["张文岳", ""],
		["赵乐际", ""],
		["杨传堂", ""],
		["王鸿举", ""],
		["王家瑞", ""],
		["王金山", ""],
		["王志珍", ""],
		["汤加丽", ""],
		["平习", ""],
		["铁凝", ""],
		["韦建桦", ""],
		["魏礼群", ""],
		["上京", ""],
		["魏京生", ""],
		["吴定富", ""],
		["向巴平措", ""],
		["徐光春", ""],
		["叶小文", ""],
		["由喜贵", ""],
		["陈建民", ""],
		["王沪宁", ""],
		["上沪", ""],
		["王自强", ""],
		["王维林", ""],
		["刘宾雁", ""],
		["邓力群", ""],
		["宋祖英", ""],
		["董文华", ""],
		["陶斯亮", ""],
		["严家其", ""],
		["郑万通", ""],
		["荣智健", ""],
		["黑鲍", ""],
		["安眠酮", ""],
		["普萘洛尔", ""],
		["呋塞米", ""],
		["西布曲明", ""],
		["地西泮", ""],
		["地奈德", ""],
		["地塞米松", ""],
		["尼可刹米", ""],
		["甲睾酮", ""],
		["氯噻嗪", ""],
		["氯胺酮", ""],
		["苯巴比妥", ""],
		["苯丙胺", ""],
		["戊四氮", ""],
		["泼尼松", ""],
		["美沙酮", ""],
		["莫达非尼", ""],
		["甲基安非他明", ""],
		["爽片", ""],
		["沙比", ""],
		["装B", ""],
		["促红细胞生成素", ""],
		["羟基丁酸", ""],
		["Party", "Pаrty"],
		["麻醉", ""],
		["胰岛素样生长因子", ""],
		["杜世成", ""],
		["湾台", ""],
		["维持稳定", ""],
		["吴关正", ""],
		["曾庆红", ""],
		["李长春", ""],
		["萨达姆", ""],
		["拉登", ""],
		["李瑞环", ""],
		["沈跃跃", ""],
		["9风", ""],
		["则民", ""],
		["则东", ""],
		["宋平顺", ""],
		["刘永治", ""],
		["yangjia", "yаngjiа"],
		["反共", ""],
		["正府", ""],
		["贺卫方", ""],
		["Google", "Gооgle"],
		["冯正虎", ""],
		["陈光诚", ""],
		["吸精", ""],
		["阴B", ""],
		["阴dao", ""],
		["阴jin", ""],
		["yindao", "yindаo"],
		["yinjin", "yīnjin"],
		["RFA", "RFА"],
		["jing坐", ""],
		["达赖", ""],
		["lasa", "lаsa"],
		["高丽棒子", ""],
		["三陪", ""],
		["杂种", ""],
		["印泥巴", ""],
		["老二", ""],
		["赵连海", ""],
		["COMMUNIST", "CоMMUNIST"],
		["方滨兴", ""],
		["黄丝带", ""],
		["六•四", ""],
		["6•4", ""],
		["伊斯兰", ""],
		["群：", ""],
		["群:", ""],
		["群", ""],
		["群　", ""],
		["槽尼玛", ""],
		["睾丸", ""],
		["蚁力神", ""],
		["肉茎", ""],
		["泽D", ""],
		["泽M", ""],
		["杨J", ""],
		["张志伟", ""],
		["士的宁", ""],
		["啦撒", ""],
		["麻痹的", ""],
		["阴阜", ""],
		["阴囊", ""],
		["赌球", ""],
		["出售", ""],
		["代购", ""],
		["购买", ""],
		["质押贷款", ""],
		["di制", ""],
		["火乍", ""],
		["收购", ""],
		["轮功", ""],
		["人拳", ""],
		["幼男", ""],
		["李洪志", ""],
		["陈水B", ""],
		["G匪", ""],
		["求购", ""],
		["苍井空", ""],
		["敏主", ""],
		["加盟", ""],
		["连锁", ""],
		["Fuck", "Fuсk"],
		["舐", "shì"],
		["抽搐", ""],
		["吸允", ""],
		["夫妻交换", ""],
		["交换夫妻", ""],
		["肉缝", ""],
		["销魂", ""],
		["白虎", ""],
		["推油", ""],
		["套弄", ""],
		["浪叫", ""],
		["屁眼", ""],
		["阴缔", ""],
		["阴核", ""],
		["小JJ", ""],
		["大JJ", ""],
		["干我", ""],
		["干它", ""],
		["含住", ""],
		["蓓蕾", ""],
		["花呸", ""],
		["花蓓", ""],
		["花芯", ""],
		["杜德印", ""],
		["刘胜玉", ""],
		["戴相龙", ""],
		["白克明", ""],
		["郭庚茂", ""],
		["赵金铎", ""],
		["孟学农", ""],
		["陈光林", ""],
		["郭廷标", ""],
		["王珉", ""],
		["王云坤", ""],
		["张左己", ""],
		["王巨禄", ""],
		["龚学平", ""],
		["许仲林", ""],
		["赵洪祝", ""],
		["杨多良", ""],
		["黄小晶", ""],
		["梁绮萍", ""],
		["吴新雄", ""],
		["傅克诚", ""],
		["姜大明", ""],
		["孙淑义", ""],
		["王全书", ""],
		["杨永良", ""],
		["王生铁", ""],
		["周强", ""],
		["陈绍基", ""],
		["马庆生", ""],
		["罗保铭", ""],
		["钟文", ""],
		["汪洋", ""],
		["刘志忠", ""],
		["林杜", ""],
		["秦玉琴", ""],
		["林树森", ""],
		["黄瑶", ""],
		["王学仁", ""],
		["张庆黎", ""],
		["帕巴拉", ""],
		["崔林涛", ""],
		["袁纯清", ""],
		["艾丕善", ""],
		["陆浩", ""],
		["徐守盛", ""],
		["仲兆隆", ""],
		["宋秀岩", ""],
		["白玛", ""],
		["任启兴", ""],
		["阿不都热依木", ""],
		["阿米提", ""],
		["艾斯海提", ""],
		["克里木拜", ""],
		["徐荣凯", ""],
		["杨崇汇", ""],
		["苏荣", ""],
		["桑结加", ""],
		["马启智", ""],
		["于均波", ""],
		["程世娥", ""],
		["房凤友", ""],
		["季允石", ""],
		["杨晶", ""],
		["王占", ""],
		["李金明", ""],
		["方兆祥", ""],
		["陈明义", ""],
		["钟起煌", ""],
		["韩寓群", ""],
		["范钦臣", ""],
		["杨正午", ""],
		["曹伯纯", ""],
		["汪啸风", ""],
		["黄镇东", ""],
		["张学忠", ""],
		["张中伟", ""],
		["曹其真", ""],
		["白志健", ""],
		["万永祥", ""],
		["刘粤军", ""],
		["杨忠民", ""],
		["艾力更", ""],
		["依明巴海", ""],
		["白克力", ""],
		["曹其真", ""],
		["曾钰成", ""],
		["崔世安", ""],
		["葛振峰", ""],
		["熊光楷", ""],
		["张黎", ""],
		["李玉", ""],
		["章沁生", ""],
		["李继耐", ""],
		["唐天标", ""],
		["孙忠同", ""],
		["刘振起", ""],
		["姜吉初", ""],
		["孙志强", ""],
		["苏书岩", ""],
		["王谦", ""],
		["孙大发", ""],
		["刘源", ""],
		["李安东", ""],
		["楚鸿彦", ""],
		["张诗明", ""],
		["朱发忠", ""],
		["张建启", ""],
		["迟万春", ""],
		["李栋恒", ""],
		["民怨", ""],
		["假钞", ""],
		["行房", ""],
		["摇头丸", ""],
		["酮体", ""],
		["胴体", ""],
		["抽奖", ""],
		["截访", ""],
		["黑监", ""],
		["黑牢", ""],
		["狱霸", ""],
		["艾未未", ""],
		["崔卫平", ""],
		["梁文道", ""],
		["龙应台", ""],
		["陈子明", ""],
		["萧瀚", ""],
		["秦晖", ""],
		["冉云飞", ""],
		["希特勒", ""],
		["自拍", ""],
		["套图", ""],
		["刘小波", ""],
		["H文", ""],
		["柳斌杰", ""],
		["苹果门", ""],
		["卧底门", ""],
		["提拔门", ""],
		["北影门", ""],
		["友妻", ""],
		["拉链门", ""],
		["封汤门", ""],
		["艳照", ""],
		["虐狗", ""],
		["虐猫", ""],
		["偷菜门", ""],
		["不雅照", ""],
		["东村门", ""],
		["网吧门", ""],
		["杂物门", ""],
		["长安门", ""],
		["酒瓶门", ""],
		["剑桥门", ""],
		["我的门", ""],
		["野战", ""],
		["明道门", ""],
		["校园门", ""],
		["一中门", ""],
		["麦当劳门", ""],
		["刘莎莎", ""],
		["排便门", ""],
		["街头门", ""],
		["吉野门", ""],
		["屁交", ""],
		["空姐", ""],
		["海运门", ""],
		["杨幂", ""],
		["制服", ""],
		["肛交", ""],
		["后入式", ""],
		["合体门", ""],
		["跳蚤门", ""],
		["私密", ""],
		["秘处", ""],
		["摸鸟", ""],
		["摸JJ", ""],
		["黄瓜门", ""],
		["秋千门", ""],
		["90门", ""],
		["80门", ""],
		["九零门", ""],
		["八零门", ""],
		["一本道", ""],
		["全套下载", ""],
		["合集", ""],
		["打包下载", ""],
		["门下载", ""],
		["东京热", ""],
		["王刚", ""],
		["廖晖", ""],
		["格列朗杰", ""],
		["阿不来提", ""],
		["阿不都热西提", ""],
		["张梅颖", ""],
		["张榕明", ""],
		["李金华", ""],
		["罗富和", ""],
		["陈宗兴", ""],
		["孙怀山", ""],
		["潘贵玉", ""],
		["陈抗甫", ""],
		["卞晋平", ""],
		["王胜洪", ""],
		["仝广成", ""],
		["陈喜庆", ""],
		["修福金", ""],
		["张宝文", ""],
		["刘晓峰", ""],
		["王钦敏", ""],
		["黄志贤", ""],
		["宋北杉", ""],
		["林智敏", ""],
		["一诚", ""],
		["叨述仁", ""],
		["万季飞", ""],
		["万学远", ""],
		["万鄂湘", ""],
		["马长庆", ""],
		["马志伟", ""],
		["王亚保", ""],
		["王光谦", ""],
		["王先琼", ""],
		["王众孚", ""],
		["王宇田", ""],
		["王林旭", ""],
		["王明明", ""],
		["王金祥", ""],
		["王钦敏", ""],
		["王健林", ""],
		["王梅祥", ""],
		["王新陆", ""],
		["王新奎", ""],
		["方兆本", ""],
		["艾努瓦尔", ""],
		["左焕琛", ""],
		["孔小均", ""],
		["厉以宁", ""],
		["石耀霖", ""],
		["卢志强", ""],
		["卢晓钟", ""],
		["叶小钢", ""],
		["田刚", ""],
		["田岚", ""],
		["田静", ""],
		["田震", ""],
		["田中群", ""],
		["田聪明", ""],
		["包俊臣", ""],
		["冯巩", ""],
		["冯明光", ""],
		["冯培恩", ""],
		["冯骥才", ""],
		["宁崇瑞", ""],
		["朱孝清", ""],
		["朱作言", ""],
		["朱祖良", ""],
		["朱维群", ""],
		["伍淑清", ""],
		["全哲洙", ""],
		["刘凡", ""],
		["刘长铭", ""],
		["刘古昌", ""],
		["刘汉元", ""],
		["刘汉铨", ""],
		["刘晓庄", ""],
		["刘光复", ""],
		["刘亦铭", ""],
		["刘志峰", ""],
		["刘迎龙", ""],
		["刘应明", ""],
		["刘泽彭", ""],
		["刘柏年", ""],
		["刘晓庄", ""],
		["刘峰岩", ""],
		["刘淑莹", ""],
		["刘新文", ""],
		["刘慕仁", ""],
		["齐让", ""],
		["许仕仁", ""],
		["许志功", ""],
		["许京君", ""],
		["孙淦", ""],
		["孙永福", ""],
		["孙怀山", ""],
		["孙晓郁", ""],
		["玉素甫", ""],
		["苏士澍", ""],
		["李冰", ""],
		["李宏", ""],
		["李明", ""],
		["李羚", ""],
		["李崴", ""],
		["李谠", ""],
		["李世济", ""],
		["李庆云", ""],
		["李君如", ""],
		["李卓彬", ""],
		["李昌鉴", ""],
		["李泽钜", ""],
		["李承淑", ""],
		["李铁林", ""],
		["李德洙", ""],
		["李德强", ""],
		["杨岐", ""],
		["杨健", ""],
		["杨孙西", ""],
		["杨春兴", ""],
		["杨俊文", ""],
		["杨健强", ""],
		["杨维刚", ""],
		["杨焱平", ""],
		["吴玉谦", ""],
		["吴正德", ""],
		["吴光正", ""],
		["吴祖强", ""],
		["吴嘉甫", ""],
		["吴蔚然", ""],
		["邱衍汉", ""],
		["何维", ""],
		["何丕洁", ""],
		["何光", ""],
		["何鸿燊", ""],
		["闵乃本", ""],
		["沈文庆", ""],
		["沈滨义", ""],
		["张平", ""],
		["张帆", ""],
		["张健", ""],
		["张海", ""],
		["张大方", ""],
		["张大宁", ""],
		["张文康", ""],
		["张龙之", ""],
		["张圣坤", ""],
		["张来斌", ""],
		["张泽熙", ""],
		["张宝文", ""],
		["张承芬", ""],
		["张俊九", ""],
		["张桃林", ""],
		["张海迪", ""],
		["张道宏", ""],
		["张福森", ""],
		["阿什老轨", ""],
		["陈君", ""],
		["陈杰", ""],
		["陈旗", ""],
		["陈广元", ""],
		["陈云林", ""],
		["陈永棋", ""],
		["陈传阔", ""],
		["陈自力", ""],
		["陈进玉", ""],
		["陈抗甫", ""],
		["陈佐洱", ""],
		["陈昊苏", ""],
		["陈明德", ""],
		["陈绍君", ""],
		["陈勋儒", ""],
		["陈凌孚", ""],
		["陈章良", ""],
		["陈清华", ""],
		["陈福今", ""],
		["邵鸿", ""],
		["武大伟", ""],
		["武四海", ""],
		["林而达", ""],
		["林兆枢", ""],
		["欧阳明高", ""],
		["欧阳淞", ""],
		["周文重", ""],
		["周汉民", ""],
		["周健民", ""],
		["周遇奇", ""],
		["郑小燕", ""],
		["郑兰荪", ""],
		["郑君里", ""],
		["郑建邦", ""],
		["郑祖康", ""],
		["郑家纯", ""],
		["郑惠强", ""],
		["郑楚平", ""],
		["郑楚光", ""],
		["学诚", ""],
		["赵龙", ""],
		["赵俊", ""],
		["赵化勇", ""],
		["赵启正", ""],
		["赵雨森", ""],
		["赵晓勇", ""],
		["钮小明", ""],
		["段成桂", ""],
		["修福金", ""],
		["俞海潮", ""],
		["洪祖杭", ""],
		["姚志彬", ""],
		["秦大河", ""],
		["土登克珠", ""],
		["袁汉民", ""],
		["袁祖亮", ""],
		["袁隆平", ""],
		["袁熙坤", ""],
		["夏涛", ""],
		["夏培度", ""],
		["顾秉林", ""],
		["柴松岳", ""],
		["钱克明", ""],
		["徐泽", ""],
		["徐辉", ""],
		["徐振寰", ""],
		["徐展堂", ""],
		["栾恩杰", ""],
		["高小玫", ""],
		["高中兴", ""],
		["高体健", ""],
		["高俊良", ""],
		["郭炳湘", ""],
		["陶建幸", ""],
		["多吉帕姆", ""],
		["德庆曲珍", ""],
		["黄代放", ""],
		["黄志贤", ""],
		["黄格胜", ""],
		["曹亚", ""],
		["曹毅", ""],
		["曹小红", ""],
		["龚世萍", ""],
		["龚惠兴", ""],
		["康耀红", ""],
		["章祥荪", ""],
		["梁金泉", ""],
		["梁振英", ""],
		["葛东升", ""],
		["葛剑平", ""],
		["葛剑雄", ""],
		["董恒宇", ""],
		["董新光", ""],
		["韩忠朝", ""],
		["韩美林", ""],
		["覃志刚", ""],
		["程世峨", ""],
		["程崇庆", ""],
		["傅先伟", ""],
		["傅惠民", ""],
		["靳尚谊", ""],
		["蒙进喜", ""],
		["赖明", ""],
		["雷蕾", ""],
		["蔡威", ""],
		["蔡达峰", ""],
		["廖泽云", ""],
		["黎桂康", ""],
		["德哇仓", ""],
		["滕文生", ""],
		["潘贵玉", ""],
		["霍达", ""],
		["磨长英", ""],
		["戴德丰", ""],
		["干以胜", ""],
		["张毅", ""],
		["黄树", ""],
		["贤生赋", ""],
		["王伟", ""],
		["令狐安", ""],
		["杜学芳", ""],
		["吴玉良", ""],
		["吴毓萍", ""],
		["邱学强", ""],
		["何勇", ""],
		["张毅", ""],
		["张纪南", ""],
		["屈万祥", ""],
		["黄树贤", ""],
		["王晨", ""],
		["王毅", ""],
		["王万宾", ""],
		["王旭东", ""],
		["王喜斌", ""],
		["吉炳轩", ""],
		["朱之鑫", ""],
		["刘京", ""],
		["刘冬冬", ""],
		["孙春兰", ""],
		["孙晓群", ""],
		["李长才", ""],
		["李长江", ""],
		["李世明", ""],
		["李学勇", ""],
		["李海峰", ""],
		["杨元元", ""],
		["杨衍银", ""],
		["肖捷", ""],
		["吴双战", ""],
		["张阳", ""],
		["张又侠", ""],
		["张玉台", ""],
		["房峰辉", ""],
		["黄晴宜", ""],
		["黄献中", ""],
		["符廷贵", ""],
		["董贵山", ""],
		["喻林祥", ""],
		["何在", ""],
		["童世平", ""],
		["焉荣竹", ""],
		["王学君", ""],
		["王建平", ""],
		["杜宇新", ""],
		["符跃兰", ""],
		["马飚", ""],
		["旦科", ""],
		["朱小丹", ""],
		["张连珍", ""],
		["林左鸣", ""],
		["罗正富", ""],
		["罗志君", ""],
		["郑立中", ""],
		["袁荣祥", ""],
		["申维辰", ""],
		["任亚平", ""],
		["刘慧", ""],
		["李希", ""],
		["李买富", ""],
		["杨刚", ""],
		["杨松", ""],
		["余远辉", ""],
		["余欣荣", ""],
		["张成寅", ""],
		["张裔炯", ""],
		["陈存根", ""],
		["陈敏尔", ""],
		["骆惠宁", ""],
		["黄康生", ""],
		["魏凤和", ""],
		["于革胜", ""],
		["艾虎生", ""],
		["刘学普", ""],
		["刘振来", ""],
		["孙金龙", ""],
		["苏士亮", ""],
		["李长印", ""],
		["岳福洪", ""],
		["金振吉", ""],
		["秦银河", ""],
		["徐一天", ""],
		["薛延忠", ""],
		["王现魁", ""],
		["巴音朝鲁", ""],
		["叶冬松", ""],
		["史莲喜", ""],
		["刘晓凯", ""],
		["张耕", ""],
		["张基尧", ""],
		["陈宝生", ""],
		["苗圩", ""],
		["赵爱明", ""],
		["咸辉", ""],
		["袁家君", ""],
		["息中朝", ""],
		["徐粉林", ""],
		["谌贻琴", ""],
		["王玉普", ""],
		["李金城", ""],
		["肖钢", ""],
		["肖亚庆", ""],
		["何立峰", ""],
		["张仕波", ""],
		["张晓刚", ""],
		["金壮龙", ""],
		["刘伟", ""],
		["陈润儿", ""],
		["鹿心社", ""],
		["谢和平", ""],
		["王儒林", ""],
		["李崇禧", ""],
		["杨利伟", ""],
		["杨焕宁", ""],
		["张轩", ""],
		["武吉海", ""],
		["项俊波", ""],
		["舒晓琴", ""],
		["詹文龙", ""],
		["潘云鹤", ""],
		["叨林荫", ""],
		["王荣", ""],
		["汤涛", ""],
		["李纪恒", ""],
		["宋爱荣", ""],
		["张杰", ""],
		["陈左宁", ""],
		["竺延风", ""],
		["骆琳", ""],
		["褚益民", ""],
		["蔡英挺", ""],
		["邢元敏", ""],
		["李鸿忠", ""],
		["陈川平", ""],
		["梅克保", ""],
		["曹清", ""],
		["焦焕成", ""],
		["雷春美", ""],
		["翟虎渠", ""],
		["丁一平", ""],
		["闵维方", ""],
		["郭树清", ""],
		["王侠", ""],
		["陈元", ""],
		["姜建清", ""],
		["董万才", ""],
		["王明方", ""],
		["沈素琍", ""],
		["张岱梨", ""],
		["乌兰", ""],
		["付志方", ""],
		["夏宝龙", ""],
		["王安顺", ""],
		["张瑞敏", ""],
		["赵勇", ""],
		["栗战书", ""],
		["车俊", ""],
		["王晓初", ""],
		["刘玉浦", ""],
		["王三运", ""],
		["殷一璀", ""],
		["楼继伟", ""],
		["刘振亚", ""],
		["贾廷安", ""],
		["兽首", ""],
		["兔首", ""],
		["鼠首", ""],
		["嘿咻", ""],
		["冤狱", ""],
		["黑狱", ""],
		["安定片", ""],
		["羟丁酸", ""],
		["巴特尔", ""],
		["斑蝥", ""],
		["诺龙", ""],
		["乙醚", ""],
		["胎盘", ""],
		["巴赫", ""],
		["多维", ""],
		["恩氟烷", ""],
		["三唑", ""],
		["烟碱", ""],
		["皮质类固醇", ""],
		["氟硝西泮", ""],
		["氧化汞", ""],
		["熊炎", ""],
		["流脑", ""],
		["六合", ""],
		["龙虎豹", ""],
		["龙虎斗", ""],
		["拉丹", ""],
		["缩阴", ""],
		["替考", ""],
		["定位器", ""],
		["硝酸甘油", ""],
		["硫酸", ""],
		["亚热", ""],
		["亚砷酸钾", ""],
		["亚硒酸", ""],
		["异氟烷", ""],
		["罂粟壳", ""],
		["涿州", ""],
		["欲望", ""],
		["上书", ""],
		["苏家屯", ""],
		["吴德", ""],
		["博白县", ""],
		["女女", ""],
		["民阵", ""],
		["霰弹", ""],
		["独夫", ""],
		["赌具", ""],
		["弹夹", ""],
		["待考", ""],
		["花花公子", ""],
		["悔过书", ""],
		["富婆", ""],
		["喊冤", ""],
		["金盾", ""],
		["民联", ""],
		["开锁", ""],
		["蒙汗", ""],
		["麻衣", ""],
		["蒲团", ""],
		["秦晋", ""],
		["手榴弹", ""],
		["思潮", ""],
		["申冤", ""],
		["圣战", ""],
		["同房", ""],
		["同居", ""],
		["台盟", ""],
		["天葬", ""],
		["万言书", ""],
		["文字狱", ""],
		["学联", ""],
		["吸储", ""],
		["小口径", ""],
		["学习班", ""],
		["氧化汞", ""],
		["押题", ""],
		["艳舞", ""],
		["征地", ""],
		["造反", ""],
		["人弹", ""],
		["春宫", ""],
		["肉壁", ""],
		["乱性", ""],
		["性侵", ""],
		["性虐", ""],
		["性奴", ""],
		["口暴", ""],
		["毒龙", ""],
		["性爱", ""],
		["性饥", ""],
		["性侵", ""],
		["于秦城", ""],
		["充气娃娃", ""],
		["女体", ""],
		["香艳", ""],
		["初夜", ""],
		["丁字裤", ""],
		["衣衫不整", ""],
		["性伙伴", ""],
		["性伴侣", ""],
		["性学", ""],
		["性息", ""],
		["性感", ""],
		["性教官", ""],
		["性福", ""],
		["性网", ""],
		["性爱", ""],
		["AMATEUR", "АMATEUR"],
		["变乱", ""],
		["症斧", ""],
		["霸英矛", ""],
		["影帝", ""],
		["美妇", ""],
		["美妻", ""],
		["欠干", ""],
		["搞女人", ""],
		["推特", ""],
		["推友", ""],
		["疫苗", ""],
		["补录", ""],
		["基金", ""],
		["不上课", ""],
		["包皮", ""],
		["滑精", ""],
		["补考", ""],
		["装13", ""],
		["3点", ""],
		["装十三", ""],
		["卧了个槽", ""],
		["卧槽", ""],
		["槽我", ""],
		["槽你", ""],
		["我槽", ""],
		["H图", ""],
		["假学历", ""],
		["土共", ""],
		["密聊", ""],
		["古鸽", ""],
		["网络长城", ""],
		["连岳", ""],
		["呙中校", ""],
		["安替", ""],
		["2030", "2о30"],
		["二零三零", ""],
		["素女", ""],
		["素人", ""],
		["伟哥", ""],
		["良心犯", ""],
		["声援", ""],
		["希望之声", ""],
		["GreatFireWall", "GreatFireωall"],
		["GreatWall", "Greatωall"],
		["敏感带", ""],
		["敏感处", ""],
		["敏感部位", ""],
		["fanhexie", "fаnhexie"],
		["整肃", ""],
		["色色", ""],
		["色咪咪", ""],
		["色眯眯", ""],
		["古月", ""],
		["金帛", ""],
		["温总", ""],
		["小胡", ""],
		["温总", ""],
		["98大寿", ""],
		["九八大寿", ""],
		["性趣", ""],
		["刀客", ""],
		["付款", ""],
		["办证", ""],
		["卖尸", ""],
		["化工厂", ""],
		["极权", ""],
		["产案", ""],
		["卖官", ""],
		["买官", ""],
		["高耀洁", ""],
		["张澜澜", ""],
		["chapterchapter", "сhаpterchapter"],
		["联合起来", ""],
		["团结起来", ""],
		["考前", ""],
		["性致", ""],
		["枪手", ""],
		["面子工程", ""],
		["贼民", ""],
		["反华", ""],
		["98年", ""],
		["地磅", ""],
		["排华", ""],
		["第三次世界大战", ""],
		["爆政", ""],
		["徐明", ""],
		["天府", ""],
		["代血浆", ""],
		["testosterone", "testosterоne"],
		["adrenaline", "adrena1ine"],
		["erythropoietin", "erythrоpоietin"],
		["促性腺激素", ""],
		["麻黄草", ""],
		["雄烯二醇", ""],
		["strychnine", "strychninē"],
		["androst", "andrоst"],
		["毒品", ""],
		["杜冷丁", ""],
		["mdma", "mdmā"],
		["海luo因", ""],
		["heroin", "herоin"],
		["diamorphine", "diamоrphine"],
		["阿芙蓉", ""],
		["cocain", "cоcain"],
		["凯他敏", ""],
		["冰毒", ""],
		["cannabis", "cānnabis"],
		["爱他死", ""],
		["benzodiazepines", "benzоdiazepines"],
		["安非他命", ""],
		["morphine", "mоrphine"],
		["迷药", ""],
		["迷幻药", ""],
		["迷魂药", ""],
		["乖乖粉", ""],
		["narcotic", "narcоtic"],
		["蓝猫圣教", ""],
		["蓝猫神圣教", ""],
		["空格去掉", ""],
		["反和谐", ""],
		["反河蟹", ""],
		["广告机", ""],
		["发贴机", ""],
		["function", "functiоn"],
		["windowopen", "windоwopen"],
		["windowclose", "windоwclose"],
		["竖排", ""],
		["竖文", ""],
		["帮忙点一下", ""],
		["帮忙点下", ""],
		["详情请进入", ""],
		["私人侦探", ""],
		["私家侦探", ""],
		["代理", ""],
		["针孔", ""],
		["盗摄", ""],
		["借腹生子", ""],
		["找个妈妈", ""],
		["找个爸爸", ""],
		["代孕", ""],
		["代生", ""],
		["款到发货", ""],
		["回复可见", ""],
		["婴儿汤", ""],
		["售肾", ""],
		["刻章", ""],
		["买小车", ""],
		["套牌", ""],
		["电脑传讯", ""],
		["高清在线", ""],
		["代孕", ""],
		["txt下载", ""],
		["个QB", ""],
		["送QB", ""],
		["横向切腹", ""],
		["四海帮", ""],
		["投注", ""],
		["钱庄", ""],
		["复兴党", ""],
		["杨树宽", ""],
		["喂奶门", ""],
		["摸nai门", ""],
		["摸奶门", ""],
		["Y佳", ""],
		["yang佳", ""],
		["杨佳", ""],
		["杀警", ""],
		["贺立旗", ""],
		["周正毅", ""],
		["PX项目", ""],
		["骂四川", ""],
		["家l福", ""],
		["家le福", ""],
		["加了服", ""],
		["家乐福", ""],
		["麦当劳被砸", ""],
		["豆腐渣", ""],
		["龙小霞", ""],
		["震其国土", ""],
		["yuce", "yūce"],
		["聂树斌", ""],
		["万里大造林", ""],
		["陈相贵", ""],
		["尹方明", ""],
		["李树菲", ""],
		["王奉友", ""],
		["惨奥", ""],
		["奥晕", ""],
		["凹晕", ""],
		["懊运", ""],
		["懊孕", ""],
		["奥孕", ""],
		["weng安", ""],
		["wengan", "wēngan"],
		["翁安", ""],
		["改卷", ""],
		["答an", ""],
		["da案", ""],
		["爆草", ""],
		["暴干", ""],
		["暴奸", ""],
		["爆乳", ""],
		["暴淫", ""],
		["被操", ""],
		["被插", ""],
		["逼奸", ""],
		["仓井空", ""],
		["插暴", ""],
		["操黑", ""],
		["操烂", ""],
		["肏你", ""],
		["厕奴", ""],
		["插比", ""],
		["插B", ""],
		["插逼", ""],
		["插你", ""],
		["插我", ""],
		["插阴", ""],
		["潮喷", ""],
		["艳情", ""],
		["扌由插", ""],
		["抽一插", ""],
		["盗撮", ""],
		["多人轮", ""],
		["群轮", ""],
		["放尿", ""],
		["肥逼", ""],
		["粉穴", ""],
		["干死", ""],
		["干穴", ""],
		["裹本", ""],
		["好嫩", ""],
		["黑逼", ""],
		["几吧", ""],
		["寂寞男", ""],
		["寂寞女", ""],
		["集体淫", ""],
		["奸情", ""],
		["金鳞岂", ""],
		["金麟岂", ""],
		["就去日", ""],
		["巨屌", ""],
		["菊门", ""],
		["巨奶", ""],
		["菊穴", ""],
		["口射", ""],
		["口淫", ""],
		["狼友", ""],
		["聊性", ""],
		["流淫", ""],
		["漏乳", ""],
		["露B", ""],
		["轮操", ""],
		["裸陪", ""],
		["美逼", ""],
		["美幼", ""],
		["迷奸", ""],
		["摸奶", ""],
		["摸胸", ""],
		["母奸", ""],
		["内射", ""],
		["嫩逼", ""],
		["嫩女", ""],
		["砲友", ""],
		["喷精", ""],
		["品香堂", ""],
		["前凸后翘", ""],
		["强jian", ""],
		["全裸", ""],
		["惹火身", ""],
		["日逼", ""],
		["日烂", ""],
		["肉逼", ""],
		["揉乳", ""],
		["乳爆", ""],
		["骚比", ""],
		["色逼", ""],
		["色界", ""],
		["色猫", ""],
		["色盟", ""],
		["色区", ""],
		["色B", ""],
		["少修正", ""],
		["射爽", ""],
		["射颜", ""],
		["无修正", ""],
		["释欲", ""],
		["兽欲", ""],
		["熟妇", ""],
		["熟母", ""],
		["死逼", ""],
		["丝诱", ""],
		["体奸", ""],
		["舔脚", ""],
		["文做", ""],
		["我就色", ""],
		["相奸", ""],
		["校鸡", ""],
		["小xue", ""],
		["写真", ""],
		["妖娆", ""],
		["性虎", ""],
		["性技巧", ""],
		["穴口", ""],
		["穴图", ""],
		["颜射", ""],
		["扬具", ""],
		["夜勤病栋", ""],
		["一夜欢", ""],
		["一ye情", ""],
		["淫虫", ""],
		["淫电影", ""],
		["淫河", ""],
		["淫海", ""],
		["淫教师", ""],
		["淫魔", ""],
		["淫妻", ""],
		["淫书", ""],
		["淫术", ""],
		["淫亵", ""],
		["淫样", ""],
		["淫照", ""],
		["幼交", ""],
		["欲仙欲", ""],
		["招鸡", ""],
		["招妓", ""],
		["抓胸", ""],
		["18禁", ""],
		["十八禁", ""],
		["99bb", "99ьь"],
		["a4u", "а4u"],
		["a4y", "а4y"],
		["adult", "adu1t"],
		["hardcore", "hardcоre"],
		["H动画", ""],
		["H动漫", ""],
		["incest", "inсest"],
		["porn", "pоrn"],
		["xiao77", "xiaо77"],
		["tokyohot", "tоkyohot"],
		["yin荡", ""],
		["titor", "titоr"],
		["逢8必灾", ""],
		["逢八必灾", ""],
		["逢9必乱", ""],
		["逢九必乱", ""],
		["朱瑟里诺", ""],
		["根达亚文明", ""],
		["诺查丹玛斯", ""],
		["马雅", ""],
		["推背", ""],
		["推bei", ""],
		["济世灵文", ""],
		["诸世纪", ""],
		["盘古", ""],
		["志洪李", ""],
		["李虹滞", ""],
		["轮法功", ""],
		["氵去车仑", ""],
		["发论工", ""],
		["法x功", ""],
		["法o功", ""],
		["法0功", ""],
		["法一轮一功", ""],
		["法lun", ""],
		["法LG", ""],
		["lungon", "lungоn"],
		["退dan", ""],
		["超越红墙", ""],
		["自fen", ""],
		["9pin", "9pīn"],
		["九pin", ""],
		["jiupin", "jiǔpíng"],
		["藏字石", ""],
		["自sha", ""],
		["zi杀", ""],
		["suicide", "sūicide"],
		["资金周转", ""],
		["崩盘", ""],
		["贷款", ""],
		["钦定", ""],
		["习近", ""],
		["平近习", ""],
		["习太子", ""],
		["习明泽", ""],
		["老习", ""],
		["温家", ""],
		["温加宝", ""],
		["温x", ""],
		["胡X", ""],
		["温jia宝", ""],
		["温宝宝", ""],
		["温加饱", ""],
		["温加保", ""],
		["张培莉", ""],
		["温云松", ""],
		["温JB", ""],
		["胡温", ""],
		["胡JT", ""],
		["胡boss", ""],
		["江boss", ""],
		["温boss", ""],
		["胡总", ""],
		["江总", ""],
		["胡王八", ""],
		["胡J涛", ""],
		["胡惊涛", ""],
		["胡景涛", ""],
		["胡紧掏", ""],
		["湖紧掏", ""],
		["胡派", ""],
		["温派", ""],
		["江派", ""],
		["刘永清", ""],
		["民泽江", ""],
		["沢民", ""],
		["浙民", ""],
		["择民", ""],
		["老J", ""],
		["老H", ""],
		["老W", ""],
		["戏子", ""],
		["绵恒", ""],
		["绵康", ""],
		["平小邓", ""],
		["择民", ""],
		["xiao平", ""],
		["邓XP", ""],
		["邓晓平", ""],
		["邓朴方", ""],
		["邓榕", ""],
		["邓质方", ""],
		["chairmanmao", "chairmanmaо"],
		["猫贼洞", ""],
		["毛ZD", ""],
		["毛ZX", ""],
		["Z东", ""],
		["ze东", ""],
		["毛太祖", ""],
		["毛相", ""],
		["朱容基", ""],
		["朱镕鸡", ""],
		["朱容鸡", ""],
		["朱云来", ""],
		["李pen", ""],
		["李月月鸟", ""],
		["李小鹏", ""],
		["李小琳", ""],
		["华国", ""],
		["国锋", ""],
		["国峰", ""],
		["锋同志", ""],
		["蔡赴朝", ""],
		["陈同海", ""],
		["傅锐", ""],
		["贺国强", ""],
		["胡春华", ""],
		["黄华华", ""],
		["黄兴国", ""],
		["李沛瑶", ""],
		["栗智", ""],
		["林炎志", ""],
		["刘志军", ""],
		["龙新民", ""],
		["罗箭", ""],
		["马恺", ""],
		["欧广源", ""],
		["沉跃跃", ""],
		["屠光绍", ""],
		["王洛林", ""],
		["王太华", ""],
		["王振华", ""],
		["无官正", ""],
		["奚国华", ""],
		["于幼军", ""],
		["曾宪梓", ""],
		["曾荫权", ""],
		["张定发", ""],
		["朱海仑", ""],
		["党产共", ""],
		["共贪党", ""],
		["阿共", ""],
		["共一产一党", ""],
		["产党共", ""],
		["公产党", ""],
		["工产党", ""],
		["共c党", ""],
		["共铲", ""],
		["共惨", ""],
		["供铲", ""],
		["共残", ""],
		["拱铲", ""],
		["中珙", ""],
		["中gon", ""],
		["GC党", ""],
		["贡挡", ""],
		["gong党", ""],
		["G产", ""],
		["狗产", ""],
		["恶党", ""],
		["邪党", ""],
		["土G", ""],
		["共狗", ""],
		["仇共", ""],
		["症腐", ""],
		["政腐", ""],
		["政付", ""],
		["政俯", ""],
		["政一府", ""],
		["政F", ""],
		["zhengfu", "zhèngfǔ"],
		["政zhi", ""],
		["国wu院", ""],
		["国务院", ""],
		["gong和", ""],
		["王八", ""],
		["性运动", ""],
		["国办发", ""],
		["中办发", ""],
		["亡党", ""],
		["特贡", ""],
		["特共", ""],
		["殃视", ""],
		["拆除", ""],
		["贵族", ""],
		["十7大", ""],
		["十8大", ""],
		["九学", ""],
		["17da", "17dа"],
		["18da", "18dа"],
		["9学", ""],
		["四风", ""],
		["4风", ""],
		["最淫", ""],
		["警匪", ""],
		["官匪", ""],
		["民贼", ""],
		["毒豺", ""],
		["一党", ""],
		["苏晓康", ""],
		["焦国标", ""],
		["万润南", ""],
		["高勤荣", ""],
		["王炳章", ""],
		["司马璐", ""],
		["林昭", ""],
		["别梦成灰", ""],
		["启蒙派", ""],
		["民一主", ""],
		["min主", ""],
		["民竹", ""],
		["民珠", ""],
		["民猪", ""],
		["democracy", "dеmocracy"],
		["da选", ""],
		["公头", ""],
		["08宪", ""],
		["零八宪", ""],
		["08XZ", "о8XZ"],
		["抿主", ""],
		["人木又", ""],
		["人quan", ""],
		["renquan", "rénquán"],
		["新民党", ""],
		["讨说法", ""],
		["shangfang", "shàngfǎng"],
		["静zuo", ""],
		["示wei", ""],
		["you行", ""],
		["油行", ""],
		["亢议", ""],
		["抵zhi", ""],
		["dizhi", "dǐzhì"],
		["boycott", "bоycott"],
		["血书", ""],
		["国耻", ""],
		["国丧", ""],
		["国伤", ""],
		["baoluan", "bàoluàn"],
		["流血", ""],
		["暴动", ""],
		["baodon", "bàodòn"],
		["灭共", ""],
		["霸工", ""],
		["罢考", ""],
		["罢餐", ""],
		["霸餐", ""],
		["罢参", ""],
		["罢饭", ""],
		["罢食", ""],
		["罢ke", ""],
		["霸课", ""],
		["ba课", ""],
		["罢学", ""],
		["罢运", ""],
		["jie严", ""],
		["戒yan", ""],
		["贰拾年", ""],
		["六河蟹四", ""],
		["六百度四", ""],
		["六和谐四", ""],
		["陆四", ""],
		["陆肆", ""],
		["5月35", ""],
		["产案", ""],
		["学chao", ""],
		["xuechao", "xuécháo"],
		["学百度潮", ""],
		["门安天", ""],
		["天按门", ""],
		["压大学生", ""],
		["高自联", ""],
		["北高联", ""],
		["维多利亚公园", ""],
		["bloodisonthesquare", "blоodisonthesquare"],
		["血洗", ""],
		["柴玲", ""],
		["沉彤", ""],
		["封从德", ""],
		["王超华", ""],
		["侯德健", ""],
		["阎明复", ""],
		["方励之", ""],
		["蒋捷连", ""],
		["蒋彦永", ""],
		["陈一咨", ""],
		["关闭所有论坛", ""],
		["汪兆钧", ""],
		["世界日报", ""],
		["东森", ""],
		["星岛", ""],
		["泰晤士", ""],
		["美国之音", ""],
		["主权", ""],
		["弓单", ""],
		["木仓", ""],
		["石肖", ""],
		["核蛋", ""],
		["步qian", ""],
		["bao炸", ""],
		["爆zha", ""],
		["baozha", "Вaоzha"],
		["zha药", ""],
		["zha弹", ""],
		["炸dan", ""],
		["炸yao", ""],
		["zhadan", "zhàdàn"],
		["zhayao", "zhàyào"],
		["hmtd", ""],
		["六氟化铀", ""],
		["兵力部署", ""],
		["军转", ""],
		["军事社", ""],
		["屠华", ""],
		["mayingjiu", "mǎyīngjiǔ"],
		["李天羽", ""],
		["苏贞昌", ""],
		["陈S扁", ""],
		["陈随便", ""],
		["A扁", ""],
		["台完", ""],
		["台wan", ""],
		["taiwan", "táiwan"],
		["台弯", ""],
		["台毒", ""],
		["台du", ""],
		["taidu", "táidú"],
		["光复", ""],
		["民进党", ""],
		["X民党", ""],
		["青天白日", ""],
		["duli", "dúlì"],
		["李愚蠢", ""],
		["进化不完全", ""],
		["震死", ""],
		["贱人", ""],
		["傻帽", ""],
		["煞逼", ""],
		["刹笔", ""],
		["傻比", ""],
		["婊子", ""],
		["我日", ""],
		["日你", ""],
		["我操", ""],
		["我草", ""],
		["卧艹", ""],
		["我艹", ""],
		["爆你菊", ""],
		["艹你", ""],
		["cao你", ""],
		["他妈", ""],
		["别他吗", ""],
		["操他", ""],
		["操你", ""],
		["操她", ""],
		["操我", ""],
		["娘西皮", ""],
		["狗操", ""],
		["狗草", ""],
		["狗日", ""],
		["狗娘", ""],
		["贱比", ""],
		["贱B", ""],
		["死光", ""],
		["不得好死", ""],
		["死绝", ""],
		["热比娅", ""],
		["伊力哈木", ""],
		["疆独", ""],
		["臧人", ""],
		["zang人", ""],
		["藏M", ""],
		["赖达", ""],
		["dalai", "dálài"],
		["哒赖", ""],
		["刺嘛", ""],
		["丹增嘉措", ""],
		["打砸", ""],
		["葬独", ""],
		["臧独", ""],
		["藏毒", ""],
		["藏du", ""],
		["zangdu", "zàngdú"],
		["支持ZD", ""],
		["藏青会", ""],
		["狮子旗", ""],
		["啦萨", ""],
		["啦沙", ""],
		["拉sa", ""],
		["la萨", ""],
		["X藏", ""],
		["西Z", ""],
		["希葬", ""],
		["希藏", ""],
		["硒藏", ""],
		["稀藏", ""],
		["西脏", ""],
		["西奘", ""],
		["西葬", ""],
		["西臧", ""],
		["安拉", ""],
		["回回", ""],
		["默罕默德", ""],
		["清zhen", ""],
		["qingzhen", "qingzhеn"],
		["满狗", ""],
		["鞑子", ""],
		["[杀|傻|吗|妈|贱]{1}[逼|B]{1}", ""],
		["贱货", ""],
		["溷蛋", ""],
		["诱奸", ""],
		["干死", ""],
		["泼妇", ""],
		["国进民退", ""],
		["我干", ""],
		["屌", "diǎo"],
		["凶杀", ""],
		["操蛋", ""],
		["神兽", ""],
		["矿难", ""],
		["郑培民", ""],
		["政变", ""],
		["王小丫", ""],
		["嫩B", ""],
		["沃尔凯西", ""],
		["沃尔开西", ""],
		["性吧", ""],
		["X网", ""],
		["阮柔安", ""],
		["刘芳菲", ""],
		["阳台门", ""],
		["天台门", ""],
		["跳蛋", ""],
		["校花", ""],
		["李苑苑", ""],
		["私拍", ""],
		["私照", ""],
		["邓丽欣", ""],
		["草榴", ""],
		["防民之口", ""],
		["王家岭", ""],
		["胡佳", ""],
		["鲍彤", ""],
		["热比亚", ""],
		["毒奶粉", ""],
		["好工作", ""],
		["生不起", ""],
		["读不起", ""],
		["住不起", ""],
		["娶不起", ""],
		["病不起", ""],
		["活不起", ""],
		["死不起", ""],
		["养不起", ""],
		["烈日炎炎心哇凉", ""],
		["黑医院", ""],
		["血屠", ""],
		["民警", ""],
		["胡政", ""],
		["温政", ""],
		["江政", ""],
		["胡氏", ""],
		["温氏", ""],
		["精佑", ""],
		["燕琼", ""],
		["华英", ""],
		["严晓玲", ""],
		["福建三网友", ""],
		["福建三网民", ""],
		["福州三网友", ""],
		["福州三网民", ""],
		["福州3网友", ""],
		["福州3网民", ""],
		["福建3网友", ""],
		["福建3网民", ""],
		["九局", ""],
		["长彭波", ""],
		["国新办", ""],
		["新闻局", ""],
		["网络局", ""],
		["18jin", "18jìn"],
		["1984BBS", "1984ВВS"],
		["裸照", ""],
		["伍皓", ""],
		["21年", ""],
		["二十一年", ""],
		["特价", ""],
		["粉笔狐", ""],
		["袁腾飞", ""],
		["毛左", ""],
		["交而不泄", ""],
		["先肾后心", ""],
		["9浅1深", ""],
		["九浅一深", ""],
		["BlowJob", "BlоwJob"],
		["姦淫", ""],
		["屄缝", ""],
		["师母", ""],
		["房中", ""],
		["慕男症", ""],
		["情欲结", ""],
		["上下其手", ""],
		["手淫", ""],
		["after-play", "after-рlay"],
		["afterplay", "afterрlay"],
		["爱抚", ""],
		["爱侣", ""],
		["爱女", ""],
		["爱慰", ""],
		["爱欲", ""],
		["安全期", ""],
		["按揉", ""],
		["按柔", ""],
		["按压", ""],
		["昂奋", ""],
		["傲然挺立", ""],
		["扒开", ""],
		["把玩", ""],
		["白带", ""],
		["白嫩", ""],
		["白浊", ""],
		["摆弄", ""],
		["扳开", ""],
		["半裸", ""],
		["半骚半软", ""],
		["半遮半露", ""],
		["膀胱", ""],
		["肿瘤", ""],
		["蚌唇", ""],
		["胞漏疮", ""],
		["包茎", ""],
		["保精", ""],
		["饱胀", ""],
		["抱坐", ""],
		["暴胀", ""],
		["爆射", ""],
		["逼里", ""],
		["逼迫", ""],
		["闭经", ""],
		["壁肉", ""],
		["臂部", ""],
		["变粗", ""],
		["变软", ""],
		["变硬", ""],
		["拨弄", ""],
		["不泄", ""],
		["不育", ""],
		["不孕", ""],
		["采精", ""],
		["采阴", ""],
		["操逼", ""],
		["操弄", ""],
		["操起", ""],
		["操死", ""],
		["操我", ""],
		["操穴", ""],
		["侧臀", ""],
		["插爆", ""],
		["插奶", ""],
		["插弄", ""],
		["插死", ""],
		["插送", ""],
		["插她", ""],
		["插穴", ""],
		["叉我", ""],
		["缠抱", ""],
		["缠绵", ""],
		["长驱直入", ""],
		["长腿", ""],
		["潮红", ""],
		["潮湿", ""],
		["撑涨", ""],
		["撑胀", ""],
		["耻部", ""],
		["耻毛", ""],
		["耻丘", ""],
		["赤裸", ""],
		["炽热", ""],
		["充血", ""],
		["冲插", ""],
		["抽擦", ""],
		["抽插", ""],
		["抽出", ""],
		["抽捣", ""],
		["抽弄", ""],
		["抽缩", ""],
		["初血", ""],
		["出水", ""],
		["出血", ""],
		["触淫", ""],
		["穿插", ""],
		["喘叫", ""],
		["床事", ""],
		["床戏", ""],
		["吹弹", ""],
		["吹萧", ""],
		["垂软", ""],
		["春洞", ""],
		["春情", ""],
		["春心", ""],
		["春药", ""],
		["下药", ""],
		["唇瓣", ""],
		["唇缝", ""],
		["唇间", ""],
		["唇片", ""],
		["唇肉", ""],
		["唇舌", ""],
		["纯熟", ""],
		["蠢蠢欲动", ""],
		["戳穴", ""],
		["丛毛", ""],
		["粗长", ""],
		["粗黑", ""],
		["粗红", ""],
		["粗鲁", ""],
		["粗硬", ""],
		["粗涨", ""],
		["粗壮", ""],
		["搓蹭", ""],
		["搓捏", ""],
		["搓弄", ""],
		["搓揉", ""],
		["搓柔", ""],
		["搓玩", ""],
		["搓着", ""],
		["打泡", ""],
		["打手枪", ""],
		["大奶", ""],
		["大肉", ""],
		["大乳", ""],
		["大腿", ""],
		["大泄", ""],
		["大穴", ""],
		["大爷", ""],
		["荡叫", ""],
		["荡声", ""],
		["档部", ""],
		["倒骑", ""],
		["登床", ""],
		["底裤", ""],
		["第二性征", ""],
		["性病", ""],
		["弟妇", ""],
		["颠鸾倒凤", ""],
		["叼住", ""],
		["调经", ""],
		["迭股", ""],
		["顶紧", ""],
		["顶进", ""],
		["顶弄", ""],
		["顶破", ""],
		["顶送", ""],
		["顶我", ""],
		["顶住", ""],
		["动欲", ""],
		["洞洞", ""],
		["洞开", ""],
		["洞穴", ""],
		["洞眼", ""],
		["抖颤", ""],
		["短粗", ""],
		["独生女", ""],
		["多毛", ""],
		["多肉", ""],
		["多睾", ""],
		["恶露", ""],
		["儿媳妇", ""],
		["耳垂", ""],
		["梅毒", ""],
		["耳磨鬓擦", ""],
		["发骚", ""],
		["发痒", ""],
		["发涨", ""],
		["翻搅", ""],
		["翻弄", ""],
		["房事", ""],
		["房室", ""],
		["放荡", ""],
		["肥美", ""],
		["肥奶", ""],
		["肥翘", ""],
		["肥乳", ""],
		["肥润", ""],
		["肥臀", ""],
		["肥穴", ""],
		["肥尻", ""],
		["粉颊", ""],
		["粉嫩", ""],
		["粉白", ""],
		["粉臂", ""],
		["粉额", ""],
		["粉汗微出", ""],
		["粉乳", ""],
		["粉腮", ""],
		["粉舌", ""],
		["粉头", ""],
		["粉腿", ""],
		["粉臀", ""],
		["粉腰", ""],
		["丰肥", ""],
		["丰隆", ""],
		["丰乳", ""],
		["丰臀", ""],
		["服囊肉膜", ""],
		["抚爱", ""],
		["抚捏", ""],
		["抚弄", ""],
		["抚揉", ""],
		["抚玩", ""],
		["抚慰", ""],
		["俯弄", ""],
		["腹股", ""],
		["附睾", ""],
		["妇方", ""],
		["干过炮", ""],
		["缸交", ""],
		["肛部", ""],
		["肛管", ""],
		["肛门", ""],
		["肛肉", ""],
		["肛柱", ""],
		["高挺", ""],
		["高凸", ""],
		["高胀", ""],
		["膏淋", ""],
		["根插", ""],
		["根毛", ""],
		["供精", ""],
		["宫口", ""],
		["宫内", ""],
		["宫腔", ""],
		["宫外孕", ""],
		["共浴", ""],
		["沟缝", ""],
		["狗交", ""],
		["狗爬", ""],
		["够骚", ""],
		["箍住", ""],
		["鼓胀", ""],
		["骨感", ""],
		["骨盆", ""],
		["股沟", ""],
		["刮宫", ""],
		["刮官", ""],
		["乖肉", ""],
		["观淫癖", ""],
		["无毛", ""],
		["石女", ""],
		["石男", ""],
		["光熘熘", ""],
		["光裸", ""],
		["光脱脱", ""],
		["龟腾", ""],
		["鬼交", ""],
		["跪骑", ""],
		["跪臀", ""],
		["跪姿", ""],
		["滚圆", ""],
		["含春", ""],
		["含弄", ""],
		["含乳", ""],
		["含吮", ""],
		["含咬", ""],
		["豪乳", ""],
		["好性", ""],
		["耗精伤气", ""],
		["呵痒", ""],
		["黑毛", ""],
		["狠插", ""],
		["狠干", ""],
		["红颊", ""],
		["红润", ""],
		["喉交", ""],
		["后入位", ""],
		["后庭花", ""],
		["后戏", ""],
		["花苞", ""],
		["花唇", ""],
		["花穴", ""],
		["滑抚", ""],
		["滑润", ""],
		["滑湿", ""],
		["滑爽", ""],
		["滑粘", ""],
		["欢爱", ""],
		["欢吟", ""],
		["缓进速出", ""],
		["秽疮", ""],
		["秽物", ""],
		["会阴", ""],
		["溷圆", ""],
		["活塞", ""],
		["火柱", ""],
		["鸡吧", ""],
		["鸡巴", ""],
		["鸡把", ""],
		["鸡奸", ""],
		["急抽", ""],
		["急喘", ""],
		["女阴", ""],
		["外阴", ""],
		["挤捏", ""],
		["尖挺", ""],
		["奸插", ""],
		["奸弄", ""],
		["奸虐", ""],
		["奸辱", ""],
		["奸尸", ""],
		["奸我", ""],
		["奸淫", ""],
		["将嘴套至", ""],
		["浆汁", ""],
		["椒乳", ""],
		["交欢", ""],
		["交颈", ""],
		["交配", ""],
		["交媾", ""],
		["骄躯", ""],
		["骄穴", ""],
		["娇喘", ""],
		["娇哼", ""],
		["娇呼", ""],
		["娇叫", ""],
		["娇媚", ""],
		["娇嫩", ""],
		["娇娘", ""],
		["娇躯", ""],
		["娇容", ""],
		["娇软", ""],
		["娇声", ""],
		["娇态", ""],
		["娇啼", ""],
		["娇吟", ""],
		["搅弄", ""],
		["洁阴", ""],
		["解衣", ""],
		["筋肉", ""],
		["津液", ""],
		["紧合", ""],
		["紧夹", ""],
		["紧小", ""],
		["紧咬", ""],
		["紧窄", ""],
		["浸润", ""],
		["浸湿", ""],
		["浸淫", ""],
		["尽根", ""],
		["茎底", ""],
		["茎头", ""],
		["精巢", ""],
		["精虫", ""],
		["精阜", ""],
		["精关失固", ""],
		["精浆", ""],
		["精满自溢", ""],
		["精门", ""],
		["精囊", ""],
		["精失固摄", ""],
		["精水", ""],
		["精细胞", ""],
		["经期", ""],
		["经痛", ""],
		["经血", ""],
		["痉挛", ""],
		["痉脔", ""],
		["菊孔", ""],
		["双腿", ""],
		["咀唇", ""],
		["巨棒", ""],
		["巨根", ""],
		["巨棍", ""],
		["巨炮", ""],
		["巨枪", ""],
		["巨乳", ""],
		["噘起", ""],
		["噘着", ""],
		["绝经", ""],
		["揩擦", ""],
		["射精", ""],
		["抠摸", ""],
		["抠弄", ""],
		["抠挖", ""],
		["口爆", ""],
		["扣弄", ""],
		["跨跪", ""],
		["跨骑", ""],
		["跨坐", ""],
		["胯股", ""],
		["狂操", ""],
		["狂插", ""],
		["狂抽", ""],
		["狂捣", ""],
		["狂泄", ""],
		["狂舐", ""],
		["来潮", ""],
		["来经", ""],
		["来搔抚", ""],
		["浪逼", ""],
		["浪喘", ""],
		["浪妇", ""],
		["浪哼", ""],
		["浪货", ""],
		["浪劲", ""],
		["浪媚", ""],
		["浪女", ""],
		["浪态", ""],
		["浪穴", ""],
		["浪样", ""],
		["浪吟", ""],
		["浪语", ""],
		["蕾苞", ""],
		["连干几炮", ""],
		["恋母", ""],
		["恋童", ""],
		["两情相悦", ""],
		["撩拨", ""],
		["撩开", ""],
		["撩乱", ""],
		["撩弄", ""],
		["淋病", ""],
		["凌乱", ""],
		["灵肉", ""],
		["春心荡漾", ""],
		["流溢", ""],
		["龙根", ""],
		["隆起", ""],
		["露阴", ""],
		["窥阴", ""],
		["令女人", ""],
		["令女性", ""],
		["卵巢", ""],
		["卵子", ""],
		["卵泡", ""],
		["乱抽", ""],
		["乱蹬", ""],
		["乱顶", ""],
		["乱摸", ""],
		["乱揉", ""],
		["乱淌", ""],
		["乱舔", ""],
		["轮暴", ""],
		["轮奸", ""],
		["裸背", ""],
		["裸露", ""],
		["裸女", ""],
		["裸躯", ""],
		["裸身", ""],
		["裸睡", ""],
		["裸体", ""],
		["裸臀", ""],
		["裸胸", ""],
		["裸着", ""],
		["肏干", ""],
		["肏人", ""],
		["肏死", ""],
		["肏我", ""],
		["冒水", ""],
		["美唇", ""],
		["美感", ""],
		["美脚", ""],
		["美伶", ""],
		["美目", ""],
		["美肉", ""],
		["美乳", ""],
		["美腿", ""],
		["美体", ""],
		["美臀", ""],
		["美香", ""],
		["美穴", ""],
		["妹夫", ""],
		["媚唇", ""],
		["媚功", ""],
		["媚力", ""],
		["媚娘", ""],
		["媚肉", ""],
		["媚术", ""],
		["媚态", ""],
		["媚笑", ""],
		["媚艳", ""],
		["媚液", ""],
		["闷哼", ""],
		["勐操", ""],
		["勐插", ""],
		["勐颤", ""],
		["勐冲", ""],
		["勐抽", ""],
		["勐喘", ""],
		["勐刺", ""],
		["勐干", ""],
		["勐搅", ""],
		["勐男", ""],
		["勐舔", ""],
		["勐挺", ""],
		["勐撞", ""],
		["梦交", ""],
		["梦失精", ""],
		["梦遗", ""],
		["迷情", ""],
		["秘贝", ""],
		["秘部", ""],
		["秘唇", ""],
		["秘缝", ""],
		["秘肉", ""],
		["秘穴", ""],
		["泌出", ""],
		["泌乳", ""],
		["蜜唇", ""],
		["蜜洞", ""],
		["蜜壶", ""],
		["蜜肉", ""],
		["蜜桃", ""],
		["蜜穴", ""],
		["蜜液", ""],
		["蜜意", ""],
		["蜜汁", ""],
		["密洞", ""],
		["密合", ""],
		["密窥", ""],
		["密穴", ""],
		["密汁", ""],
		["绵软", ""],
		["妙目", ""],
		["命根", ""],
		["摸到", ""],
		["摸抠", ""],
		["摸摸", ""],
		["摸捏", ""],
		["摸弄", ""],
		["摸揉", ""],
		["摸乳", ""],
		["摸他", ""],
		["摸玩", ""],
		["摸我", ""],
		["磨穴", ""],
		["奶房", ""],
		["奶尖", ""],
		["奶水", ""],
		["奶头", ""],
		["奶子", ""],
		["男根", ""],
		["男跪女后", ""],
		["男欢女爱", ""],
		["男茎", ""],
		["男精女血", ""],
		["男上式", ""],
		["内壁", ""],
		["嫩红", ""],
		["嫩肉", ""],
		["嫩乳", ""],
		["嫩舌", ""],
		["嫩爽", ""],
		["嫩腿", ""],
		["嫩臀", ""],
		["嫩娃", ""],
		["嫩穴", ""],
		["腻滑", ""],
		["娘亲", ""],
		["尿道", ""],
		["尿水", ""],
		["尿痛", ""],
		["尿味", ""],
		["尿血", ""],
		["尿液", ""],
		["尿意", ""],
		["尿浊", ""],
		["捏挤", ""],
		["捏揪", ""],
		["捏摸", ""],
		["捏弄", ""],
		["捏掐", ""],
		["捏揉", ""],
		["扭臀", ""],
		["扭腰", ""],
		["脓尿", ""],
		["浓精", ""],
		["浓热", ""],
		["浓浊", ""],
		["弄湿", ""],
		["弄穴", ""],
		["怒张", ""],
		["怒涨", ""],
		["怒胀", ""],
		["女畅男欢", ""],
		["女器", ""],
		["女前男后", ""],
		["的BB", ""],
		["逼逼", ""],
		["女上式", ""],
		["女上位", ""],
		["女童", ""],
		["女臀", ""],
		["女卧男立", ""],
		["女下位", ""],
		["女尻", ""],
		["虐待", ""],
		["排过精", ""],
		["排精", ""],
		["排卵", ""],
		["排射", ""],
		["排泄", ""],
		["抛浪", ""],
		["泡彦", ""],
		["泡浴", ""],
		["配偶", ""],
		["喷泄", ""],
		["盆腔", ""],
		["澎胀", ""],
		["膨大", ""],
		["膨涨", ""],
		["膨胀", ""],
		["疲软", ""],
		["屁道", ""],
		["屁门", ""],
		["屁穴", ""],
		["破处", ""],
		["破瓜", ""],
		["破身", ""],
		["破贞", ""],
		["奇痒", ""],
		["奇淫", ""],
		["骑乘位", ""],
		["乾妈", ""],
		["乾姊", ""],
		["前戏", ""],
		["潜欲", ""],
		["浅出浅入", ""],
		["浅入浅出", ""],
		["腔肉", ""],
		["强暴", ""],
		["强奸", ""],
		["强健", ""],
		["强精", ""],
		["巧春", ""],
		["翘起", ""],
		["翘臀", ""],
		["俏丽", ""],
		["俏脸", ""],
		["俏眼", ""],
		["亲哥", ""],
		["亲匿", ""],
		["亲亲", ""],
		["轻颤", ""],
		["轻喘", ""],
		["轻撩", ""],
		["轻舔", ""],
		["轻握", ""],
		["轻咬", ""],
		["轻盈", ""],
		["轻舐", ""],
		["情穴", ""],
		["情欲", ""],
		["取悦", ""],
		["求欢", ""],
		["去操", ""],
		["去吮", ""],
		["去舔", ""],
		["泉涌", ""],
		["全根", ""],
		["热浆", ""],
		["热辣辣", ""],
		["热淋", ""],
		["热穴", ""],
		["忍精", ""],
		["妊娠", ""],
		["乳头", ""],
		["揉抚", ""],
		["揉摸", ""],
		["揉磨", ""],
		["揉捏", ""],
		["揉弄", ""],
		["柔唇", ""],
		["柔滑", ""],
		["柔肌", ""],
		["柔毛", ""],
		["柔腻", ""],
		["肉棍", ""],
		["肉瓣", ""],
		["肉贝", ""],
		["肉帛", ""],
		["肉唇", ""],
		["肉袋", ""],
		["肉弹", ""],
		["肉道", ""],
		["肉豆", ""],
		["肉根", ""],
		["肉沟", ""],
		["肉冠", ""],
		["肉核", ""],
		["肉乎乎", ""],
		["肉壶", ""],
		["肉紧", ""],
		["肉具", ""],
		["肉孔", ""],
		["肉粒", ""],
		["肉门", ""],
		["肉膜", ""],
		["肉腔", ""],
		["肉丘", ""],
		["肉球", ""],
		["肉圈", ""],
		["肉身", ""],
		["肉臀", ""],
		["肉香", ""],
		["肉穴", ""],
		["肉眼", ""],
		["肉柱", ""],
		["肉襞", ""],
		["乳房", ""],
		["乳波臀浪", ""],
		["乳部", ""],
		["乳蒂", ""],
		["乳儿", ""],
		["乳峰", ""],
		["乳沟", ""],
		["乳核", ""],
		["乳尖", ""],
		["乳交", ""],
		["乳浪", ""],
		["乳蕾", ""],
		["乳糜尿", ""],
		["乳母", ""],
		["乳球", ""],
		["乳肉", ""],
		["乳首", ""],
		["乳水", ""],
		["乳腺", ""],
		["乳晕", ""],
		["乳渍", ""],
		["入浴", ""],
		["软毛", ""],
		["软绵", ""],
		["软肉", ""],
		["软瘫", ""],
		["润滑", ""],
		["弱入强出", ""],
		["搔弄", ""],
		["搔痒", ""],
		["骚B", ""],
		["骚逼", ""],
		["骚动", ""],
		["骚货", ""],
		["骚劲", ""],
		["骚浪", ""],
		["骚媚", ""],
		["骚女", ""],
		["骚情", ""],
		["骚热", ""],
		["骚声", ""],
		["骚水", ""],
		["骚味", ""],
		["骚穴", ""],
		["骚痒", ""],
		["骚淫", ""],
		["骚幽", ""],
		["骚状", ""],
		["色欲", ""],
		["杀精", ""],
		["伤精", ""],
		["上翘", ""],
		["上位", ""],
		["上下蠕动", ""],
		["上压下顶", ""],
		["射出", ""],
		["射到", ""],
		["射液", ""],
		["身无寸缕", ""],
		["深插", ""],
		["软玉温香", ""],
		["生母", ""],
		["生殖", ""],
		["失精", ""],
		["湿滑", ""],
		["湿热下注证", ""],
		["湿软", ""],
		["实臀", ""],
		["受精", ""],
		["受孕", ""],
		["兽奸", ""],
		["兽交", ""],
		["输精", ""],
		["叔母", ""],
		["叔嫂", ""],
		["双唇", ""],
		["双峰", ""],
		["双箽下", ""],
		["双胯", ""],
		["双奶", ""],
		["双乳", ""],
		["双臀", ""],
		["妹爽", ""],
		["姐爽", ""],
		["哥爽", ""],
		["弟爽", ""],
		["我爽", ""],
		["水多", ""],
		["吮了", ""],
		["吮奶", ""],
		["吮吻", ""],
		["吮吸", ""],
		["吮咬", ""],
		["吮舐", ""],
		["硕乳", ""],
		["私部", ""],
		["死精", ""],
		["酥到", ""],
		["酥淋", ""],
		["酥熔", ""],
		["酥乳", ""],
		["酥软", ""],
		["酥爽", ""],
		["酥酥", ""],
		["酥胸", ""],
		["酥痒", ""],
		["素燕", ""],
		["酸软", ""],
		["酸痒", ""],
		["锁精术", ""],
		["她的波", ""],
		["她的奶", ""],
		["她的下面", ""],
		["贪淫", ""],
		["堂哥", ""],
		["堂妹", ""],
		["堂嫂", ""],
		["套动", ""],
		["提枪", ""],
		["提睾", ""],
		["体壁", ""],
		["体毛", ""],
		["体味", ""],
		["体位", ""],
		["体香", ""],
		["体液", ""],
		["舔遍", ""],
		["舔触", ""],
		["舔到", ""],
		["舔动", ""],
		["舔及轻击", ""],
		["舔净", ""],
		["舔了", ""],
		["舔掠", ""],
		["舔摸", ""],
		["舔奶", ""],
		["舔弄", ""],
		["舔起", ""],
		["舔乾", ""],
		["舔去", ""],
		["舔拭", ""],
		["舔吮", ""],
		["舔他", ""],
		["舔吻", ""],
		["舔我", ""],
		["舔吸", ""],
		["舔穴", ""],
		["舔寻", ""],
		["舔咬", ""],
		["舔阴", ""],
		["舔着", ""],
		["舔舐", ""],
		["挑弄", ""],
		["铁硬", ""],
		["停经", ""],
		["性器", ""],
		["挺实", ""],
		["童男", ""],
		["捅进", ""],
		["白痴", ""],
		["痴汉", ""],
		["痴男", ""],
		["痴女", ""],
		["痴呆", ""],
		["呆子", ""],
		["傻子", ""],
		["傻瓜", ""],
		["傻帽", ""],
		["呆逼", ""],
		["草泥马", ""],
		["操你", ""],
		["你妈", ""],
		["你娘", ""],
		["你爷", ""],
		["你大爷", ""],
		["草你", ""],
		["草我", ""],
		["偷汉", ""],
		["偷窥", ""],
		["偷香", ""],
		["推揉", ""],
		["推送", ""],
		["腿儿", ""],
		["腿缝", ""],
		["腿根", ""],
		["腿间", ""],
		["褪下", ""],
		["吞精", ""],
		["拉屎", ""],
		["吃屎", ""],
		["妈逼", ""],
		["臀部", ""],
		["臀瓣", ""],
		["臀洞", ""],
		["臀缝", ""],
		["臀沟", ""],
		["臀股", ""],
		["臀尖", ""],
		["臀孔", ""],
		["臀丘", ""],
		["臀肉", ""],
		["臀腿", ""],
		["臀下", ""],
		["臀眼", ""],
		["臀后", ""],
		["脱光", ""],
		["脱裤", ""],
		["挖弄", ""],
		["瘙痒", ""],
		["好痒", ""],
		["痒死", ""],
		["六九", ""],
		["玩摸", ""],
		["流产", ""],
		["万艾可", ""],
		["旺盛", ""],
		["微隆", ""],
		["萎软", ""],
		["萎缩", ""],
		["吻遍", ""],
		["吻摸", ""],
		["吻向", ""],
		["握缩感", ""],
		["月经", ""],
		["五征五欲", ""],
		["舞奴", ""],
		["吸功", ""],
		["吸吭", ""],
		["吸弄", ""],
		["吸舔", ""],
		["吸吻", ""],
		["吸咬", ""],
		["吸啜", ""],
		["吸聒", ""],
		["细腰", ""],
		["下贱", ""],
		["下阴", ""],
		["先摸", ""],
		["先射", ""],
		["咸咸", ""],
		["衔住", ""],
		["香唇", ""],
		["香肌", ""],
		["香肩", ""],
		["香软", ""],
		["香腮", ""],
		["香臀", ""],
		["香涎", ""],
		["想操", ""],
		["想舔", ""],
		["消精亘", ""],
		["小逼", ""],
		["小便", ""],
		["小唇", ""],
		["小洞", ""],
		["小缝", ""],
		["小核", ""],
		["小鸸", ""],
		["小咀", ""],
		["小脸", ""],
		["小美", ""],
		["小屁眼", ""],
		["小巧玲珑", ""],
		["小乳", ""],
		["小舌", ""],
		["小腿", ""],
		["小雄", ""],
		["小穴", ""],
		["小腰", ""],
		["小姨", ""],
		["小嘴", ""],
		["挟紧双腿", ""],
		["泄出", ""],
		["泄精", ""],
		["泄了", ""],
		["泄射", ""],
		["泄身", ""],
		["泄欲", ""],
		["泻出", ""],
		["泻了", ""],
		["心痒", ""],
		["阳萎", ""],
		["行事", ""],
		["行淫", ""],
		["性欲", ""],
		["性奋", ""],
		["性黄金", ""],
		["性冷感", ""],
		["性冷淡", ""],
		["性力", ""],
		["性脉博", ""],
		["性脉搏", ""],
		["性器官", ""],
		["性生活", ""],
		["性事", ""],
		["性妄想症", ""],
		["性戏", ""],
		["性腺", ""],
		["性心理障碍", ""],
		["性信号", ""],
		["性行为", ""],
		["性招式", ""],
		["胸推", ""],
		["胸型", ""],
		["羞态", ""],
		["秀媚", ""],
		["秀挺", ""],
		["蓄精", ""],
		["宣淫", ""],
		["学姐", ""],
		["学妹", ""],
		["穴壁", ""],
		["穴唇", ""],
		["穴道", ""],
		["穴洞", ""],
		["穴缝", ""],
		["穴门", ""],
		["穴肉", ""],
		["穴水", ""],
		["穴心", ""],
		["穴裡", ""],
		["穴穴", ""],
		["穴眼", ""],
		["穴痒", ""],
		["雪颈", ""],
		["雪臀", ""],
		["血精", ""],
		["艳妇", ""],
		["艳丽", ""],
		["艳肉", ""],
		["艳臀", ""],
		["羊水", ""],
		["阳峰", ""],
		["阳根", ""],
		["阳茎", ""],
		["阳精", ""],
		["阳事渐衰", ""],
		["阳水", ""],
		["阳物", ""],
		["腰腹", ""],
		["腰际", ""],
		["腰臀", ""],
		["腰枝", ""],
		["腰肢", ""],
		["妖媚", ""],
		["妖艳", ""],
		["妖淫", ""],
		["咬扯", ""],
		["冶荡", ""],
		["腋尾", ""],
		["夜御数女", ""],
		["一泻千里", ""],
		["遗精", ""],
		["意淫", ""],
		["益精", ""],
		["溢精", ""],
		["溢乳", ""],
		["荫茎", ""],
		["殷红", ""],
		["阴口", ""],
		["阴壁", ""],
		["阴埠", ""],
		["好紧", ""],
		["阴洞", ""],
		["阴缝", ""],
		["阴垢", ""],
		["阴径", ""],
		["阴门", ""],
		["阴肉", ""],
		["阴水", ""],
		["阴庭", ""],
		["阴虚火", ""],
		["阴穴", ""],
		["阴液", ""],
		["淫荡", ""],
		["淫靡", ""],
		["淫液", ""],
		["淫棒", ""],
		["淫唇", ""],
		["淫洞", ""],
		["淫妇", ""],
		["淫哥", ""],
		["淫根", ""],
		["淫棍", ""],
		["淫果", ""],
		["淫合", ""],
		["淫花", ""],
		["淫秽", ""],
		["淫火", ""],
		["淫贱", ""],
		["淫溅", ""],
		["淫叫", ""],
		["淫津", ""],
		["淫精", ""],
		["淫具", ""],
		["淫浪", ""],
		["淫乱", ""],
		["淫毛", ""],
		["淫媚", ""],
		["淫糜", ""],
		["淫母", ""],
		["淫念", ""],
		["淫女", ""],
		["淫虐", ""],
		["淫腔", ""],
		["淫情", ""],
		["淫人", ""],
		["淫肉", ""],
		["淫乳", ""],
		["淫骚", ""],
		["淫色", ""],
		["淫舌", ""],
		["淫神", ""],
		["淫声", ""],
		["淫事", ""],
		["淫兽", ""],
		["淫水", ""],
		["淫态", ""],
		["淫汤", ""],
		["淫臀", ""],
		["淫娃", ""],
		["淫物", ""],
		["淫香", ""],
		["淫笑", ""],
		["淫邪", ""],
		["淫心", ""],
		["淫兴", ""],
		["淫性", ""],
		["淫嗅味", ""],
		["淫穴", ""],
		["淫血", ""],
		["淫言", ""],
		["淫艳", ""],
		["淫宴", ""],
		["淫痒", ""],
		["淫逸", ""],
		["淫友", ""],
		["淫语", ""],
		["淫欲", ""],
		["淫汁", ""],
		["淫挚", ""],
		["淫纵", ""],
		["淫嘴", ""],
		["淫狎", ""],
		["淫猥", ""],
		["樱唇", ""],
		["樱口", ""],
		["硬邦邦", ""],
		["硬梆梆", ""],
		["硬绑绑", ""],
		["硬茎", ""],
		["硬热", ""],
		["硬挺", ""],
		["硬物", ""],
		["硬下疳", ""],
		["硬涨", ""],
		["硬胀", ""],
		["拥吻", ""],
		["涌出", ""],
		["涌泉", ""],
		["涌入", ""],
		["涌向", ""],
		["勇勐", ""],
		["用力一顶", ""],
		["幽洞", ""],
		["幽户", ""],
		["优香", ""],
		["油黑", ""],
		["有舒有缓", ""],
		["右乳", ""],
		["右臀", ""],
		["左乳", ""],
		["左臀", ""],
		["又稠又粘", ""],
		["又粗又短", ""],
		["又肥又厚", ""],
		["又美又嫩", ""],
		["又细又嫩", ""],
		["又咬又舔又吸", ""],
		["又肿又大", ""],
		["幼嫩", ""],
		["鱼水", ""],
		["玉腿", ""],
		["玉棒", ""],
		["玉背", ""],
		["玉臂", ""],
		["玉齿", ""],
		["玉洞", ""],
		["玉房", ""],
		["玉峰", ""],
		["玉缝", ""],
		["玉肤", ""],
		["玉棍", ""],
		["玉户", ""],
		["玉肌", ""],
		["玉浆", ""],
		["玉脚", ""],
		["玉茎", ""],
		["玉颈", ""],
		["玉娟", ""],
		["玉面", ""],
		["玉娘", ""],
		["玉卿", ""],
		["玉乳", ""],
		["玉蕊", ""],
		["玉体", ""],
		["玉臀", ""],
		["玉穴", ""],
		["玉液", ""],
		["玉液般", ""],
		["玉指", ""],
		["玉柱", ""],
		["玉麈", ""],
		["愈插愈快", ""],
		["欲感", ""],
		["欲焰", ""],
		["浴室", ""],
		["圆粗", ""],
		["圆鼓鼓", ""],
		["圆滚", ""],
		["圆翘", ""],
		["圆臀", ""],
		["允吸", ""],
		["脏病", ""],
		["早泄", ""],
		["造爱", ""],
		["增粗", ""],
		["粘稠", ""],
		["粘乎乎", ""],
		["粘滑", ""],
		["粘膜", ""],
		["粘液", ""],
		["站立式", ""],
		["张合着", ""],
		["胀大", ""],
		["胀红", ""],
		["胀破", ""],
		["胀疼", ""],
		["胀硬", ""],
		["胀胀", ""],
		["直插", ""],
		["直肠", ""],
		["直挺挺", ""],
		["指技", ""],
		["稚嫩", ""],
		["治荡", ""],
		["肿涨", ""],
		["肿胀", ""],
		["朱唇", ""],
		["抓捏", ""],
		["抓弄", ""],
		["抓揉", ""],
		["抓住", ""],
		["专奸", ""],
		["壮神", ""],
		["神鞭", ""],
		["壮盛", ""],
		["子孙袋子", ""],
		["自淫", ""],
		["自渎", ""],
		["纵欲", ""],
		["尊具", ""],
		["左拥右抱", ""],
		["坐式", ""],
		["厮缠", ""],
		["厮磨", ""],
		["耷拉", ""],
		["撸着", ""],
		["攥住", ""],
		["啜吸", ""],
		["啜着", ""],
		["噙住", ""],
		["后穴", ""],
		["后洞", ""],
		["后进", ""],
		["狎弄", ""],
		["狎玩", ""],
		["猬亵", ""],
		["汩汩", ""],
		["涓涓", ""],
		["涔涔", ""],
		["溽湿", ""],
		["潺潺", ""],
		["濡湿", ""],
		["尻臀", ""],
		["姊弟", ""],
		["姊夫", ""],
		["妞媚", ""],
		["膣壁", ""],
		["膣口", ""],
		["膣肉", ""],
		["膣穴", ""],
		["黏滑", ""],
		["黏膜", ""],
		["黏腻", ""],
		["黏热", ""],
		["黏湿", ""],
		["黏液", ""],
		["癃闭", ""],
		["裆部", ""],
		["舐弄", ""],
		["舐去", ""],
		["舐吮", ""],
		["舐吻", ""],
		["舐着", ""],
		["酡红", ""],
		["稣胸", ""],
		["骶丛", ""],
		["髋部", ""],
		["麈柄", ""],
		["黝黑", ""],
		["邪教", ""],
		["弘法", ""],
		["三去", ""],
		["江X", ""],
		["4\\\.25", "⒋25"],
		["425", ""],
		["4\\\-25", ""],
		["4\\\·25", ""],
		["四·二五", ""],
		["专桉组", ""],
		["轮大", ""],
		["屠城", ""],
		["屠杀", ""],
		["Da4Lu4", "Da4Lu4"],
		["Fa\\\-\\\-Lun", "Fа\\\-\\\-Lun"],
		["Fa\\\-Lun", "Fа\\\-Lun"],
		["Fa\\\_Lun", "Fа\\\_Lun"],
		["MHWeekly", "ΜHWeekly"],
		["X书", ""],
		["禁书", ""],
		["禁闻", ""],
		["X闻", ""],
		["X法X轮X功", ""],
		["Zen1Shan2Ren3", "Zеn1Shan2Ren3"],
		["江氏", ""],
		["诉江", ""],
		["告江案", ""],
		["epochtpe", "еpochtpe"],
		["dafa", "dаfa"],
		["l法l轮l功", ""],
		["kang4议", ""],
		["kang议", ""],
		["xiu1炼", ""],
		["x党", ""],
		["太子党", ""],
		["惨党", ""],
		["yanling", "yаnling"],
		["江核心", ""],
		["辅导站", ""],
		["大狱", ""],
		["大穹", ""],
		["戴春华", ""],
		["戴春梅", ""],
		["戴东雪", ""],
		["戴冬雪", ""],
		["戴乐", ""],
		["戴向丽", ""],
		["戴志珍", ""],
		["丹麦学员", ""],
		["丹尼尔", ""],
		["党皮", ""],
		["党徒", ""],
		["德惠", ""],
		["暴动", ""],
		["暴乱", ""],
		["得度", ""],
		["得法", ""],
		["邓少松", ""],
		["邓淑娟", ""],
		["邓伟男", ""],
		["邓小兵", ""],
		["邓小平", ""],
		["邓雪", ""],
		["翟志彬", ""],
		["点化", ""],
		["电棒", ""],
		["电棍", ""],
		["电椅", ""],
		["丁刚子", ""],
		["丁关根", ""],
		["丁延", ""],
		["董步云", ""],
		["董红", ""],
		["董建华", ""],
		["董立", ""],
		["董林桂", ""],
		["董朋", ""],
		["董玉华", ""],
		["动兵", ""],
		["动功", ""],
		["斗法", ""],
		["毒根", ""],
		["毒刑", ""],
		["毒瘾", ""],
		["独修", ""],
		["杜国聪", ""],
		["杜淑珍", ""],
		["杜晓华", ""],
		["杜旭", ""],
		["杜撰", ""],
		["度化", ""],
		["段晶晶", ""],
		["段利", ""],
		["段秀平", ""],
		["下无生", ""],
		["敦请", ""],
		["新闻社", ""],
		["恶暴", ""],
		["恶警", ""],
		["恶医", ""],
		["恩人", ""],
		["发出强大正念", ""],
		["发出正念", ""],
		["发完正念", ""],
		["发正念", ""],
		["法\\\-轮\\\-功", "", ""],
		["法L2", ""],
		["法不正", ""],
		["法不公", ""],
		["法场", ""],
		["法成天地行", ""],
		["法教班", ""],
		["法炼人", ""],
		["真善忍", ""],
		["和平请", ""],
		["救度世人", ""],
		["于国于民", ""],
		["教功", ""],
		["良知", ""],
		["转化班", ""],
		["转化学习", ""],
		["转化看管", ""],
		["桩法", ""],
		["法能破一切", ""],
		["法身", ""],
		["法像", ""],
		["法医", ""],
		["法正人间", ""],
		["法正人心", ""],
		["珐轮功", ""],
		["翻桉", ""],
		["樊启帆", ""],
		["樊颜玉", ""],
		["反党", ""],
		["反华", ""],
		["范秀云", ""],
		["方光孝", ""],
		["方林", ""],
		["方显智", ""],
		["方舟", ""],
		["警察", ""],
		["袭警", ""],
		["匪警", ""],
		["焚书坑儒", ""],
		["封闭班", ""],
		["疯狗", ""],
		["冯克兰", ""],
		["冯平", ""],
		["冯英霞", ""],
		["冯子斌", ""],
		["奉公守法", ""],
		["符克妙", ""],
		["符彦飙", ""],
		["傅怡彬", ""],
		["付艳", ""],
		["改生日", ""],
		["盖世太保", ""],
		["高德勇", ""],
		["高凤芹", ""],
		["高桂云", ""],
		["高辉", ""],
		["高科被", ""],
		["高士", ""],
		["高淑兰", ""],
		["高淑英", ""],
		["高淑珍", ""],
		["高文智", ""],
		["高秀兰", ""],
		["高玉珍", ""],
		["高源", ""],
		["葛一夫", ""],
		["耿萃芳", ""],
		["工潮", ""],
		["工贼", ""],
		["功友", ""],
		["功柱", ""],
		["龚宝华", ""],
		["龚成喜", ""],
		["龚家湾", ""],
		["龚玉枝", ""],
		["公愤", ""],
		["公判", ""],
		["宫永银", ""],
		["愚民", ""],
		["残暴", ""],
		["暴政", ""],
		["条狗", ""],
		["反宇宙", ""],
		["反世界", ""],
		["反人类", ""],
		["政权", ""],
		["共党", ""],
		["共军", ""],
		["苟延残喘", ""],
		["狗官", ""],
		["古长琴", ""],
		["谷文启", ""],
		["固守", ""],
		["顾思颖", ""],
		["顾亚楼", ""],
		["怪罪", ""],
		["关龙梅", ""],
		["官场", ""],
		["官府", ""],
		["官官相护", ""],
		["冠立荣", ""],
		["冠冕堂皇", ""],
		["灌食", ""],
		["贯通两极法", ""],
		["光天化日", ""],
		["郭凤霞", ""],
		["郭汉波", ""],
		["郭红", ""],
		["郭敬霞", ""],
		["郭俊英", ""],
		["郭来祥", ""],
		["郭丽娟", ""],
		["郭敏", ""],
		["郭明", ""],
		["郭明霞", ""],
		["郭庆", ""],
		["郭淑艳", ""],
		["郭小红", ""],
		["国家机器", ""],
		["国劙", ""],
		["国殇", ""],
		["海外综合", ""],
		["害法", ""],
		["邯郸", ""],
		["韩X", ""],
		["韩桂莲", ""],
		["韩纪珍", ""],
		["韩明", ""],
		["韩萍", ""],
		["韩淑芬", ""],
		["韩伟", ""],
		["韩秀荣", ""],
		["韩旭", ""],
		["韩勇", ""],
		["韩玉霞", ""],
		["韩玉珠", ""],
		["含冤", ""],
		["汉奸", ""],
		["郝平", ""],
		["郝润娟", ""],
		["郝亚芬", ""],
		["浩劫", ""],
		["何X", ""],
		["何德勇", ""],
		["何红", ""],
		["何华", ""],
		["何静", ""],
		["何静芬", ""],
		["何来琴", ""],
		["何立芳", ""],
		["何敏", ""],
		["何少君", ""],
		["何淑荣", ""],
		["何唯青", ""],
		["何文", ""],
		["何小船", ""],
		["何行宗", ""],
		["何秀兰", ""],
		["何秀英", ""],
		["赫尔辛基", ""],
		["贺传法", ""],
		["贺师尊传法", ""],
		["贺真跃", ""],
		["贺志红", ""],
		["乱党", ""],
		["政匪", ""],
		["黑材料", ""],
		["横心消业修心", ""],
		["洪传", ""],
		["洪法", ""],
		["洪吟", ""],
		["红色恐怖", ""],
		["侯惠茹", ""],
		["侯娟娟", ""],
		["侯秀兰", ""],
		["侯秀平", ""],
		["厚颜无耻", ""],
		["候春黎", ""],
		["胡伯荣", ""],
		["胡凜", ""],
		["胡桂莲", ""],
		["胡贺祥", ""],
		["胔涛", ""],
		["胡平", ""],
		["胡胜莲", ""],
		["胡胜满", ""],
		["胡文海", ""],
		["胡秀荣", ""],
		["胡友良", ""],
		["胡作非为", ""],
		["华国锋", ""],
		["环球好评", ""],
		["全球好评", ""],
		["世界好评", ""],
		["唤醒", ""],
		["荒淫", ""],
		["黄根慧", ""],
		["黄桂秋", ""],
		["黄汉冲", ""],
		["黄汉冲被", ""],
		["黄淮", ""],
		["黄惠珍", ""],
		["黄杰", ""],
		["黄克被", ""],
		["黄敏", ""],
		["黄浅", ""],
		["黄琼蓉", ""],
		["黄泉", ""],
		["黄淑兰", ""],
		["黄素云", ""],
		["黄涛", ""],
		["黄文英", ""],
		["黄欣金", ""],
		["黄秀平", ""],
		["黄秀英", ""],
		["黄耀英", ""],
		["黄玉屏", ""],
		["黄玉珍", ""],
		["黄云", ""],
		["黄志成", ""],
		["黄志义", ""],
		["黄麟", ""],
		["谎报", ""],
		["回教", ""],
		["保证书", ""],
		["决裂书", ""],
		["惠玲", ""],
		["昏君", ""],
		["昏庸", ""],
		["溷浊", ""],
		["溷沌", ""],
		["饥荒", ""],
		["集权", ""],
		["集训队", ""],
		["集中营", ""],
		["纪烈武", ""],
		["佳木斯", ""],
		["家破人亡", ""],
		["加强海外斗争", ""],
		["贾桂兰", ""],
		["贾海梅", ""],
		["贾乃芝", ""],
		["贾斯伯", ""],
		["贾秀兰", ""],
		["贾永发", ""],
		["假恶暴", ""],
		["假经", ""],
		["假理", ""],
		["驾法船", ""],
		["监视居住", ""],
		["坚修", ""],
		["奸臣", ""],
		["奸污", ""],
		["检讨书", ""],
		["柬共屠杀", ""],
		["建政", ""],
		["姜滨", ""],
		["姜波", ""],
		["姜斗元", ""],
		["姜帆", ""],
		["姜凤英", ""],
		["姜广波", ""],
		["姜桂兰", ""],
		["姜桂伶", ""],
		["姜洪禄", ""],
		["姜洪禄被", ""],
		["姜杰", ""],
		["姜瑞刚", ""],
		["姜山", ""],
		["姜淑芬", ""],
		["姜淑华", ""],
		["姜涛", ""],
		["姜伟", ""],
		["姜锡琪", ""],
		["吴风英", ""],
		["姜秀芳", ""],
		["姜雅芬", ""],
		["姜义武", ""],
		["姜英顺", ""],
		["姜志", ""],
		["姜志刚", ""],
		["姜志清", ""],
		["江贼", ""],
		["江川县", ""],
		["江的", ""],
		["江集团", ""],
		["江家帮", ""],
		["江锦恒", ""],
		["江静", ""],
		["江李朱", ""],
		["江罗", ""],
		["江死穴", ""],
		["江拥军", ""],
		["江责民", ""],
		["江折民", ""],
		["蒋垂平", ""],
		["蒋德军", ""],
		["蒋红", ""],
		["焦点谎谈", ""],
		["教友", ""],
		["教育转化", ""],
		["强拆", ""],
		["拆房", ""],
		["戒毒", ""],
		["江湖骗", ""],
		["江湖大骗", ""],
		["金有明", ""],
		["江胡", ""],
		["京城血桉", ""],
		["景玉红", ""],
		["警界", ""],
		["静修", ""],
		["九江", ""],
		["九天班", ""],
		["决心书", ""],
		["绝裂书", ""],
		["军警", ""],
		["卡尔加里", ""],
		["开平", ""],
		["开枪", ""],
		["堪培拉", ""],
		["康妮", ""],
		["齐普卡", ""],
		["康州", ""],
		["考验面前见真性", ""],
		["苛政", ""],
		["恳请", ""],
		["孔德易", ""],
		["孔庆黄", ""],
		["孔宪华", ""],
		["控制信徒", ""],
		["寇立荣", ""],
		["酷吏", ""],
		["匡素娥", ""],
		["魁北克", ""],
		["魁首", ""],
		["拉托维亚", ""],
		["拉脱维亚", ""],
		["喇嘛教", ""],
		["轻舟网", ""],
		["兰宏宇", ""],
		["老虎凳", ""],
		["雷克雅未克", ""],
		["雷晓婷", ""],
		["黎丽", ""],
		["黎梅", ""],
		["李丙华", ""],
		["李炳华", ""],
		["李波", ""],
		["李昌", ""],
		["李昌新", ""],
		["李长军", ""],
		["李丹", ""],
		["李冬梅", ""],
		["李芳", ""],
		["李风珍", ""],
		["李凤兰", ""],
		["李凤梅", ""],
		["李凤芹", ""],
		["李凤霞", ""],
		["李凤云", ""],
		["李凤珍", ""],
		["李福贵", ""],
		["李桂芳", ""],
		["李桂凤", ""],
		["李桂红", ""],
		["李桂玲", ""],
		["李桂梅", ""],
		["李桂芹", ""],
		["李桂荣", ""],
		["李桂荣被", ""],
		["李桂霞", ""],
		["李桂英", ""],
		["李桂珍", ""],
		["李桂芝", ""],
		["李国栋", ""],
		["李国俊", ""],
		["李海", ""],
		["李洪波", ""],
		["李慧琪", ""],
		["李季", ""],
		["李继菊", ""],
		["李佳敏", ""],
		["李进宇", ""],
		["李晶", ""],
		["李京东", ""],
		["李景成", ""],
		["李静毅", ""],
		["李竟春", ""],
		["李君", ""],
		["李俊英", ""],
		["李兰", ""],
		["李兰英", ""],
		["李兰英被", ""],
		["李老师", ""],
		["李莉", ""],
		["李丽", ""],
		["李丽娟", ""],
		["李玲云", ""],
		["李梅", ""],
		["李敏敏", ""],
		["李佩菊", ""],
		["李其华", ""],
		["李强", ""],
		["李巧云", ""],
		["李勤", ""],
		["李庆荣", ""],
		["李秋兰", ""],
		["李秋芝", ""],
		["李瑞英", ""],
		["李润花", ""],
		["李世霞", ""],
		["李淑芳", ""],
		["李淑芬", ""],
		["李淑华", ""],
		["李淑娟", ""],
		["李淑兰", ""],
		["李淑梅", ""],
		["李淑荣", ""],
		["李淑香", ""],
		["李淑珍", ""],
		["李淑贞", ""],
		["李淑媛", ""],
		["李斯", ""],
		["李素云", ""],
		["李素珍", ""],
		["李卫东", ""],
		["李香兰", ""],
		["李向", ""],
		["李晓彬", ""],
		["李晓威", ""],
		["李晓霞", ""],
		["李小兵", ""],
		["李小妹", ""],
		["李心明", ""],
		["李修梅", ""],
		["李秀芬", ""],
		["李秀红", ""],
		["李秀华", ""],
		["李秀兰", ""],
		["李秀玲", ""],
		["李秀梅", ""],
		["李秀敏", ""],
		["李秀琴", ""],
		["李秀芹", ""],
		["李秀清", ""],
		["李秀荣", ""],
		["李秀云", ""],
		["李秀珍", ""],
		["李轩", ""],
		["李学荣", ""],
		["李迅", ""],
		["李艳华", ""],
		["李艳萍", ""],
		["李艳秋", ""],
		["李艳霞", ""],
		["李燕", ""],
		["李义", ""],
		["李义翔", ""],
		["李英", ""],
		["李婴", ""],
		["李影", ""],
		["李永胜", ""],
		["李有甫", ""],
		["李友林", ""],
		["李玉芬", ""],
		["李玉华", ""],
		["李玉玲被", ""],
		["李玉梅", ""],
		["李玉萍", ""],
		["李玉霞", ""],
		["李玉英", ""],
		["李月英", ""],
		["李泽涛", ""],
		["李真", ""],
		["李振英", ""],
		["李之捷", ""],
		["李志广", ""],
		["李忠民", ""],
		["李仲明", ""],
		["李仲文", ""],
		["李宗民", ""],
		["李怡", ""],
		["里斯本", ""],
		["利国利民", ""],
		["练法堂", ""],
		["梁国满", ""],
		["梁燕", ""],
		["梁玉杰", ""],
		["梁玉琳", ""],
		["廖常琼", ""],
		["廖桂芳", ""],
		["廖琴英", ""],
		["廖伟雄", ""],
		["廖晓英", ""],
		["林保华", ""],
		["林澄涛", ""],
		["林鸿飞", ""],
		["林鸣立", ""],
		["林潜修", ""],
		["林慎立", ""],
		["林晓旭", ""],
		["林心慧", ""],
		["林心融", ""],
		["林雄", ""],
		["林艳", ""],
		["林占", ""],
		["刘爱芳", ""],
		["吕际云", ""],
		["苏梅", ""],
		["刘爱华", ""],
		["刘爱娟", ""],
		["刘爱阳", ""],
		["刘宝", ""],
		["刘宝云", ""],
		["刘宝芝", ""],
		["刘必静", ""],
		["刘兵", ""],
		["刘博", ""],
		["刘博扬", ""],
		["刘长", ""],
		["刘长平", ""],
		["刘长英", ""],
		["刘超", ""],
		["刘成", ""],
		["刘成刚", ""],
		["刘成军", ""],
		["刘春华", ""],
		["刘春玲", ""],
		["刘春梅", ""],
		["刘春荣", ""],
		["刘春香", ""],
		["刘春阳", ""],
		["刘春英", ""],
		["刘翠花", ""],
		["刘翠兰", ""],
		["刘翠英", ""],
		["刘东慧", ""],
		["刘冬梅", ""],
		["刘锋", ""],
		["刘风梅", ""],
		["刘凤华", ""],
		["刘凤兰", ""],
		["刘凤林", ""],
		["刘凤梅", ""],
		["刘凤明", ""],
		["刘凤萍", ""],
		["刘凤芹", ""],
		["刘凤荣", ""],
		["刘凤舞", ""],
		["刘凤英", ""],
		["刘凤珍", ""],
		["刘凤芝", ""],
		["刘福斌", ""],
		["刘福玺", ""],
		["刘光秀", ""],
		["刘光英", ""],
		["刘桂春", ""],
		["刘桂芬", ""],
		["刘桂玲", ""],
		["刘桂敏", ""],
		["刘桂琴", ""],
		["刘桂荣", ""],
		["刘桂茹", ""],
		["刘桂香", ""],
		["刘桂英", ""],
		["刘桂云", ""],
		["刘桂芝", ""],
		["刘贵荣", ""],
		["刘国萍", ""],
		["刘汉香", ""],
		["刘禾美", ""],
		["刘红东", ""],
		["刘红英", ""],
		["刘华", ""],
		["刘焕金", ""],
		["刘焕青", ""],
		["刘辉", ""],
		["刘纪颖", ""],
		["刘佳平", ""],
		["刘家利", ""],
		["刘健被", ""],
		["刘建民", ""],
		["刘洁", ""],
		["刘金", ""],
		["刘劲松", ""],
		["刘晶", ""],
		["刘静航", ""],
		["刘靖", ""],
		["刘菊丽", ""],
		["刘娟", ""],
		["刘俊禄", ""],
		["刘俊英", ""],
		["刘兰香", ""],
		["刘丽", ""],
		["刘丽芬", ""],
		["刘丽丽", ""],
		["刘丽梅", ""],
		["刘丽伟", ""],
		["刘丽霞", ""],
		["刘丽影", ""],
		["刘梅", ""],
		["刘美荣", ""],
		["刘苗琴", ""],
		["刘明", ""],
		["刘明华", ""],
		["刘娜", ""],
		["刘宁", ""],
		["刘萍", ""],
		["刘青", ""],
		["刘清碧", ""],
		["刘清滔", ""],
		["刘庆", ""],
		["刘庆华", ""],
		["刘庆明", ""],
		["刘庆余", ""],
		["刘秋红", ""],
		["刘秋梅", ""],
		["刘秋生", ""],
		["刘荣秀", ""],
		["刘瑞", ""],
		["刘诗幼", ""],
		["刘士荣", ""],
		["刘仕文", ""],
		["刘淑芳", ""],
		["刘淑华", ""],
		["刘淑坤", ""],
		["刘淑梅", ""],
		["刘淑平", ""],
		["刘淑芹", ""],
		["刘淑清", ""],
		["刘淑荣", ""],
		["刘淑文", ""],
		["刘淑贤", ""],
		["刘淑香", ""],
		["刘淑艳", ""],
		["刘淑珍", ""],
		["刘淑贞", ""],
		["刘淑芝", ""],
		["刘书松", ""],
		["刘树勇", ""],
		["刘树元", ""],
		["刘思影", ""],
		["刘素华", ""],
		["刘素芹", ""],
		["刘素文", ""],
		["刘素英", ""],
		["刘素芝", ""],
		["刘涛", ""],
		["刘天素", ""],
		["刘铁栋", ""],
		["刘伟珊", ""],
		["刘武", ""],
		["刘锡珍", ""],
		["刘喜祥", ""],
		["刘香兰", ""],
		["刘向党", ""],
		["刘晓", ""],
		["晓波", ""],
		["刘晓玲", ""],
		["刘晓旭", ""],
		["刘晓燕", ""],
		["刘欣", ""],
		["刘新平", ""],
		["刘新宇", ""],
		["刘兴明", ""],
		["刘杏", ""],
		["刘绪国", ""],
		["刘宣", ""],
		["刘雪岩", ""],
		["刘雅琴", ""],
		["刘亚杰", ""],
		["刘艳", ""],
		["刘艳芬", ""],
		["刘艳凤", ""],
		["刘艳秋", ""],
		["刘艳荣", ""],
		["刘艳霞", ""],
		["刘燕", ""],
		["刘彦", ""],
		["刘阳", ""],
		["刘永国", ""],
		["刘永来", ""],
		["刘永旺", ""],
		["刘玉芳", ""],
		["刘玉风", ""],
		["刘玉凤", ""],
		["刘玉河", ""],
		["刘玉红", ""],
		["刘玉华", ""],
		["刘玉莲", ""],
		["刘玉芹", ""],
		["刘玉亭", ""],
		["刘玉霞", ""],
		["刘玉香", ""],
		["刘玉英", ""],
		["刘玉珍", ""],
		["刘玉芝", ""],
		["刘玉竹", ""],
		["刘越", ""],
		["刘云华", ""],
		["刘云秀", ""],
		["刘蕴", ""],
		["刘增良", ""],
		["刘哲", ""],
		["刘哲和张玉凤", ""],
		["刘振光", ""],
		["刘志芬", ""],
		["刘志兰", ""],
		["刘志敏", ""],
		["刘志强", ""],
		["刘子文", ""],
		["刘宗彤", ""],
		["刘葆荣", ""],
		["刘怡", ""],
		["刘妍", ""],
		["刘祚平", ""],
		["刘铮", ""],
		["流氓无产者", ""],
		["流亡", ""],
		["流泯", ""],
		["柳连义", ""],
		["六禁止", ""],
		["六一○", ""],
		["六一零", ""],
		["卢冬梅", ""],
		["卢海英", ""],
		["卢辉", ""],
		["卢巧珊", ""],
		["卢森堡", ""],
		["卢玉会", ""],
		["卢占芳", ""],
		["吕柏凤", ""],
		["朱柯明", ""],
		["吕朝辉", ""],
		["吕春凤", ""],
		["吕凤玲", ""],
		["吕建华", ""],
		["吕连贵", ""],
		["吕仁娟", ""],
		["吕淑秋", ""],
		["吕淑英", ""],
		["吕淑云", ""],
		["吕淑珍", ""],
		["吕文中", ""],
		["吕兴华", ""],
		["乱法", ""],
		["乱民", ""],
		["冤缘皆得善解", ""],
		["罗伯塔", ""],
		["罗英", ""],
		["罗织", ""],
		["麻木不仁", ""],
		["马蒂亚斯", ""],
		["马桂兰", ""],
		["马桂芝", ""],
		["马国超", ""],
		["马海林", ""],
		["马洪梅", ""],
		["马军", ""],
		["马峻", ""],
		["马列", ""],
		["根本之邪", ""],
		["马列主义", ""],
		["邪皮", ""],
		["马萨诸塞", ""],
		["马三家", ""],
		["教养院", ""],
		["马淑华", ""],
		["马素英", ""],
		["马希君", ""],
		["马永", ""],
		["马志欣", ""],
		["毛凤英", ""],
		["毛骨悚然", ""],
		["毛慧芷", ""],
		["毛家山", ""],
		["毛杰权", ""],
		["蒙冤", ""],
		["勐醒", ""],
		["孟凡丽", ""],
		["孟富春", ""],
		["孟丽君", ""],
		["孟敏", ""],
		["孟庆玲", ""],
		["孟庆涛", ""],
		["孟庆英", ""],
		["孟宪芳", ""],
		["孟宪荣", ""],
		["孟雪涛", ""],
		["孟勇", ""],
		["孟云", ""],
		["迷惑信徒", ""],
		["迷係说", ""],
		["弥勒", ""],
		["弥天大谎", ""],
		["弥天大罪", ""],
		["米文莲", ""],
		["密苏里州", ""],
		["密西根", ""],
		["密西根州", ""],
		["苗奇生", ""],
		["淼小", ""],
		["灭绝人性", ""],
		["民不聊生", ""],
		["民愤", ""],
		["民权", ""],
		["民脂民膏", ""],
		["明报", ""],
		["鸣冤", ""],
		["名利情", ""],
		["命桉", ""],
		["莫水金", ""],
		["男警", ""],
		["聂春玲", ""],
		["牛玉辉", ""],
		["学员供稿", ""],
		["弄权", ""],
		["女色", ""],
		["欧共体", ""],
		["潘军", ""],
		["潘开祥", ""],
		["潘兴福", ""],
		["潘宣华", ""],
		["潘宣芝", ""],
		["潘永书", ""],
		["叛国", ""],
		["彭功惠", ""],
		["彭亮", ""],
		["彭敏", ""],
		["彭攀月", ""],
		["彭唯圣", ""],
		["彭兴华", ""],
		["彭燕", ""],
		["批判稿", ""],
		["皮景辉", ""],
		["苹果日报", ""],
		["剖腹", ""],
		["欺上瞒下", ""],
		["齐发正念", ""],
		["齐金胜", ""],
		["乞灵", ""],
		["启明网", ""],
		["强改班", ""],
		["强奸民意", ""],
		["强权", ""],
		["强行灌食", ""],
		["强行火化", ""],
		["强行送往", ""],
		["强硬灌食", ""],
		["强制改变不了人心", ""],
		["强制洗脑", ""],
		["强制洗脑班", ""],
		["强制转化", ""],
		["强制转化班", ""],
		["乔石", ""],
		["窃国", ""],
		["亲共", ""],
		["秦凤珍", ""],
		["秦桂兰", ""],
		["秦淑兰", ""],
		["秦尉", ""],
		["轻舟网文", ""],
		["清官", ""],
		["请功", ""],
		["请命", ""],
		["请愿书", ""],
		["请愿遭警暴虐", ""],
		["洪传十", ""],
		["邱丽英", ""],
		["邱萍", ""],
		["邱智岩", ""],
		["曲洪梅", ""],
		["曲金霞", ""],
		["屈凤兰", ""],
		["权贵", ""],
		["劝善歌", ""],
		["劝世歌", ""],
		["群众斗群众", ""],
		["群众运动", ""],
		["人不治天治", ""],
		["人祸", ""],
		["人权恶棍", ""],
		["人权观察", ""],
		["人权流氓", ""],
		["人权日", ""],
		["人权周", ""],
		["人身自由", ""],
		["人治", ""],
		["任爱梅", ""],
		["任国华", ""],
		["任海飞等", ""],
		["任劳任怨", ""],
		["任孟军", ""],
		["任鹏武", ""],
		["任淑芬", ""],
		["任淑杰", ""],
		["任廷玲", ""],
		["任秀英", ""],
		["荣凤贤", ""],
		["溶于法中", ""],
		["如狼似虎", ""],
		["入党", ""],
		["软禁", ""],
		["三保", ""],
		["三不", ""],
		["三句话", ""],
		["三书", ""],
		["三条", ""],
		["商诗迎", ""],
		["商锡平", ""],
		["尚春光", ""],
		["邵小山", ""],
		["深圳命桉", ""],
		["神化自我", ""],
		["沉剑利", ""],
		["升天圆满", ""],
		["圣约翰", ""],
		["师父新经文", ""],
		["失望工程", ""],
		["十堰", ""],
		["石春莲", ""],
		["石丽春", ""],
		["石人", ""],
		["石伟", ""],
		["史金玲", ""],
		["史文博", ""],
		["世风日下", ""],
		["世界末日", ""],
		["誓愿", ""],
		["舒兰", ""],
		["舒敏", ""],
		["淑英", ""],
		["谁揭谁遭报", ""],
		["思想汇报", ""],
		["思想迫害", ""],
		["思想转化", ""],
		["司美娥", ""],
		["死于非命", ""],
		["四\\\.二五", ""],
		["四二五", ""],
		["四防", ""],
		["颂师恩", ""],
		["宋冰", ""],
		["宋春霞", ""],
		["宋翠玲", ""],
		["宋凤菊", ""],
		["宋桂美", ""],
		["宋国梁", ""],
		["宋丽杰", ""],
		["宋连英", ""],
		["宋亮", ""],
		["宋庆慧", ""],
		["宋淑端", ""],
		["宋淑芬", ""],
		["宋淑华", ""],
		["宋修云", ""],
		["宋秀兰", ""],
		["宋秀梅", ""],
		["宋秀珍", ""],
		["宋延昭", ""],
		["宋艳群", ""],
		["宋义", ""],
		["宋永毅", ""],
		["宋宇飞", ""],
		["宋玉芳", ""],
		["宋玉珍", ""],
		["宋宗兰", ""],
		["宋倩玲", ""],
		["苏刚", ""],
		["苏晶岩", ""],
		["苏静", ""],
		["苏菊珍", ""],
		["苏丽凤", ""],
		["苏莹", ""],
		["苏玉芝", ""],
		["肃清", ""],
		["随师", ""],
		["随心而化", ""],
		["孙波", ""],
		["孙长立", ""],
		["孙成荣", ""],
		["孙翠芳", ""],
		["孙道芳", ""],
		["孙方熙", ""],
		["孙凤杰", ""],
		["孙凤兰", ""],
		["孙凤龙", ""],
		["孙凤琴", ""],
		["孙刚", ""],
		["孙桂芳", ""],
		["孙桂兰", ""],
		["孙桂玲", ""],
		["孙桂琴", ""],
		["孙桂芹", ""],
		["孙桂英", ""],
		["孙桂珍", ""],
		["孙国华", ""],
		["孙洪", ""],
		["孙宏艳", ""],
		["孙辉", ""],
		["孙金平", ""],
		["孙静", ""],
		["孙丽华", ""],
		["孙丽君", ""],
		["孙丽娜", ""],
		["孙立绢", ""],
		["孙莲霞", ""],
		["孙连军", ""],
		["孙灵华", ""],
		["孙明", ""],
		["孙明霞", ""],
		["孙宁", ""],
		["孙胜华", ""],
		["孙世文", ""],
		["孙寿兰", ""],
		["孙淑娥", ""],
		["孙淑芬", ""],
		["孙淑华", ""],
		["孙淑兰", ""],
		["孙淑琴", ""],
		["孙淑芹", ""],
		["孙淑英", ""],
		["孙淑珍", ""],
		["孙淑芝", ""],
		["孙水华", ""],
		["孙素芬", ""],
		["孙提", ""],
		["孙提屁", ""],
		["孙香淑", ""],
		["孙秀兰", ""],
		["孙秀梅", ""],
		["孙秀芹", ""],
		["孙秀云", ""],
		["孙秀珍", ""],
		["孙秀芝", ""],
		["孙艳", ""],
		["孙燕", ""],
		["孙颖", ""],
		["孙宇霞", ""],
		["孙玉芬", ""],
		["孙玉环", ""],
		["孙玉莲", ""],
		["孙玉淑", ""],
		["孙玉霞", ""],
		["孙正凡", ""],
		["孙卓", ""],
		["太阳报", ""],
		["贪官", ""],
		["谭晓荣等", ""],
		["谭秀英", ""],
		["唐德良", ""],
		["唐红梅", ""],
		["唐健", ""],
		["唐丽娟", ""],
		["唐齐", ""],
		["唐山", ""],
		["唐素华", ""],
		["陶洪升", ""],
		["陶琳", ""],
		["讨伐", ""],
		["特权", ""],
		["特赦", ""],
		["天an", ""],
		["惨桉", ""],
		["焚人", ""],
		["枪杀", ""],
		["天怒人怨", ""],
		["天清体透乾坤正", ""],
		["天灾人祸", ""],
		["天诛地灭", ""],
		["田宝珍", ""],
		["田海涛", ""],
		["田纪云", ""],
		["田纳西州", ""],
		["田平", ""],
		["田香翠", ""],
		["田旭", ""],
		["传单", ""],
		["停炼", ""],
		["统治阶级", ""],
		["土匪", ""],
		["退党", ""],
		["倡议书", ""],
		["王爱华", ""],
		["王爱娟", ""],
		["王爱玲", ""],
		["王爱茹", ""],
		["王波", ""],
		["王博", ""],
		["王春", ""],
		["王春香", ""],
		["王春艳", ""],
		["王翠花", ""],
		["王翠荣", ""],
		["王村", ""],
		["王道", ""],
		["王德福", ""],
		["王殿侠", ""],
		["王东", ""],
		["王东丽", ""],
		["王法", ""],
		["王凤华", ""],
		["王凤兰", ""],
		["王凤琴", ""],
		["王凤云", ""],
		["王凤芝", ""],
		["王福", ""],
		["王改芝", ""],
		["王桂芬", ""],
		["王桂兰", ""],
		["王桂莲", ""],
		["王桂玲", ""],
		["王桂琴", ""],
		["王桂芹", ""],
		["王桂荣", ""],
		["王桂香", ""],
		["王桂欣", ""],
		["王桂英", ""],
		["王桂云", ""],
		["王海泉", ""],
		["王虹", ""],
		["王洪斌", ""],
		["王洪良", ""],
		["王洪林", ""],
		["王洪书", ""],
		["王洪霞", ""],
		["王洪艳", ""],
		["王洪印", ""],
		["王宏", ""],
		["王红", ""],
		["王红被", ""],
		["王红梅", ""],
		["王红艳", ""],
		["王后", ""],
		["王华君", ""],
		["王华君被", ""],
		["王化臣", ""],
		["王还", ""],
		["王慧芳", ""],
		["王惠兰", ""],
		["王会艳", ""],
		["王继财", ""],
		["王继军", ""],
		["王继文", ""],
		["王剑", ""],
		["王建春", ""],
		["王建光", ""],
		["王建辉", ""],
		["王杰", ""],
		["王金龙", ""],
		["王进", ""],
		["王进东", ""],
		["王靳威", ""],
		["王井方", ""],
		["王静", ""],
		["王娟", ""],
		["王娟芳", ""],
		["王可非", ""],
		["王坤", ""],
		["王兰英", ""],
		["王乐", ""],
		["王蕾", ""],
		["王磊被", ""],
		["王莉莉", ""],
		["王丽芳", ""],
		["王丽娟", ""],
		["王丽君", ""],
		["王丽丽", ""],
		["王丽梅", ""],
		["王丽平", ""],
		["王丽荣", ""],
		["王丽霞", ""],
		["王丽珠", ""],
		["王丽萱", ""],
		["王利", ""],
		["王立凡", ""],
		["王立平", ""],
		["王立霞", ""],
		["王立新", ""],
		["王立宇", ""],
		["王琳", ""],
		["王琳琳", ""],
		["王梅", ""],
		["王美玲", ""],
		["王美珍", ""],
		["王敏", ""],
		["王娜", ""],
		["王芹香", ""],
		["王清", ""],
		["王庆新", ""],
		["王秋霞", ""],
		["王权", ""],
		["王群", ""],
		["王仁成", ""],
		["王荣", ""],
		["王茹瑛", ""],
		["王瑞芬", ""],
		["王瑞兰", ""],
		["王瑞云", ""],
		["王胜瑞", ""],
		["王胜喜", ""],
		["王世学", ""],
		["王淑存", ""],
		["王淑芳", ""],
		["王淑华", ""],
		["王淑娟", ""],
		["王淑君", ""],
		["王淑兰", ""],
		["王淑芹", ""],
		["王淑声", ""],
		["王淑贤", ""],
		["王淑香", ""],
		["王淑艳", ""],
		["王淑英", ""],
		["王淑珍", ""],
		["王淑芝", ""],
		["王书珍", ""],
		["王帅", ""],
		["王爽", ""],
		["王素华", ""],
		["王素娟", ""],
		["王素兰", ""],
		["王素梅", ""],
		["王素芹", ""],
		["王素清", ""],
		["王素珍", ""],
		["王铁松", ""],
		["王文华", ""],
		["王文军", ""],
		["王文鹏", ""],
		["王文清", ""],
		["王香玲", ""],
		["王晓华", ""],
		["王晓英", ""],
		["王晓忠", ""],
		["王小平", ""],
		["王新", ""],
		["王新碧", ""],
		["王新彩", ""],
		["王新忠", ""],
		["王兴华", ""],
		["王兴田", ""],
		["王秀芬", ""],
		["王秀华", ""],
		["王秀娟", ""],
		["王秀兰", ""],
		["王秀莲", ""],
		["王秀玲", ""],
		["王秀明", ""],
		["王秀芹", ""],
		["王秀荣", ""],
		["王秀书", ""],
		["王秀艳", ""],
		["王秀英", ""],
		["王秀云", ""],
		["王秀芝", ""],
		["王旭", ""],
		["王旭志", ""],
		["王学力", ""],
		["王学亮", ""],
		["王学明", ""],
		["王雪冰", ""],
		["王雅芝", ""],
		["王燕玲", ""],
		["王艺红", ""],
		["王艺因", ""],
		["王英洲", ""],
		["王莹", ""],
		["王永东", ""],
		["王永东遭恶警", ""],
		["王永吉", ""],
		["王勇", ""],
		["王玉", ""],
		["王玉娥", ""],
		["王玉芳", ""],
		["王玉芬", ""],
		["王玉红", ""],
		["王玉华", ""],
		["王玉坤", ""],
		["王玉莲", ""],
		["王玉玲", ""],
		["王玉敏", ""],
		["王玉培和王", ""],
		["王玉琴", ""],
		["王玉芹", ""],
		["王玉荣", ""],
		["王玉茹", ""],
		["王玉霞", ""],
		["王玉英", ""],
		["王玉芝", ""],
		["王豫东", ""],
		["王粤", ""],
		["王悦", ""],
		["王云秀", ""],
		["王哲浩", ""],
		["王志", ""],
		["王志斌", ""],
		["王志杰", ""],
		["王志荣", ""],
		["王志文", ""],
		["王志英", ""],
		["王瑛", ""],
		["王韬", ""],
		["王轶丽", ""],
		["王筱丽被", ""],
		["王鑫长", ""],
		["亡国", ""],
		["威权", ""],
		["唯物论", ""],
		["为民请命", ""],
		["为人民服务", ""],
		["魏明", ""],
		["尉健行", ""],
		["文痞", ""],
		["文字材料", ""],
		["问讯", ""],
		["我党", ""],
		["沃伦", ""],
		["无神论", ""],
		["无产阶级", ""],
		["吴邦国", ""],
		["吴波", ""],
		["吴翠霞", ""],
		["吴丹", ""],
		["吴殿华", ""],
		["吴殿辉", ""],
		["吴凤", ""],
		["吴凤英", ""],
		["吴凤芝", ""],
		["吴官正", ""],
		["吴桂春", ""],
		["吴桂梅", ""],
		["吴桂英", ""],
		["吴桂芝", ""],
		["吴海友", ""],
		["吴洪波", ""],
		["吴红梅", ""],
		["吴华", ""],
		["吴吉文", ""],
		["吴稼祥", ""],
		["吴健", ""],
		["吴军庆", ""],
		["吴兰芳", ""],
		["吴丽娟", ""],
		["吴庆斌", ""],
		["吴淑芹", ""],
		["吴树宇", ""],
		["吴桐林", ""],
		["吴伟标", ""],
		["吴相", ""],
		["吴相文", ""],
		["吴晓华", ""],
		["吴秀光", ""],
		["吴秀萍", ""],
		["吴秀英", ""],
		["吴艳杰", ""],
		["吴艳茹", ""],
		["吴永根", ""],
		["吴玉清", ""],
		["武警", ""],
		["武军", ""],
		["席成明", ""],
		["夏爱香", ""],
		["夏桂芹", ""],
		["夏军", ""],
		["夏梅", ""],
		["夏品华", ""],
		["夏术才", ""],
		["学员提供", ""],
		["集体自杀", ""],
		["项进英", ""],
		["项利杰", ""],
		["肖新改", ""],
		["肖志君", ""],
		["邪、骗、煽、斗、抢、痞、间、灭、控", ""],
		["邪法", ""],
		["国教化揭评", ""],
		["谢桂珍", ""],
		["谢红", ""],
		["谢科峰", ""],
		["谢少东", ""],
		["辛辛那", ""],
		["新生网", ""],
		["信仰自由", ""],
		["邢桂玲", ""],
		["邢俊", ""],
		["凶桉", ""],
		["熊启祥", ""],
		["熊伟", ""],
		["修心断欲去执着", ""],
		["秀英", ""],
		["徐承本", ""],
		["徐广道", ""],
		["徐桂珍", ""],
		["徐慧", ""],
		["徐惠敏", ""],
		["徐菊华", ""],
		["徐梅香", ""],
		["徐乃文", ""],
		["徐向东", ""],
		["徐新明", ""],
		["徐新牧", ""],
		["徐秀华", ""],
		["徐秀芝", ""],
		["徐艳", ""],
		["徐增亮", ""],
		["徐芝莲", ""],
		["徐志伟", ""],
		["徐子傲", ""],
		["徐侃刚", ""],
		["许春芝", ""],
		["许春枝", ""],
		["许家逢", ""],
		["许丽华", ""],
		["许淑华", ""],
		["许文君", ""],
		["许月英", ""],
		["许张绮娴", ""],
		["玄成喜", ""],
		["薛俊", ""],
		["薛霞", ""],
		["学法", ""],
		["血债", ""],
		["阎锋", ""],
		["阎王", ""],
		["验尸", ""],
		["杨德志", ""],
		["杨峰", ""],
		["杨桂宝", ""],
		["杨桂英", ""],
		["杨桂云", ""],
		["杨桂珍", ""],
		["杨国枢", ""],
		["维园", ""],
		["杨海", ""],
		["杨虹", ""],
		["全集", ""],
		["杨家桥", ""],
		["杨金凤", ""],
		["杨军", ""],
		["杨命兰", ""],
		["杨巧玲", ""],
		["杨清芳", ""],
		["杨庆敏", ""],
		["杨荣", ""],
		["杨蕊", ""],
		["杨瑞玉", ""],
		["杨瑞玉被", ""],
		["杨尚昆", ""],
		["杨淑梅", ""],
		["杨淑琴", ""],
		["杨淑芹", ""],
		["杨淑荣", ""],
		["杨舜华", ""],
		["杨硕", ""],
		["杨素花", ""],
		["杨甜", ""],
		["杨伟东", ""],
		["杨伟华", ""],
		["杨文会", ""],
		["杨晓杰", ""],
		["杨小晶", ""],
		["杨秀春", ""],
		["杨秀华", ""],
		["杨秀莲", ""],
		["杨秀芹", ""],
		["杨秀玉", ""],
		["杨秀珍", ""],
		["杨学贵", ""],
		["杨亚杰", ""],
		["杨毅", ""],
		["杨永兰", ""],
		["杨玉峰", ""],
		["杨玉华", ""],
		["杨玉梅", ""],
		["杨玉芹", ""],
		["杨占久", ""],
		["杨志", ""],
		["阳光网", ""],
		["姚春艳", ""],
		["姚红", ""],
		["姚淑华", ""],
		["姚淑云", ""],
		["姚维钊", ""],
		["姚永樊", ""],
		["姚治文", ""],
		["耶和华", ""],
		["叶科", ""],
		["叶淑贞", ""],
		["叶水钦", ""],
		["叶秀凤", ""],
		["依兰", ""],
		["疑桉", ""],
		["H网", ""],
		["以权代法", ""],
		["以商养功", ""],
		["抑善扬恶", ""],
		["圆明", ""],
		["殷淑云", ""],
		["尹丽萍", ""],
		["尹淑兰", ""],
		["尹淑荣", ""],
		["尹晓春", ""],
		["尹学庆", ""],
		["尹玉珍", ""],
		["鹰犬", ""],
		["应城", ""],
		["雍艳梅", ""],
		["用正念清除", ""],
		["犹大", ""],
		["犹他", ""],
		["犹太教", ""],
		["游街", ""],
		["于春明", ""],
		["于翠莲", ""],
		["于丹江", ""],
		["于德荣", ""],
		["于凤珍", ""],
		["于桂兰", ""],
		["于桂荣", ""],
		["于桂英", ""],
		["于桂珍", ""],
		["于桂芝", ""],
		["于海霞", ""],
		["于红", ""],
		["于建梅", ""],
		["于丽波", ""],
		["于立波", ""],
		["于立新", ""],
		["于莲春", ""],
		["于萍", ""],
		["色女", ""],
		["于庆军", ""],
		["于淑芬", ""],
		["于淑华", ""],
		["于淑敏", ""],
		["于淑清", ""],
		["于淑云", ""],
		["于树江", ""],
		["于苏月", ""],
		["于素敏", ""],
		["于文江", ""],
		["于先娜", ""],
		["代办", ""],
		["japan", "jаpan"],
		["sweet", "swеet"],
		["于秀春", ""],
		["于秀芬", ""],
		["于秀兰", ""],
		["于秀玲", ""],
		["于秀云", ""],
		["于洋", ""],
		["于勇", ""],
		["于占春", ""],
		["于占江", ""],
		["于正高", ""],
		["于志昕", ""],
		["于溟", ""],
		["愚民政策", ""],
		["余碧兴", ""],
		["余烬", ""],
		["余智荣", ""],
		["俞碧清", ""],
		["宇宙之声", ""],
		["羽明", ""],
		["吁请", ""],
		["狱警", ""],
		["狱医", ""],
		["狱卒", ""],
		["冤桉", ""],
		["冤魂", ""],
		["袁峰", ""],
		["袁桂风", ""],
		["袁金峰", ""],
		["袁林", ""],
		["袁凌娃", ""],
		["袁文", ""],
		["袁野", ""],
		["袁薇", ""],
		["原忠宇", ""],
		["圆满升天", ""],
		["怨声载道", ""],
		["云鹤", ""],
		["云游", ""],
		["灾祸", ""],
		["再教育", ""],
		["在桉", ""],
		["在法上认识法", ""],
		["泽弘义", ""],
		["曾亮", ""],
		["找哥哥", ""],
		["曾令华", ""],
		["曾世华", ""],
		["曾宪梅", ""],
		["曾晓春", ""],
		["曾毅", ""],
		["詹炜", ""],
		["展金燕", ""],
		["章翠英", ""],
		["章家敦", ""],
		["张安梅", ""],
		["张宝华", ""],
		["张宝君", ""],
		["张冰惠", ""],
		["张川生", ""],
		["张春芳", ""],
		["张春梅", ""],
		["张春媚", ""],
		["张春香", ""],
		["张德意", ""],
		["张东", ""],
		["张娥", ""],
		["张尔平", ""],
		["张方良被谋杀", ""],
		["张凤杰", ""],
		["张凤云", ""],
		["张凤珍", ""],
		["张光清", ""],
		["张桂芬", ""],
		["张桂华", ""],
		["张桂兰", ""],
		["张桂琴", ""],
		["张桂荣", ""],
		["张桂霞", ""],
		["张桂英", ""],
		["张桂云", ""],
		["张国玲", ""],
		["张海斌", ""],
		["张海峰", ""],
		["张洪林", ""],
		["张怀军", ""],
		["张慧双", ""],
		["张惠芳", ""],
		["张佳", ""],
		["张家口", ""],
		["张建辉", ""],
		["张洁", ""],
		["张金玲", ""],
		["张锦", ""],
		["张锦华", ""],
		["张进", ""],
		["张劲", ""],
		["张景良", ""],
		["张久海", ""],
		["张俊云", ""],
		["张克福", ""],
		["张狂", ""],
		["张兰芳", ""],
		["张兰桂", ""],
		["张兰英", ""],
		["张磊", ""],
		["张丽芳", ""],
		["张丽娟", ""],
		["张丽君", ""],
		["张丽娜", ""],
		["张丽艳", ""],
		["张丽英", ""],
		["张立艳", ""],
		["张连宾", ""],
		["张亮", ""],
		["张琳蒂", ""],
		["张林", ""],
		["张林玉", ""],
		["张凌蒂", ""],
		["张令德", ""],
		["张梅", ""],
		["张美琳", ""],
		["张孟业", ""],
		["张敏于", ""],
		["张明华", ""],
		["张明玉", ""],
		["张萍华", ""],
		["张清溪", ""],
		["张庆国", ""],
		["张庆华", ""],
		["张庆梅", ""],
		["张荣芬", ""],
		["张瑞华", ""],
		["张瑞珍", ""],
		["张少慧", ""],
		["张声伟", ""],
		["张生范", ""],
		["张淑凤", ""],
		["张淑兰", ""],
		["张淑丽", ""],
		["张淑梅", ""],
		["张淑敏", ""],
		["张淑清", ""],
		["张淑贤", ""],
		["张淑香", ""],
		["张淑英", ""],
		["张淑芝", ""],
		["张书琴", ""],
		["张思远", ""],
		["张素芳", ""],
		["张素芳被", ""],
		["张素芹", ""],
		["张贴", ""],
		["张伟", ""],
		["张文峰", ""],
		["张文华", ""],
		["张文清", ""],
		["张霞", ""],
		["张晓春", ""],
		["张晓光", ""],
		["张晓玲", ""],
		["张晓明", ""],
		["张小杰", ""],
		["张兴国", ""],
		["张秀臣", ""],
		["张秀华", ""],
		["张秀兰", ""],
		["张秀梅", ""],
		["张秀敏", ""],
		["张秀芹", ""],
		["张秀霞", ""],
		["张秀艳", ""],
		["张秀芝", ""],
		["张选寿", ""],
		["张学玲", ""],
		["张雪", ""],
		["张雪蓉", ""],
		["张雪容", ""],
		["张雅芬", ""],
		["张亚杰", ""],
		["张亚丽", ""],
		["张亚琴", ""],
		["张延荣", ""],
		["张艳芳", ""],
		["张艳华", ""],
		["张艳平", ""],
		["张彦", ""],
		["张耀杰", ""],
		["张义楠", ""],
		["张英丽", ""],
		["张颖", ""],
		["张永红", ""],
		["张予", ""],
		["张宇", ""],
		["张宇伟", ""],
		["张玉芳", ""],
		["张玉凤", ""],
		["张玉华", ""],
		["张玉杰", ""],
		["张玉莲", ""],
		["张玉梅", ""],
		["张玉霞", ""],
		["张玉珍", ""],
		["张远明", ""],
		["张月明", ""],
		["张云", ""],
		["张云鹤", ""],
		["张云芝", ""],
		["张振华", ""],
		["张振琴", ""],
		["张正刚", ""],
		["张志", ""],
		["张志彬", ""],
		["张志捷", ""],
		["张菁", ""],
		["张璇", ""],
		["昭雪", ""],
		["昭彰", ""],
		["昭昭", ""],
		["赵波", ""],
		["赵传文", ""],
		["赵达功", ""],
		["赵东侠", ""],
		["赵福兰", ""],
		["赵刚", ""],
		["赵桂芳", ""],
		["赵桂凤", ""],
		["赵桂荣", ""],
		["赵桂芝", ""],
		["赵继红", ""],
		["赵建", ""],
		["赵乐琳", ""],
		["赵丽华", ""],
		["赵丽辉", ""],
		["赵立山", ""],
		["赵明被", ""],
		["赵明之友", ""],
		["赵秋梅", ""],
		["赵荣花", ""],
		["赵寿柱", ""],
		["赵淑琴", ""],
		["赵淑清", ""],
		["赵淑云", ""],
		["赵淑珍", ""],
		["赵欣", ""],
		["赵秀云", ""],
		["赵雪霞", ""],
		["赵雅云", ""],
		["赵岩", ""],
		["赵艳芳被", ""],
		["赵永芳", ""],
		["赵永利", ""],
		["赵玉安", ""],
		["赵玉芳", ""],
		["赵玉芬", ""],
		["赵玉功", ""],
		["赵玉琴", ""],
		["赵玉芹", ""],
		["赵玉霞", ""],
		["赵玉英", ""],
		["赵玉芝", ""],
		["赵云", ""],
		["赵忠", ""],
		["赵昕", ""],
		["遮羞布", ""],
		["宇宙历", ""],
		["珍相", ""],
		["真\\\-善\\\-忍", ""],
		["真\\\.善\\\.荵", ""],
		["震压", ""],
		["正见网", ""],
		["正念清除邪恶", ""],
		["正清集", ""],
		["正清网", ""],
		["正善", ""],
		["正悟", ""],
		["正邪不分谤天法", ""],
		["正一切不正的", ""],
		["政匪一家", ""],
		["政府", ""],
		["郑东辉", ""],
		["郑凤英", ""],
		["郑萍", ""],
		["郑伟东", ""],
		["郑宇燕", ""],
		["知识界", ""],
		["执法犯法", ""],
		["执着心去真无为", ""],
		["只许州官放火", ""],
		["智慧网", ""],
		["镇反", ""],
		["党魁", ""],
		["恶戏", ""],
		["群体灭绝", ""],
		["毁民", ""],
		["假人道", ""],
		["迷惑世人", ""],
		["骚乱", ""],
		["权力之争", ""],
		["即将崩溃", ""],
		["中宣部", ""],
		["中原半壁覆沙尘", ""],
		["中组部", ""],
		["肿共", ""],
		["周成渝", ""],
		["周恩来", ""],
		["周凤林", ""],
		["周甫秀", ""],
		["周刚", ""],
		["周洪波", ""],
		["周红英", ""],
		["周劲松", ""],
		["周君", ""],
		["周丽", ""],
		["周力", ""],
		["周美凤", ""],
		["周巧愚", ""],
		["周蓉", ""],
		["周润君", ""],
		["陈艳梅", ""],
		["周身", ""],
		["周淑兰", ""],
		["周淑琴", ""],
		["周淑珍", ""],
		["周文普", ""],
		["周晓军", ""],
		["周秀芹", ""],
		["周亚静", ""],
		["周艳波", ""],
		["周英", ""],
		["周永红", ""],
		["周永年", ""],
		["周玉芳", ""],
		["周玉琴", ""],
		["周玉艳", ""],
		["周玉珍", ""],
		["周泽霖", ""],
		["周志昌", ""],
		["周祖清", ""],
		["周作明", ""],
		["株连", ""],
		["朱澄琳", ""],
		["朱纯荣", ""],
		["朱德", ""],
		["朱桂兰", ""],
		["朱洪瑛", ""],
		["朱红", ""],
		["朱均秀", ""],
		["朱琳", ""],
		["朱婉琪", ""],
		["朱宣武", ""],
		["朱艳华", ""],
		["朱颖", ""],
		["朱总理", ""],
		["朱颍", ""],
		["主佛", ""],
		["主谋", ""],
		["主使", ""],
		["主意识要强", ""],
		["主宰", ""],
		["主尊", ""],
		["助师正法", ""],
		["专权", ""],
		["专政", ""],
		["转X法X轮X", ""],
		["乾坤正", ""],
		["庄光新", ""],
		["庄偃红", ""],
		["庄铿", ""],
		["追悼", ""],
		["浊世", ""],
		["伪桉", ""],
		["邹桂荣", ""],
		["邹家华", ""],
		["佟贵洁", ""],
		["佟力军", ""],
		["冼锦华", ""],
		["邬学娣", ""],
		["芮晓林", ""],
		["茳泽民", ""],
		["囹圄", ""],
		["猡gan", ""],
		["闫宝双", ""],
		["闫修忠", ""],
		["楠木", ""],
		["祛病", ""],
		["恣意", ""],
		["羁押", ""],
		["铐吊", ""],
		["鸠集", ""],
		["覃永洁", ""],
		["鑫诺卫星", ""],
		["黛晓静", ""],
		["XJP", "ΧJP"],
		["JZM", "JΖM"],
		["WJB", "WJΒ"],
		["HJT", "НJT"],
		["FLG", "℉LG"],
		["J8", "亅8"],
		["三个代表", ""],
		["金正日", ""],
		["金日成", ""],
		["金胖子", ""],
		["哀悼日", ""],
		["赌马", ""],
		["华通时事", ""],
		["华夏文摘", ""],
		["华语世界论坛", ""],
		["华岳时事", ""],
		["僵贼", ""],
		["看中国", ""],
		["毛厕洞", ""],
		["贼东", ""],
		["美国参考", ""],
		["退谠", ""],
		["脱谠", ""],
		["死亡笔记", ""],
		["死亡日志", ""],
		["死亡日记", ""],
		["秀女", ""],
		["A级", ""],
		["HKZO线上讨论", ""],
		["KT\\\-ZONE", "KT\\\-ZОNE"],
		["P2P\\\-zone", "P2P\\\-zоne"],
		["PPXX", "PPХX"],
		["cc438", "cс438"],
		["koog", "koоg"],
		["laiwanwan", "lаiwanwan"],
		["爱性BT", ""],
		["爱性区", ""],
		["翱游天堂", ""],
		["被逼", ""],
		["被虐", ""],
		["藏春阁", ""],
		["插他", ""],
		["大汉遗风", ""],
		["弟疼", ""],
		["弟痛", ""],
		["色电影", ""],
		["红河谷信息", ""],
		["花花女人图区", ""],
		["华人娱乐", ""],
		["欢欢文苑文学", ""],
		["欢乐白领", ""],
		["欢喜佛", ""],
		["姐疼", ""],
		["姐痛", ""],
		["金金世界", ""],
		["九州人", ""],
		["清纯美眉", ""],
		["快活林", ""],
		["狼桥伊梦", ""],
		["老玉米", ""],
		["恋之谷", ""],
		["龙门客栈文学", ""],
		["露毛", ""],
		["鹿城贴图区", ""],
		["抡功", ""],
		["裸聊", ""],
		["妹妹BT", ""],
		["欧龙", ""],
		["喷尿", ""],
		["品色堂", ""],
		["强歼", ""],
		["万盟", ""],
		["群射", ""],
		["色窝", ""],
		["色家大杂烩", ""],
		["色友", ""],
		["圣记", ""],
		["天堂部落", ""],
		["黄站", ""],
		["图霸天下", ""],
		["我拍我妹妹", ""],
		["无名小站", ""],
		["无忧春", ""],
		["惜玉怜香", ""],
		["心动时刻", ""],
		["新人类BT", ""],
		["幸福郁守", ""],
		["性经验", ""],
		["性经历", ""],
		["性闻", ""],
		["秀色", ""],
		["正宗XX", ""],
		["中国堂", ""],
		["黄网", ""],
		["紫陵阁", ""],
		["紫色年代", ""],
		["自摸", ""],
		["走光", ""],
		["坐交", ""],
		["逍遥龙潭", ""],
		["嫖客", ""],
		["妹疼", ""],
		["妹痛", ""],
		["万能钥匙", ""],
		["牝户", ""],
		["BJ", "ВJ"],
		["BlowJob", "ВlowJob"],
		["KJ", "КJ"],
		["牛皮癣", ""],
		["螳臂当车", ""],
		["潭作人", ""],
		["八平方", ""],
		["华尔街日报", ""],
		["反中", ""],
		["国耻", ""],
		["贼洞", ""],
		["peace", ""],
		["上街", ""],
		["螳臂挡车", ""],
		["装逼", ""],
		["储安平", ""],
		["妈的", ""],
		["地沟油", ""],
		["空凳", ""],
		["空椅", ""],
		["金正恩", ""],
		["金正云", ""],
		["食品安全", ""],
		["王显政", ""],
		["王瑞祥", ""],
		["朱树豪", ""],
		["步正发", ""],
		["王国强", ""],
		["王炳华", ""],
		["王富卿", ""],
		["王富卿", ""],
		["田淑兰", ""],
		["冯远", ""],
		["宁远", ""],
		["吕章申", ""],
		["任洪斌", ""],
		["刘元龙", ""],
		["刘环祥", ""],
		["刘逢君", ""],
		["江小涓", ""],
		["孙晓华", ""],
		["纪斌", ""],
		["苏立清", ""],
		["李武", ""],
		["李成贵", ""],
		["李秀恒", ""],
		["杨文良", ""],
		["杨国庆", ""],
		["吴先宁", ""],
		["宋南平", ""],
		["张宁", ""],
		["张沅", ""],
		["张政", ""],
		["张化本", ""],
		["张近东", ""],
		["陈明金", ""],
		["范伯元", ""],
		["林贤郁", ""],
		["林淑娘", ""],
		["国一民", ""],
		["金大鹏", ""],
		["周晋峰", ""],
		["赵光华", ""],
		["赵维绥", ""],
		["洪天慧", ""],
		["夏敏", ""],
		["郗杰英", ""],
		["曹湘洪", ""],
		["崔大林", ""],
		["陶大为", ""],
		["蒋秋霞", ""],
		["雷元亮", ""],
		["雷加富", ""],
		["蔡玲", ""],
		["王军伟", ""],
		["周纪昌", ""],
		["董福元", ""],
		["黄少良", ""],
		["刘江", ""],
		["刘永好", ""],
		["李家杰", ""],
		["李德水", ""],
		["陈锡文", ""],
		["范西成", ""],
		["欧新黔", ""],
		["郑新立", ""],
		["胡德平", ""],
		["董文标", ""],
		["颜延龄", ""],
		["丁仲篪", ""],
		["马明哲", ""],
		["马蔚华", ""],
		["王大成", ""],
		["王为强", ""],
		["王建宙", ""],
		["王基铭", ""],
		["宁高宁", ""],
		["朱孟依", ""],
		["刘公勤", ""],
		["刘克崮", ""],
		["刘迎霞", ""],
		["刘树成", ""],
		["刘德树", ""],
		["刘遵义", ""],
		["闫冰竹", ""],
		["许善达", ""],
		["李育才", ""],
		["李剑阁", ""],
		["李德成", ""],
		["杨先明", ""],
		["杨凯生", ""],
		["邱立成", ""],
		["应仲树", ""],
		["汪建熙", ""],
		["宋晓梧", ""],
		["张元龙", ""],
		["张华峰", ""],
		["张宏伟", ""],
		["张国初", ""],
		["张国宝", ""],
		["张春江", ""],
		["张赛娥", ""],
		["陈峰", ""],
		["陈晓颖", ""],
		["范小建", ""],
		["范福春", ""],
		["林金城", ""],
		["郑晖", ""],
		["胡四一", ""],
		["洪敬南", ""],
		["贺强", ""],
		["耿亮", ""],
		["贾康", ""],
		["唐大智", ""],
		["唐双宁", ""],
		["黄方毅", ""],
		["梅兴保", ""],
		["梁季阳", ""],
		["蒋超良", ""],
		["谢炳", ""],
		["谢渡扬", ""],
		["蔡继明", ""],
		["魏迎宁", ""],
		["李稻葵", ""],
		["宋丰强", ""],
		["王征", ""],
		["王广宪", ""],
		["王少阶", ""],
		["王曙光", ""],
		["李元", ""],
		["邵秉仁", ""],
		["林树哲", ""],
		["郭炎", ""],
		["卜漱和", ""],
		["于天忱", ""],
		["马富才", ""],
		["王曦", ""],
		["王训练", ""],
		["牛文元", ""],
		["尹伟伦", ""],
		["田在玮", ""],
		["印红", ""],
		["朱光武", ""],
		["刘纪远", ""],
		["刘秀晨", ""],
		["刘衍泉", ""],
		["兰云升", ""],
		["许健康", ""],
		["孙文杰", ""],
		["严慧英", ""],
		["李猛", ""],
		["李永安", ""],
		["李河君", ""],
		["李学明", ""],
		["李晋峰", ""],
		["李烈荣", ""],
		["李铁军", ""],
		["杨淳", ""],
		["杨文采", ""],
		["肖燕军", ""],
		["吴晓青", ""],
		["沈瑾", ""],
		["沈德忠", ""],
		["张红武", ""],
		["陆启洲", ""],
		["陈必亭", ""],
		["林宗寿", ""],
		["周大兵", ""],
		["周中枢", ""],
		["周名江", ""],
		["孟宪来", ""],
		["经天亮", ""],
		["赵学敏", ""],
		["赵炳礼", ""],
		["茹克", ""],
		["聂振邦", ""],
		["贾承造", ""],
		["倪晋仁", ""],
		["黄大卫", ""],
		["蒋丽芸", ""],
		["韩修国", ""],
		["舒兴田", ""],
		["谢正观", ""],
		["谢企华", ""],
		["谢俊奇", ""],
		["蔡国雄", ""],
		["翟若愚", ""],
		["翟浩辉", ""],
		["李宝善", ""],
		["张征宇", ""],
		["胡希捷", ""],
		["李蓉", ""],
		["金义华", ""],
		["徐冠华", ""],
		["于永湛", ""],
		["江绍高", ""],
		["杨胜群", ""],
		["陈晓光", ""],
		["赵沁平", ""],
		["胡家燕", ""],
		["高敬德", ""],
		["霍震霆", ""],
		["丁洁", ""],
		["于文明", ""],
		["于魁智", ""],
		["马大龙", ""],
		["马国湘", ""],
		["王宇", ""],
		["王成喜", ""],
		["王次炤", ""],
		["王国宾", ""],
		["邓亚萍", ""],
		["龙瑞", ""],
		["卢锡城", ""],
		["叶少兰", ""],
		["叶乔波", ""],
		["田军利", ""],
		["申万胜", ""],
		["史康成", ""],
		["包为民", ""],
		["朱星", ""],
		["邬贺铨", ""],
		["刘敏", ""],
		["刘焱", ""],
		["刘大为", ""],
		["刘振英", ""],
		["许树强", ""],
		["孙丽英", ""],
		["孙志辉", ""],
		["孙铁英", ""],
		["严望佳", ""],
		["李未", ""],
		["李立明", ""],
		["李济生", ""],
		["李胜素", ""],
		["李维康", ""],
		["杨桦", ""],
		["杨元庆", ""],
		["吴明江", ""],
		["吴雁泽", ""],
		["邱贵兴", ""],
		["佘靖", ""],
		["张会军", ""],
		["张景安", ""],
		["张新建", ""],
		["陈红", ""],
		["陈大卫", ""],
		["陈立人", ""],
		["陈仲强", ""],
		["陈邦柱", ""],
		["陈泽盛", ""],
		["范利", ""],
		["林金星", ""],
		["单霁翔", ""],
		["赵卫", ""],
		["赵平", ""],
		["胡定旭", ""],
		["胡海岩", ""],
		["柯杨", ""],
		["钟秉林", ""],
		["俞光岩", ""],
		["姚乃礼", ""],
		["徐亮", ""],
		["徐翔", ""],
		["徐延豪", ""],
		["徐沛东", ""],
		["徐晓兰", ""],
		["高润霖", ""],
		["郭为", ""],
		["郭传杰", ""],
		["黄大昉", ""],
		["黄如楷", ""],
		["黄洁夫", ""],
		["曹洪欣", ""],
		["曹淑敏", ""],
		["常小兵", ""],
		["蒋效愚", ""],
		["程天权", ""],
		["温熙森", ""],
		["蔡国斌", ""],
		["蔡冠深", ""],
		["瞿振元", ""],
		["李大魁", ""],
		["解思忠", ""],
		["江蓝生", ""],
		["张穹", ""],
		["罗平飞", ""],
		["赵少华", ""],
		["高金榜", ""],
		["谭耀宗", ""],
		["于宁", ""],
		["方工", ""],
		["王乃坤", ""],
		["王书平", ""],
		["王秀红", ""],
		["王建沂", ""],
		["王俊峰", ""],
		["王宪鹏", ""],
		["石见元", ""],
		["华士飞", ""],
		["刘红宇", ""],
		["许荣茂", ""],
		["许智明", ""],
		["孙南申", ""],
		["李小豹", ""],
		["李贤义", ""],
		["李顺桃", ""],
		["李钺锋", ""],
		["李嘉音", ""],
		["杨超", ""],
		["吴焰", ""],
		["何悦", ""],
		["宋林飞", ""],
		["张世平", ""],
		["张秋俭", ""],
		["陈智伦", ""],
		["林圣雄", ""],
		["林国文", ""],
		["周和平", ""],
		["郝明金", ""],
		["胡永柱", ""],
		["胡汉清", ""],
		["段正坤", ""],
		["侯欣一", ""],
		["姜建初", ""],
		["郭长江", ""],
		["黄文仔", ""],
		["黄英豪", ""],
		["曹义孙", ""],
		["董力", ""],
		["景天魁", ""],
		["曾智明", ""],
		["谢卫", ""],
		["谢伯阳", ""],
		["甄贞", ""],
		["黎振强", ""],
		["滕一龙", ""],
		["薄绍晔", ""],
		["牛越生", ""],
		["张希钦", ""],
		["唐铁汉", ""],
		["葛志荣", ""],
		["甄砚", ""],
		["凌孜", ""],
		["辛树森", ""],
		["任法融", ""],
		["张秀明", ""],
		["陈洪", ""],
		["拉巴平措", ""],
		["周明甫", ""],
		["巴登多吉", ""],
		["蒋明麟", ""],
		["丁文方", ""],
		["丁常云", ""],
		["刀述仁", ""],
		["于新粒", ""],
		["马子龙", ""],
		["马英林", ""],
		["王平", ""],
		["王健", ""],
		["王四代", ""],
		["邓宗良", ""],
		["田青", ""],
		["印乐", ""],
		["尼玛泽仁", ""],
		["朴英", ""],
		["伊丽苏娅", ""],
		["旭日干", ""],
		["关牧村", ""],
		["汤伟奇", ""],
		["安阿玥", ""],
		["安信义", ""],
		["安家瑶", ""],
		["向巴昂翁丹曲成来", ""],
		["艾山", ""],
		["李光富", ""],
		["李成日", ""],
		["杨钊", ""],
		["吴培娟", ""],
		["何玉棠", ""],
		["何星亮", ""],
		["张千一", ""],
		["陈顺鹏", ""],
		["妙江", ""],
		["尚绍华", ""],
		["金莉", ""],
		["金蔚", ""],
		["金晏山", ""],
		["房兴耀", ""],
		["郝时远", ""],
		["洪长有", ""],
		["贺捷生", ""],
		["别克西", ""],
		["钱利民", ""],
		["郭占春", ""],
		["唐诚青", ""],
		["黄元河", ""],
		["黄至安", ""],
		["黄信阳", ""],
		["曹玉书", ""],
		["鄂义太", ""],
		["韩兴旺", ""],
		["湛如", ""],
		["雷世银", ""],
		["雷菊芳", ""],
		["蔡世杰", ""],
		["德德玛", ""],
		["王江", ""],
		["吴江", ""],
		["米吉提", ""],
		["马有礼", ""],
		["王凤超", ""],
		["安民", ""],
		["李炳才", ""],
		["吴国祯", ""],
		["陈丽华", ""],
		["胡应湘", ""],
		["施祥鹏", ""],
		["楼志豪", ""],
		["蔡东士", ""],
		["于炼", ""],
		["马介璋", ""],
		["王执礼", ""],
		["王晓玉", ""],
		["邓成城", ""],
		["史茂林", ""],
		["乐美真", ""],
		["庄绍绥", ""],
		["孙必达", ""],
		["孙宝启", ""],
		["杨瀚", ""],
		["杨思泽", ""],
		["吴承业", ""],
		["邱维廉", ""],
		["张茵", ""],
		["张闾蘅", ""],
		["陈寒枫", ""],
		["陈联合", ""],
		["林明江", ""],
		["林盛中", ""],
		["罗援", ""],
		["胡葆琳", ""],
		["侯伯文", ""],
		["钟小健", ""],
		["俞敏洪", ""],
		["贺定一", ""],
		["贾宝兰", ""],
		["高杰", ""],
		["黄植诚", ""],
		["黄紫玉", ""],
		["黄楚标", ""],
		["彭磷基", ""],
		["董中原", ""],
		["董利翔", ""],
		["程红", ""],
		["曾文仲", ""],
		["瞿弦和", ""],
		["张启华", ""],
		["马秀红", ""],
		["卢文端", ""],
		["赵进军", ""],
		["韩方明", ""],
		["马灿荣", ""],
		["马胜荣", ""],
		["石愚", ""],
		["冯军", ""],
		["吕凤鼎", ""],
		["吕新华", ""],
		["刘文杰", ""],
		["刘梦熊", ""],
		["关呈远", ""],
		["孙萍", ""],
		["孙振宇", ""],
		["苏树辉", ""],
		["李大壮", ""],
		["李静杰", ""],
		["杨澜", ""],
		["吴思科", ""],
		["张骏", ""],
		["张九桓", ""],
		["张小济", ""],
		["张蕴岭", ""],
		["陆忠伟", ""],
		["陈经纬", ""],
		["图登克珠", ""],
		["金一南", ""],
		["柯小刚", ""],
		["袁明", ""],
		["贾庆国", ""],
		["郭涛", ""],
		["黄庆", ""],
		["黄友义", ""],
		["章新胜", ""],
		["蒋晓松", ""],
		["裘援平", ""],
		["詹国枢", ""],
		["蔡名照", ""],
		["廖晓淇", ""],
		["蓝鸿震", ""],
		["赵汝蘅", ""],
		["毛福民", ""],
		["计佑铭", ""],
		["郑欣淼", ""],
		["施子清", ""],
		["崔占福", ""],
		["梁华", ""],
		["王天增", ""],
		["王文章", ""],
		["王兴东", ""],
		["王连生", ""],
		["王晓秋", ""],
		["左东岭", ""],
		["石峰", ""],
		["叶培建", ""],
		["朱莲芬", ""],
		["李东东", ""],
		["李兴山", ""],
		["李国强", ""],
		["李景瑞", ""],
		["杨波", ""],
		["杨力舟", ""],
		["余辉", ""],
		["沈悌", ""],
		["张柏", ""],
		["张皎", ""],
		["张华祝", ""],
		["张廷皓", ""],
		["张胜友", ""],
		["陈力", ""],
		["陈醉", ""],
		["陈建功", ""],
		["林野", ""],
		["聂震宁", ""],
		["夏燕月", ""],
		["黄小同", ""],
		["黄书元", ""],
		["曹幸穗", ""],
		["曹鸿鸣", ""],
		["戚发轫", ""],
		["梁晓声", ""],
		["葛晓音", ""],
		["董良翚", ""],
		["滕矢初", ""],
		["何虎林", ""],
		["王军伟", ""],
		["周纪昌", ""],
		["董福元", ""],
		["黄少良", ""],
		["董必武", ""],
		["陈云", ""],
		["郭沫若", ""],
		["黄炎培", ""],
		["谭平山", ""],
		["谢觉哉", ""],
		["罗瑞卿", ""],
		["曾山", ""],
		["滕代远", ""],
		["章伯钧", ""],
		["李立三", ""],
		["马叙伦", ""],
		["陈劭先", ""],
		["王昆仑", ""],
		["罗隆基", ""],
		["章乃器", ""],
		["邵力子", ""],
		["黄绍竑", ""],
		["李富春", ""],
		["彭德怀", ""],
		["邓子恢", ""],
		["贺龙", ""],
		["陈毅", ""],
		["林彪", ""],
		["聂荣臻", ""],
		["谭震林", ""],
		["陆定一", ""],
		["柯庆施", ""],
		["陶铸", ""],
		["谢富治", ""],
		["周荣鑫", ""],
		["张春桥", ""],
		["陈锡联", ""],
		["纪登奎", ""],
		["陈永贵", ""],
		["吴桂贤", ""],
		["王震", ""],
		["余秋里", ""],
		["谷牧", ""],
		["孙健", ""],
		["徐向前", ""],
		["耿飚", ""],
		["方毅", ""],
		["康世恩", ""],
		["陈慕华", ""],
		["姬鹏飞", ""],
		["王任重", ""],
		["姚依林", ""],
		["杨静仁", ""],
		["张爱萍", ""],
		["黄华", ""],
		["钱之光", ""],
		["刘澜波", ""],
		["曾生", ""],
		["金明", ""],
		["杜星垣", ""],
		["吴学谦", ""],
		["王丙乾", ""],
		["宋平", ""],
		["宋健", ""],
		["陈俊生", ""],
		["秦基伟", ""],
		["王芳", ""],
		["李贵鲜", ""],
		["陈希同", ""],
		["钱其琛", ""],
		["迟浩田", ""],
		["艾买提", ""],
		["彭珮云", ""],
		["姜春云", ""],
		["王忠禹", ""],
		["唐家璇", ""],
		["钱云会", ""],
		["防和谐器", ""],
		["fanghexie", "fаnghexie"],
		["柏杨", ""],
		["丑陋的中国人", ""],
		["大逼", ""],
		["大B", ""],
		["昝爱宗", ""],
		["辛灝年", ""],
		["沈彤", ""],
		["左翼联盟", ""],
		["四事件", ""],
		["4事件", ""],
		["九事件", ""],
		["9事件", ""],
		["zhadan", "zhаdan"],
		["zhayao", "zhаdan"],
		["fenlie", "fеnlie"],
		["阿波罗", ""],
		["75事件", ""],
		["七五事件", ""],
		["群体事件", ""],
		["群体性事件", ""],
		["印尼事件", ""],
		["暴乳", ""],
		["内涵铁", ""],
		["穴海", ""],
		["惨案", ""],
		["charter", "сharter"],
		["仿真枪", ""],
		["信号枪", ""],
		["雅蠛蝶", ""],
		["吉跋猫", ""],
		["复制地址", ""],
		["复制到地址栏", ""],
		["色诱", ""],
		["淫威", ""],
		["埃及", ""],
		["开罗", ""],
		["穆巴拉克", ""],
		["突尼斯", ""],
		["阿里", ""],
		["茉莉", ""],
		["利比亚", ""],
		["黎波里", ""],
		["卡扎菲", ""],
		["愤怒日", ""],
		["赛风", ""],
		["Freegate", "Frеegate"],
		["bit\\\.ly", "bit点ly"],
		["is\\\.gd", "is点gd"],
		["药家鑫", ""],
		["txdl.cn", "txdl点cn"],
		["测试器", ""],
		["和谐器", ""],
		["正清集", ""],
		["正清网", ""],
		["正见网", ""],
		["智慧网", ""],
		["新生网", ""],
		["思想转化", ""],
		["回教", ""],
		["教育转化", ""],
		["九天班", ""],
		["联名", ""],
		["迷係说", ""],
		["民心所向", ""],
		["不得民心", ""],
		["民愤", ""],
		["鸣冤", ""],
		["学员供稿", ""],
		["启明网", ""],
		["强改班", ""],
		["人不治天治", ""],
		["人治", ""],
		["天灾人祸", ""],
		["遗臭万年", ""],
		["怨声载道", ""],
		["中联办", ""],
		["中宣部", ""],
		["中组部", ""],
		["自残", ""],
		["八的平方", ""],
		["8平方", ""],
		["8的平方", ""],
		["8乘于8", ""],
		["8乘8", ""],
		["八乘于八", ""],
		["八乘八", ""],
		["8\\\*8", "8〤8"],
		["8×8", "8〤8"],
		["奥斯陆", ""],
		["艾青的儿子", ""],
		["img\\\.ly", "img点ly"],
		["抚州", ""],
		["钱明奇", ""],
		["夏俊峰", ""],
		["方校长", ""],
		["北邮", ""],
		["李庄", ""],
		["潮州", ""],
		["古巷", ""],
		["增城", ""],
		["新塘", ""],
		["大敦", ""],
		["姜瑜", ""],
		["goo\\\.gl", "goo点gl"],
		["铁道部", ""],
		["动车", ""],
		["7.23", "⒎23"],
		["7·23", "⒎23"],
		["七二三", ""],
		["七·二三", "⒎二三"],
		["王荔蕻", ""],
		["和谐器", ""],
		["陈光诚", ""],
		["人权", ""],
		["痴乳", ""],
		["猛插", ""],
		["情色", ""],
		["穴淫", ""],
		["仑工力", ""],
		["仑工力", ""],
		["总书记", ""],
		["范徐丽泰", ""],
		["祖英", ""],
		["性友", ""],
		["子宫", ""],
		["清海无上师", ""],
		["江浙闽", ""],
		["老江", ""],
		["江core", ""],
		["江ZM", ""],
		["江某某", ""],
		["江猪", ""],
		["政百度府", ""],
		["一位老同志的谈话", ""],
		["ZF大楼", ""],
		["清华帮", ""],
		["上海帮", ""],
		["团派", ""],
		["网络评论员", ""],
		["无国界记者", ""],
		["记者无国界", ""],
		["记者无疆界", ""],
		["华盛顿邮报", ""],
		["威胁论", ""],
		["保钓", ""],
		["三股势力", ""],
		["你麻痹", ""],
		["他麻痹", ""],
		["妈了个逼", ""],
		["韩国狗", ""],
		["韩国猪", ""],
		["日本狗", ""],
		["日本猪", ""],
		["混蛋", ""],
		["杜金才", ""],
		["张军", ""],
		["陈文清", ""],
		["刘滨", ""],
		["江必新", ""],
		["杜金才", ""],
		["周福启", ""],
		["侯凯", ""],
		["俞贵麟", ""],
		["姚增科", ""],
		["黄晓薇", ""],
		["崔少鹏", ""],
		["王立军", ""],
		["谷开来", ""],
		["薄瓜瓜", ""],
		["车震", ""],
		["18大", ""],
		["胡星斗", ""],
		["反日", ""],
		["博讯", ""],
		["包遵信", ""],
		["北京之春", ""],
		["北京军区", ""],
		["洪博培", ""],
		["杨恒均", ""],
		["杨建利", ""],
		["陈破空", ""],
		["王若望", ""],
		["何家栋", ""],
		["徐文立", ""],
		["严家祺", ""],
		["共当", ""],
		["中文笔会", ""],
		["宪政", ""],
		["泛蓝联盟", ""],
		["习总", ""],
		["薄熙", ""],
		["熙来", ""],
		["谷开", ""],
		["挺薄", ""],
		["倒薄", ""],
		["黄奇帆", ""],
		["海伍德", ""],
		["氰化物", ""],
		["北戴河会议", ""],
		["境外媒体", ""],
		["乌有之乡", ""],
		["成都军区", ""],
		["姜异康", ""],
		["亚洲周刊", ""],
		["中央办公厅", ""],
		["金融时报", ""],
		["中国当局", ""],
		["中央领导", ""],
		["不厚", ""],
		["德国之声", ""],
		["参与网", ""],
		["庆林", ""],
		["国民党", ""],
		["中央社", ""],
		["瘟神", ""],
		["济南军区", ""],
		["支联会", ""],
		["沈阳军区", ""],
		["南京军区", ""],
		["广州军区", ""],
		["修改党章", ""],
		["末代皇帝", ""],
		["政治改革", ""],
		["政改", ""],
		["罗志军", ""],
		["赖昌星", ""],
		["江系", ""],
		["色图", ""],
		["李建国", ""],
		["张蓓莉", ""],
		["网管办", ""],
		["兰州军区", ""],
		["姜异康", ""],
		["互联网审查", ""],
		["网络审查", ""],
		["贾春旺", ""],
		["康生", ""],
		["张蓓莉", ""],
		["周舵", ""],
		["退出中国国籍", ""],
		["叶静子", ""],
		["彭博社", ""],
		["傅政华", ""],
		["党的喉舌", ""],
		["胡和谐", ""],
		["黄琦", ""],
		["收复台湾", ""],
		["暴力拆迁", ""],
		["温相", ""],
		["官商勾结", ""],
		["大赦国际", ""],
		["燃烧瓶", ""],
		["倪玉兰", ""],
		["日逼", ""],
		["结石宝宝", ""],
		["淫母", ""],
		["李卓人", ""],
		["奸幼", ""],
		["殃视", ""],
		["莫少平", ""],
		["李方平", ""],
		["告全国同胞书", ""],
		["告全国人民书", ""],
		["光诚", ""],
		["张伯笠", ""],
		["守望教会", ""],
		["李方平", ""],
		["傅希秋", ""],
		["基督教科学箴言报", ""],
		["陈永苗", ""],
		["芙瑞", ""],
		["QVOD", "QV●D"]
	],
	medium: [
		["SM", "SΜ"],
		["开户", ""],
		["杀人", ""],
		["焚书坑儒", ""],
		["大狱", ""],
		["唤醒", ""],
		["6月", ""],
		["六月", ""],
		["领导", ""],
		["干部", ""],
		["秘书", ""],
		["上任", ""],
		["下任", ""],
		["事故", ""],
		["成立", ""],
		["涨价", ""],
		["奥运", ""],
		["怀孕", ""],
		["按摩", ""],
		["弟弟", ""],
		["体内", ""],
		["小姐", ""],
		["全套", ""],
		["成人", ""],
		["真相", ""],
		["人民", ""],
		["百姓", ""],
		["台湾", ""],
		["独立", ""],
		["统一", ""],
		["北京", ""],
		["上海", ""],
		["大陆", ""],
		["社会", ""],
		["中央", ""],
		["冲突", ""],
		["改革", ""],
		["主义", ""],
		["制度", ""],
		["选举", ""],
		["阶级", ""],
		["言论", ""],
		["委员", ""],
		["书记", ""],
		["禽兽", ""],
		["畜生", ""],
		["牲畜", ""],
		["革命", ""],
		["防腐", ""],
		["反腐", ""],
		["舆论", ""],
		["宗教", ""],
		["信仰", ""],
		["审查", ""],
		["践踏", ""],
		["机构", ""],
		["机关", ""],
		["分裂", ""],
		["各界", ""],
		["人士", ""],
		["社论", ""],
		["违禁", ""],
		["组织", ""],
		["头目", ""],
		["分子", ""],
		["份子", ""],
		["同伙", ""],
		["基地", ""],
		["头子", ""],
		["狂妄", ""],
		["旁见", ""],
		["真凶", ""],
		["答案", ""],
		["集团", ""],
		["公司", ""],
		["用品", ""],
		["美容", ""],
		["激情", ""],
		["免费", ""],
		["传奇", ""],
		["受不了了", ""],
		["夹紧", ""],
		["内侧", ""],
		["鼓起", ""],
		["插进", ""],
		["插入", ""],
		["好痛", ""],
		["用力", ""],
		["湿了", ""],
		["湿透", ""],
		["液体", ""],
		["床上", ""],
		["上床", ""],
		["视频", ""],
		["用具", ""],
		["用品", ""],
		["VIP", "VΙP"],
		["猛犬", ""],
		["丁香", ""],
		["下岗", ""],
		["首脑", ""],
		["共和", ""],
		["联邦", ""],
		["开会", ""],
		["公仆", ""],
		["少女", ""],
		["严惩", ""],
		["列强", ""],
		["工农", ""],
		["农民", ""],
		["斗争", ""],
		["挂帅", ""],
		["专业", ""],
		["专家", ""],
		["砖家", ""],
		["破解", ""],
		["黑客", ""],
		["乱了", ""],
		["宣言", ""],
		["群体", ""],
		["大会", ""],
		["民族", ""],
		["窒息", ""],
		["服务", ""],
		["两岸", ""],
		["狂情", ""],
		["私语", ""],
		["今晚", ""],
		["解放", ""],
		["体制", ""],
		["帮派", ""],
		["天朝", ""],
		["朝廷", ""],
		["残忍", ""],
		["凶残", ""],
		["利用", ""],
		["欺骗", ""],
		["嘴脸", ""],
		["堕落", ""],
		["教条", ""],
		["棺材", ""],
		["谎言", ""],
		["谎话", ""],
		["说谎", ""],
		["面临", ""],
		["不强都不行", ""],
		["必看", ""],
		["同胞", ""],
		["互联网", ""],
		["无耻", ""],
		["沦丧", ""],
		["讲理", ""],
		["陆战", ""],
		["公务", ""],
		["钓鱼", ""],
		["留学生", ""],
		["危机", ""],
		["强势", ""],
		["网民", ""],
		["过度", ""],
		["震惊", ""],
		["无能", ""],
		["之子", ""],
		["部队", ""],
		["张开", ""],
		["靠山", ""],
		["私仇", ""],
		["私了", ""],
		["老罗", ""],
		["赌博", ""],
		["保障", ""],
		["检查", ""],
		["违章", ""],
		["亲密", ""],
		["人体", ""],
		["斗士", ""],
		["勇士", ""],
		["内情", ""],
		["强制", ""],
		["武器", ""],
		["武装", ""],
		["办理", ""],
		["劈开", ""],
		["肮脏", ""],
		["历史", ""],
		["抄家", ""],
		["黑暗", ""],
		["档案", ""],
		["给封", ""],
		["给删", ""],
		["被封", ""],
		["被删", ""],
		["光明", ""],
		["美女", ""],
		["真实", ""],
		["亵渎", ""],
		["喉舌", ""],
		["歪曲", ""],
		["领袖", ""],
		["纳税", ""],
		["私聊", ""],
		["疑案", ""],
		["领取", ""],
		["预测", ""],
		["监听", ""],
		["监视", ""],
		["悬案", ""],
		["清醒", ""],
		["全会", ""],
		["人大", ""],
		["会议", ""],
		["歌功", ""],
		["粉饰", ""],
		["祸害", ""],
		["被关", ""],
		["封网", ""],
		["控制", ""],
		["限制", ""],
		["屏蔽", ""],
		["劳改", ""],
		["劳教", ""],
		["公民", ""],
		["草木皆兵", ""],
		["喝茶", ""],
		["负面", ""],
		["道德", ""],
		["被判", ""],
		["处长", ""],
		["宣传", ""],
		["监督", ""],
		["厅长", ""],
		["阿拉伯", ""],
		["谷歌", ""],
		["签名", ""],
		["业务", ""],
		["台北", ""],
		["高雄", ""],
		["身份证", ""],
		["泄露", ""],
		["泄漏", ""],
		["机密", ""],
		["绝密", ""],
		["纪委", ""],
		["台海", ""],
		["银行", ""],
		["行长", ""],
		["抢劫", ""],
		["元帅", ""],
		["批评", ""],
		["公款", ""],
		["呼吁", ""],
		["泛蓝", ""],
		["泛绿", ""],
		["辛灏年", ""],
		["辛亥", ""],
		["江清", ""],
		["香港", ""],
		["澳门", ""],
		["鸦片", ""],
		["抵制", ""],
		["盘查", ""],
		["勘察", ""],
		["海关", ""],
		["惨无人", ""],
		["外交部", ""],
		["发言人", ""],
		["风月", ""],
		["内衣", ""],
		["周刊", ""],
		["晚报", ""],
		["文汇", ""],
		["时报", ""],
		["通讯社", ""],
		["早报", ""],
		["玛雅", ""],
		["预言", ""],
		["恐慌", ""],
		["预谋", ""],
		["扫荡", ""],
		["动荡", ""],
		["村民", ""],
		["种族", ""],
		["歧视", ""],
		["仇恨", ""],
		["抗议", ""],
		["管制", ""],
		["群发", ""],
		["离婚", ""],
		["工资", ""],
		["证书", ""],
		["文凭", ""],
		["兴奋", ""],
		["集合", ""],
		["裤袜", ""],
		["衣裤", ""],
		["被迫", ""],
		["告状", ""],
		["状告", ""],
		["出台", ""],
		["三峡", ""],
		["加群", ""],
		["下台", ""],
		["落马", ""],
		["我朝", ""],
		["威武", ""],
		["监管", ""],
		["残害", ""],
		["押送", ""],
		["特务", ""],
		["揭露", ""],
		["揭穿", ""],
		["慎入", ""],
		["勿进", ""],
		["自治", ""],
		["打针", ""],
		["分身", ""],
		["和弦", ""],
		["媚外", ""],
		["解码器", ""],
		["受害者", ""],
		["受害人", ""],
		["真主", ""],
		["行贿", ""],
		["受贿", ""],
		["贿赂", ""],
		["信号弹", ""],
		["闪光弹", ""],
		["网评", ""],
		["工人", ""],
		["奴才", ""],
		["失魂", ""],
		["造假", ""],
		["丑闻", ""],
		["语音", ""],
		["调查", ""],
		["公关", ""],
		["舞女", ""],
		["花心", ""],
		["女郎", ""],
		["网特", ""],
		["网监", ""],
		["不穿", ""],
		["手交", ""],
		["拳交", ""],
		["脚交", ""],
		["好爽", ""],
		["进沪", ""],
		["进京", ""],
		["殡仪馆", ""],
		["销赃", ""],
		["关押", ""],
		["彩铃", ""],
		["孙子", ""],
		["神经", ""],
		["放屁", ""],
		["放P", ""],
		["阿三", ""],
		["巴子", ""],
		["鬼子", ""],
		["小鬼", ""],
		["大便", ""],
		["境外", ""],
		["愤青", ""],
		["粪青", ""],
		["西门子", ""],
		["腾讯", ""],
		["农奴", ""],
		["制作", ""],
		["制造", ""],
		["自制", ""],
		["赤匪", ""],
		["殴打", ""],
		["低智商", ""],
		["智商低", ""],
		["低能儿", ""],
		["弱智", ""],
		["房奴", ""],
		["买不起房", ""],
		["教徒", ""],
		["阴谋", ""],
		["包养", ""],
		["6月", ""],
		["活体", ""],
		["聚集", ""],
		["艾滋病", ""],
		["民意", ""],
		["压迫", ""],
		["更衣", ""],
		["护士", ""],
		["强迫", ""],
		["伦理", ""],
		["斯诺", ""],
		["杂志", ""],
		["基督", ""],
		["天主", ""],
		["瓮安", ""],
		["大庄", ""],
		["广安", ""],
		["蹂躏", ""],
		["女奴", ""],
		["男奴", ""],
		["蛤蟆", ""],
		["核武", ""],
		["论功", ""],
		["耳机", ""],
		["龙卷风", ""],
		["陆委", ""],
		["绿营", ""],
		["白皮书", ""],
		["棒子", ""],
		["吃人", ""],
		["参拜", ""],
		["踩踏", ""],
		["大盖帽", ""],
		["大选", ""],
		["弟子", ""],
		["宏恩", ""],
		["反对派", ""],
		["保守派", ""],
		["红灯区", ""],
		["活佛", ""],
		["红头文件", ""],
		["复员", ""],
		["圆满", ""],
		["高干", ""],
		["工力", ""],
		["股民", ""],
		["雇佣", ""],
		["高瞻", ""],
		["绝版", ""],
		["接班", ""],
		["交班", ""],
		["金戈铁马", ""],
		["升天", ""],
		["经文", ""],
		["空难", ""],
		["买断", ""],
		["母子", ""],
		["流感", ""],
		["迁都", ""],
		["情妇", ""],
		["少儿不宜", ""],
		["儿童不宜", ""],
		["松下", ""],
		["首长", ""],
		["天怒", ""],
		["弹劾", ""],
		["台商", ""],
		["统战", ""],
		["围攻", ""],
		["修炼", ""],
		["消声器", ""],
		["小阳", ""],
		["隐形", ""],
		["遗作", ""],
		["证件", ""],
		["招收", ""],
		["增值税", ""],
		["抵抗", ""],
		["唐人", ""],
		["被捕", ""],
		["逮捕", ""],
		["抓捕", ""],
		["同性", ""],
		["命案", ""],
		["疑云", ""],
		["被拘", ""],
		["蒙羞", ""],
		["丧尽天良", ""],
		["伸入", ""],
		["伪善", ""],
		["便衣", ""],
		["捞钱", ""],
		["主子", ""],
		["价格", ""],
		["出卖灵魂", ""],
		["偷换概念", ""],
		["混淆视听", ""],
		["作弊", ""],
		["轮子", ""],
		["遇害", ""],
		["鞭子", ""],
		["抽打", ""],
		["负翁", ""],
		["伪造", ""],
		["网管", ""],
		["高干", ""],
		["真理", ""],
		["五岳散人", ""],
		["凌辱", ""],
		["服从", ""],
		["推倒", ""],
		["推墙", ""],
		["出事了", ""],
		["亢奋", ""],
		["发育", ""],
		["黄色", ""],
		["色眼", ""],
		["灾情", ""],
		["灾难", ""],
		["旱情", ""],
		["旱灾", ""],
		["干旱", ""],
		["局长", ""],
		["主任", ""],
		["扔鞋", ""],
		["贪污", ""],
		["交警", ""],
		["执法", ""],
		["亿元", ""],
		["公车消费", ""],
		["核电", ""],
		["立宪", ""],
		["分权", ""],
		["建国", ""],
		["反对", ""],
		["军队", ""],
		["鸟巢", ""],
		["水立方", ""],
		["暴民", ""],
		["爆民", ""],
		["爆炸", ""],
		["暴炸", ""],
		["做人不能太", ""],
		["下载速度", ""],
		["在线播放", ""],
		["中印边界", ""],
		["蟾蜍迁徙", ""],
		["内幕", ""],
		["色情", ""],
		["妓女", ""],
		["笨蛋", ""],
		["救市", ""],
		["圈钱", ""],
		["证监会", ""],
		["胡的", ""],
		["温的", ""],
		["缺钱", ""],
		["中华", ""],
		["帝国", ""],
		["中日", ""],
		["后台", ""],
		["当官", ""],
		["做官", ""],
		["中石化", ""],
		["中石油", ""],
		["特供", ""],
		["双规", ""],
		["被拆", ""],
		["拆迁", ""],
		["执政", ""],
		["法院", ""],
		["法官", ""],
		["国家", ""],
		["我国", ""],
		["国民", ""],
		["宪政", ""],
		["低制", ""],
		["国旗", ""],
		["国徽", ""],
		["杀毙", ""],
		["京城", ""],
		["爱国", ""],
		["卖国", ""],
		["蒋公", ""],
		["蒋介石", ""],
		["台军", ""],
		["军区", ""],
		["塔利班", ""],
		["全家", ""],
		["汉人", ""],
		["满洲", ""],
		["联系", ""],
		["想做", ""],
		["电话", ""],
		["手机", ""],
		["矿工", ""],
		["庶民", ""],
		["一国两制", ""],
		["录音", ""],
		["24小时", ""],
		["官商", ""],
		["工商税务", ""],
		["楼盘", ""],
		["楼市", ""],
		["物价", ""],
		["工商局", ""],
		["税务局", ""],
		["苍生", ""],
		["检院", ""],
		["检察院", ""],
		["教育局", ""],
		["教育部", ""],
		["卫生局", ""],
		["卫生部", ""],
		["人事局", ""],
		["人事部", ""],
		["卫生院", ""],
		["卫生部", ""],
		["世博", ""],
		["富士康", ""],
		["白里透红", ""],
		["摆布", ""],
		["摆动", ""],
		["棒棒", ""],
		["剥开", ""],
		["拨开", ""],
		["擦拭", ""],
		["补阳", ""],
		["勃发", ""],
		["插出", ""],
		["叉开", ""],
		["颤动", ""],
		["颤抖", ""],
		["撑爆", ""],
		["撑破", ""],
		["抽离", ""],
		["抽了", ""],
		["触摸", ""],
		["触碰", ""],
		["戳穿", ""],
		["戳入", ""],
		["刺插", ""],
		["粗暴", ""],
		["粗粗", ""],
		["粗大", ""],
		["窜动", ""],
		["摧残", ""],
		["大抽", ""],
		["大娘", ""],
		["老爷", ""],
		["老娘", ""],
		["爷子", ""],
		["蛋蛋", ""],
		["蛋子", ""],
		["低嚎", ""],
		["滴出", ""],
		["调逗", ""],
		["调情", ""],
		["调戏", ""],
		["丢了", ""],
		["动情", ""],
		["洞口", ""],
		["逗弄", ""],
		["多情", ""],
		["多姿", ""],
		["发颤", ""],
		["发抖", ""],
		["发麻", ""],
		["发热", ""],
		["发丝", ""],
		["发泄", ""],
		["翻动", ""],
		["芳香", ""],
		["昏厥", ""],
		["飞溅", ""],
		["飞燕", ""],
		["肥大", ""],
		["分泌", ""],
		["焚身", ""],
		["丰硕", ""],
		["风流", ""],
		["风骚", ""],
		["夫妻", ""],
		["伏在", ""],
		["抚摸", ""],
		["妇人", ""],
		["高耸", ""],
		["高亢", ""],
		["根部", ""],
		["乖巧", ""],
		["滚热", ""],
		["滚烫", ""],
		["裹住", ""],
		["裹着", ""],
		["含入", ""],
		["合体", ""],
		["黑黑的", ""],
		["黑洞", ""],
		["红唇", ""],
		["花蜜", ""],
		["花蕊", ""],
		["滑出", ""],
		["滑到", ""],
		["滑动", ""],
		["滑进", ""],
		["滑熘", ""],
		["滑嫩", ""],
		["滑入", ""],
		["滑下", ""],
		["滑顺", ""],
		["滑向", ""],
		["欢愉", ""],
		["欢悦", ""],
		["唤起", ""],
		["魂飞魄散", ""],
		["火热", ""],
		["击打", ""],
		["饥渴", ""],
		["激射", ""],
		["挤压", ""],
		["悸动", ""],
		["夹着", ""],
		["夹住", ""],
		["坚实", ""],
		["坚硬", ""],
		["尖叫", ""],
		["尖硬", ""],
		["交缠", ""],
		["娇弱", ""],
		["娇小", ""],
		["娇笑", ""],
		["娇艳", ""],
		["叫声", ""],
		["接触", ""],
		["接吻", ""],
		["解带", ""],
		["解开", ""],
		["紧靠", ""],
		["紧贴", ""],
		["紧握", ""],
		["紧抓", ""],
		["久战", ""],
		["巨物", ""],
		["俊逸", ""],
		["亢进", ""],
		["啃咬", ""],
		["口唇", ""],
		["口含", ""],
		["口中", ""],
		["胯下", ""],
		["快意", ""],
		["狂暴", ""],
		["狂热", ""],
		["狂吻", ""],
		["窥探", ""],
		["两腿", ""],
		["撩动", ""],
		["撩起", ""],
		["流到", ""],
		["搂抱", ""],
		["露出", ""],
		["毛茸茸", ""],
		["茂密", ""],
		["茂盛", ""],
		["美人", ""],
		["冰火", ""],
		["注入", ""],
		["秘洞", ""],
		["名器", ""],
		["摸向", ""],
		["摸着", ""],
		["磨擦", ""],
		["磨搽", ""],
		["磨搓", ""],
		["磨弄", ""],
		["嫩白", ""],
		["嫩脸", ""],
		["嫩嫩", ""],
		["捏捏", ""],
		["扭动", ""],
		["扭捏", ""],
		["浓稠", ""],
		["浓黑", ""],
		["浓密", ""],
		["弄弄", ""],
		["弄破", ""],
		["排出", ""],
		["排入", ""],
		["喷射", ""],
		["喷出", ""],
		["喷发", ""],
		["喷涌", ""],
		["碰触", ""],
		["平滑", ""],
		["破坏", ""],
		["迫进", ""],
		["起性", ""],
		["器具", ""],
		["腔内", ""],
		["强硬", ""],
		["亲热", ""],
		["亲吻", ""],
		["亲昵", ""],
		["青春期", ""],
		["轻按", ""],
		["轻触", ""],
		["轻搓", ""],
		["轻抚", ""],
		["轻揉", ""],
		["轻松", ""],
		["轻吻", ""],
		["情动", ""],
		["情侣", ""],
		["情色", ""],
		["燃烧", ""],
		["热滚", ""],
		["热烘烘", ""],
		["热乎乎", ""],
		["热热", ""],
		["热烫", ""],
		["热吻", ""],
		["揉擦", ""],
		["揉搓", ""],
		["揉动", ""],
		["揉揉", ""],
		["揉抓", ""],
		["揉转", ""],
		["揉着", ""],
		["柔嫩", ""],
		["柔软", ""],
		["柔弱", ""],
		["肉体", ""],
		["肉芽", ""],
		["肉蚌", ""],
		["肉臂", ""],
		["肉搏", ""],
		["肉色", ""],
		["肉团", ""],
		["肉嘟嘟", ""],
		["蠕动", ""],
		["如醉如痴", ""],
		["乳白色", ""],
		["软掉", ""],
		["软了", ""],
		["软软", ""],
		["软下", ""],
		["润湿", ""],
		["塞进", ""],
		["塞入", ""],
		["嫂嫂", ""],
		["嫂子", ""],
		["上上下下", ""],
		["舌头", ""],
		["舌尖", ""],
		["射了", ""],
		["射向", ""],
		["身体", ""],
		["身子", ""],
		["深喉", ""],
		["深入浅出", ""],
		["深吻", ""],
		["婶婶", ""],
		["师弟", ""],
		["师姐", ""],
		["师妹", ""],
		["师兄", ""],
		["湿乎乎", ""],
		["湿淋淋", ""],
		["湿热", ""],
		["湿漉漉", ""],
		["湿濡", ""],
		["蚀骨", ""],
		["事前", ""],
		["势如破竹", ""],
		["舒爽", ""],
		["竖立", ""],
		["竖起", ""],
		["竖直", ""],
		["爽滑", ""],
		["爽劲", ""],
		["爽快", ""],
		["爽死", ""],
		["爽透", ""],
		["水淋淋", ""],
		["吮着", ""],
		["硕大", ""],
		["硕壮", ""],
		["撕开", ""],
		["撕裂", ""],
		["撕破", ""],
		["松弛", ""],
		["松软", ""],
		["耸动", ""],
		["耸起", ""],
		["随心所欲", ""],
		["瘫软", ""],
		["探入", ""],
		["烫热", ""],
		["套上", ""],
		["套紧", ""],
		["剃掉", ""],
		["天强", ""],
		["甜蜜", ""],
		["挑拨", ""],
		["挑动", ""],
		["挑逗", ""],
		["挑起", ""],
		["挺进", ""],
		["挺立", ""],
		["挺起", ""],
		["挺腰", ""],
		["挺直", ""],
		["捅了", ""],
		["捅入", ""],
		["透明", ""],
		["突刺", ""],
		["徒弟", ""],
		["吞入", ""],
		["吞食", ""],
		["脱去", ""],
		["脱下", ""],
		["外流", ""],
		["玩弄", ""],
		["完事", ""],
		["温软", ""],
		["温湿", ""],
		["卧式", ""],
		["吸入", ""],
		["戏弄", ""],
		["吸吮", ""],
		["细嫩", ""],
		["鲜嫩", ""],
		["鲜润", ""],
		["香滑", ""],
		["香津", ""],
		["香嫩", ""],
		["小弟弟", ""],
		["泄洪", ""],
		["新婚", ""],
		["性侵犯", ""],
		["性情", ""],
		["凶勐", ""],
		["胸脯", ""],
		["雄壮", ""],
		["修长", ""],
		["虚脱", ""],
		["宣泄", ""],
		["压进", ""],
		["压入", ""],
		["养父", ""],
		["养精", ""],
		["养母", ""],
		["养女", ""],
		["野合", ""],
		["姨妈", ""],
		["姨妹", ""],
		["姨丈", ""],
		["义父", ""],
		["阴沟", ""],
		["引逗", ""],
		["引诱", ""],
		["盈满", ""],
		["硬立", ""],
		["硬硬", ""],
		["拥抱", ""],
		["用药", ""],
		["游动", ""],
		["游移", ""],
		["岳父", ""],
		["岳母", ""],
		["韵律", ""],
		["窄窄", ""],
		["展露", ""],
		["丈母", ""],
		["胀得", ""],
		["侄儿", ""],
		["侄女", ""],
		["侄子", ""],
		["壮大", ""],
		["茁壮", ""],
		["灼热", ""],
		["姿势", ""],
		["滋润", ""],
		["坐姿", ""],
		["剌激", ""],
		["渲泄", ""],
		["姊姊", ""],
		["掰开", ""],
		["黏稠", ""],
		["黏煳", ""],
		["歹徒", ""],
		["发功", ""],
		["法力", ""],
		["总部", ""],
		["护法", ""],
		["迷途知返", ""],
		["歪理邪说", ""],
		["悟到", ""],
		["伪科学", ""],
		["暗杀", ""],
		["杀害", ""],
		["虐杀", ""],
		["紧急救援", ""],
		["环球步行", ""],
		["全球步行", ""],
		["全台步行", ""],
		["练习者", ""],
		["大气候", ""],
		["大千世界", ""],
		["大权", ""],
		["大赦大刑", ""],
		["大义", ""],
		["主教", ""],
		["歹毒", ""],
		["丹田", ""],
		["丹心", ""],
		["当道", ""],
		["当局", ""],
		["当权", ""],
		["当世", ""],
		["当政", ""],
		["党籍", ""],
		["党纪", ""],
		["国法", ""],
		["党内", ""],
		["党委", ""],
		["党员", ""],
		["党章", ""],
		["党政", ""],
		["倒行逆施", ""],
		["祷告", ""],
		["道家", ""],
		["道教", ""],
		["道门", ""],
		["道人", ""],
		["道士", ""],
		["道学", ""],
		["道义", ""],
		["得道多助", ""],
		["得救", ""],
		["得人心", ""],
		["酷刑", ""],
		["低劣", ""],
		["敌对势力", ""],
		["地痞", ""],
		["弟子切磋", ""],
		["颠倒黑白", ""],
		["颠倒是非", ""],
		["颠沛流离", ""],
		["刁难", ""],
		["吊绑", ""],
		["吊打", ""],
		["定理", ""],
		["动刑", ""],
		["动摇", ""],
		["动议", ""],
		["恫吓", ""],
		["毒害", ""],
		["毒计", ""],
		["毒辣", ""],
		["毒瘤", ""],
		["毒手", ""],
		["毒打", ""],
		["断子绝孙", ""],
		["行恶", ""],
		["诋毁", ""],
		["灭亡", ""],
		["信徒", ""],
		["对着干", ""],
		["蹲点", ""],
		["多灾多难", ""],
		["夺权", ""],
		["堕入", ""],
		["讹诈", ""],
		["恶霸", ""],
		["恶毒", ""],
		["恶鬼", ""],
		["恶棍", ""],
		["恶果", ""],
		["恶疾", ""],
		["恶贯满盈", ""],
		["恶浪", ""],
		["恶梦", ""],
		["恶名", ""],
		["恶魔", ""],
		["恶人", ""],
		["恶少", ""],
		["恶事", ""],
		["恶徒", ""],
		["恶习", ""],
		["恶相", ""],
		["恶行", ""],
		["恶言", ""],
		["恶有恶报", ""],
		["恶语", ""],
		["恶咒", ""],
		["扼杀", ""],
		["恩德", ""],
		["恩惠", ""],
		["恩师", ""],
		["尔虞我诈", ""],
		["二不保证", ""],
		["发报", ""],
		["发怒", ""],
		["法办", ""],
		["法典", ""],
		["法度", ""],
		["众生师", ""],
		["法官", ""],
		["法会", ""],
		["法理", ""],
		["法令", ""],
		["法正乾坤", ""],
		["海协", ""],
		["和平与善良", ""],
		["和平之路", ""],
		["坚不可摧", ""],
		["千古奇冤", ""],
		["世人必经", ""],
		["正法", ""],
		["讲座", ""],
		["宇宙大法", ""],
		["镇邪灭乱", ""],
		["正义之声", ""],
		["道德力量", ""],
		["和平历程", ""],
		["教导", ""],
		["哲学思想", ""],
		["和平巡回", ""],
		["和平之旅", ""],
		["难民", ""],
		["黑名单", ""],
		["白名单", ""],
		["法门", ""],
		["邪恶", ""],
		["法器", ""],
		["法师", ""],
		["法王", ""],
		["法学", ""],
		["无法无天", ""],
		["翻脸", ""],
		["反人道", ""],
		["反锁", ""],
		["反诬", ""],
		["犯下", ""],
		["防暴", ""],
		["放下屠刀", ""],
		["拘留", ""],
		["判刑", ""],
		["取缔", ""],
		["抓走", ""],
		["非人", ""],
		["飞天", ""],
		["匪徒", ""],
		["诽谤", ""],
		["肺腑之言", ""],
		["费尽心机", ""],
		["分局", ""],
		["分派", ""],
		["焚毁", ""],
		["粉身碎骨", ""],
		["愤恨", ""],
		["丰碑", ""],
		["风云突变", ""],
		["疯子", ""],
		["奉劝", ""],
		["佛恩浩荡", ""],
		["佛法无边", ""],
		["佛光普照", ""],
		["佛经", ""],
		["佛寺", ""],
		["佛陀", ""],
		["佛学", ""],
		["佛国", ""],
		["佛展千手法", ""],
		["佛主", ""],
		["符咒", ""],
		["伏法", ""],
		["福报", ""],
		["福分", ""],
		["福益", ""],
		["福音", ""],
		["覆灭", ""],
		["改过自新", ""],
		["改悔", ""],
		["改邪归正", ""],
		["干将", ""],
		["干警", ""],
		["赶尽杀绝", ""],
		["感化", ""],
		["感悟", ""],
		["感召", ""],
		["高波", ""],
		["高参", ""],
		["高德", ""],
		["高官", ""],
		["搞垮", ""],
		["功法", ""],
		["功力", ""],
		["功派", ""],
		["功修", ""],
		["绑架", ""],
		["公道", ""],
		["公检法", ""],
		["公理", ""],
		["公粮", ""],
		["公论", ""],
		["官吏", ""],
		["地方官", ""],
		["官员", ""],
		["公社", ""],
		["公审", ""],
		["公署", ""],
		["公诸", ""],
		["暴虐", ""],
		["暴力", ""],
		["流毒", ""],
		["胡搞", ""],
		["教义", ""],
		["强售", ""],
		["瘟疫", ""],
		["作恶", ""],
		["幽灵", ""],
		["共发", ""],
		["共同精进", ""],
		["勾心斗角", ""],
		["苟且偷生", ""],
		["狗命", ""],
		["构陷", ""],
		["古今中外", ""],
		["骨瘦如柴", ""],
		["官办", ""],
		["官厅", ""],
		["官位", ""],
		["官职", ""],
		["管教", ""],
		["归真", ""],
		["诡辩", ""],
		["诡计", ""],
		["刽子手", ""],
		["棍棒", ""],
		["棍子", ""],
		["国安", ""],
		["国格", ""],
		["国会", ""],
		["国家大事", ""],
		["国家机关", ""],
		["海关", ""],
		["骇怕", ""],
		["好恶", ""],
		["号房", ""],
		["号子", ""],
		["合十", ""],
		["黑道", ""],
		["黑恶", ""],
		["黑手", ""],
		["黑窝", ""],
		["黑线", ""],
		["狠毒", ""],
		["狠命", ""],
		["恨之入骨", ""],
		["横暴", ""],
		["横财", ""],
		["横幅", ""],
		["洪大", ""],
		["洪恩", ""],
		["洪灾", ""],
		["出凶", ""],
		["行凶", ""],
		["花招", ""],
		["豢养", ""],
		["活埋", ""],
		["惑乱", ""],
		["祸乱", ""],
		["监禁", ""],
		["监牢", ""],
		["监区", ""],
		["监舍", ""],
		["监室", ""],
		["检查官", ""],
		["检举", ""],
		["检视", ""],
		["教规", ""],
		["教化", ""],
		["教皇", ""],
		["教会", ""],
		["教诲", ""],
		["教派", ""],
		["教区", ""],
		["教唆", ""],
		["教堂", ""],
		["揭发", ""],
		["揭密", ""],
		["揭批", ""],
		["揭示", ""],
		["阶下囚", ""],
		["看守所", ""],
		["劫夺", ""],
		["劫难", ""],
		["劫数", ""],
		["结社", ""],
		["解教", ""],
		["戒律", ""],
		["进修", ""],
		["禁闭", ""],
		["禁令", ""],
		["禁锢", ""],
		["尽人皆知", ""],
		["惊骇", ""],
		["经书", ""],
		["经学", ""],
		["警笛", ""],
		["警服", ""],
		["警官", ""],
		["警棍", ""],
		["警号", ""],
		["警局", ""],
		["警绳", ""],
		["救了我一命", ""],
		["就教", ""],
		["拘捕", ""],
		["拘禁", ""],
		["拘留所", ""],
		["拘押", ""],
		["拘役", ""],
		["居留", ""],
		["举发", ""],
		["举国上下", ""],
		["觉悟", ""],
		["军权", ""],
		["看管", ""],
		["看护", ""],
		["看守", ""],
		["看押", ""],
		["考勒", ""],
		["拷打", ""],
		["拷问", ""],
		["坑害", ""],
		["坑蒙", ""],
		["坑人", ""],
		["恐怖组织", ""],
		["恐吓", ""],
		["控告", ""],
		["扣发", ""],
		["扣留", ""],
		["扣压", ""],
		["扣押", ""],
		["苦不堪言", ""],
		["苦渡", ""],
		["苦炼", ""],
		["苦役", ""],
		["酷虐", ""],
		["酷刑折磨", ""],
		["拦阻", ""],
		["滥捕", ""],
		["滥施", ""],
		["劳动改造", ""],
		["劳动教养", ""],
		["劳改犯", ""],
		["劳教所", ""],
		["劳役", ""],
		["牢房", ""],
		["牢笼", ""],
		["牢狱", ""],
		["勒派", ""],
		["离心离德", ""],
		["口头保证", ""],
		["其人其事", ""],
		["连坐", ""],
		["联名", ""],
		["连宵风雨不须愁", ""],
		["炼不炼", ""],
		["炼法", ""],
		["炼功", ""],
		["炼好", ""],
		["炼习", ""],
		["炼狱", ""],
		["练队", ""],
		["练功", ""],
		["镣铐", ""],
		["劣迹", ""],
		["凌锋", ""],
		["凌驾", ""],
		["凌虐", ""],
		["灵魂离体", ""],
		["灵体", ""],
		["令人发指", ""],
		["轮转", ""],
		["落井下石", ""],
		["蛮不讲理", ""],
		["漫谈", ""],
		["冒天下之大不", ""],
		["昧良心", ""],
		["昧心", ""],
		["门徒", ""],
		["蒙难", ""],
		["密件", ""],
		["密令", ""],
		["庙宇", ""],
		["灭顶之灾", ""],
		["灭口", ""],
		["明辨是非", ""],
		["明鉴", ""],
		["明星功派", ""],
		["明哲保身", ""],
		["明州", ""],
		["磨难中", ""],
		["莫须有", ""],
		["默祷", ""],
		["目不忍睹", ""],
		["恼羞成怒", ""],
		["闹灾", ""],
		["内奸", ""],
		["逆行", ""],
		["宁死不屈", ""],
		["奴役", ""],
		["女号", ""],
		["派出所", ""],
		["盘剥", ""],
		["盘问", ""],
		["判罪", ""],
		["叛变", ""],
		["叛徒", ""],
		["陪教", ""],
		["陪葬", ""],
		["批透", ""],
		["噼头盖脸", ""],
		["皮包骨", ""],
		["皮带", ""],
		["皮开肉绽", ""],
		["片警", ""],
		["骗局", ""],
		["破骇", ""],
		["破门而入", ""],
		["破绽百出", ""],
		["普天同庆", ""],
		["欺世盗名", ""],
		["欺侮", ""],
		["欺压", ""],
		["妻离子散", ""],
		["奇耻大辱", ""],
		["起诉书", ""],
		["启悟", ""],
		["气功", ""],
		["气焰嚣张", ""],
		["黔驴技穷", ""],
		["遣返", ""],
		["遣送", ""],
		["强压", ""],
		["敲诈勒索", ""],
		["侨民", ""],
		["亲善大使", ""],
		["请罪", ""],
		["穷途末路", ""],
		["穷凶极恶", ""],
		["囚车", ""],
		["囚禁", ""],
		["囚室", ""],
		["屈打成招", ""],
		["趋炎附势", ""],
		["权柄", ""],
		["权利", ""],
		["权势", ""],
		["权术", ""],
		["全盘否定", ""],
		["拳打脚踢", ""],
		["拳脚", ""],
		["群魔", ""],
		["群氓", ""],
		["人多势众", ""],
		["人间地狱", ""],
		["人伦", ""],
		["人面兽心", ""],
		["人世间", ""],
		["人欲横流", ""],
		["人云亦云", ""],
		["认识书", ""],
		["认罪", ""],
		["熔炼", ""],
		["如饥似渴", ""],
		["如梦初醒", ""],
		["辱骂", ""],
		["入监", ""],
		["入狱", ""],
		["软硬兼施", ""],
		["丧心病狂", ""],
		["杀戮", ""],
		["杀无赦", ""],
		["山海经", ""],
		["善恶必报", ""],
		["善恶有报", ""],
		["善恶终有报", ""],
		["善念", ""],
		["善有善报", ""],
		["善缘", ""],
		["伤天害理", ""],
		["上窜下跳", ""],
		["上纲上线", ""],
		["上林下火", ""],
		["上刑", ""],
		["上议院", ""],
		["烧人", ""],
		["社稷", ""],
		["神圣不可侵犯", ""],
		["神效", ""],
		["神户", ""],
		["神学", ""],
		["神智", ""],
		["升官", ""],
		["妖言", ""],
		["圣灵", ""],
		["圣明", ""],
		["圣人", ""],
		["圣水", ""],
		["圣徒", ""],
		["圣王", ""],
		["圣缘", ""],
		["师恩", ""],
		["师法", ""],
		["施暴", ""],
		["十字架", ""],
		["实修", ""],
		["示警", ""],
		["示众", ""],
		["誓约", ""],
		["市府", ""],
		["收监", ""],
		["收买", ""],
		["收容", ""],
		["收审", ""],
		["收尸", ""],
		["收押", ""],
		["手无寸铁", ""],
		["首恶", ""],
		["受虐", ""],
		["受屈", ""],
		["受辱", ""],
		["受刑", ""],
		["兽行", ""],
		["兽性", ""],
		["书面保证", ""],
		["熟视无睹", ""],
		["双盘", ""],
		["双修", ""],
		["水深火热", ""],
		["斯德哥尔摩", ""],
		["思想认识", ""],
		["私愤", ""],
		["私囊", ""],
		["私念", ""],
		["私设", ""],
		["私刑", ""],
		["司法局", ""],
		["司法厅", ""],
		["寺庙", ""],
		["寺院", ""],
		["怂恿", ""],
		["搜捕", ""],
		["搜查", ""],
		["搜身", ""],
		["太平盛世", ""],
		["太上皇", ""],
		["摊派", ""],
		["贪财", ""],
		["贪赃", ""],
		["讨论会", ""],
		["提审", ""],
		["体罚", ""],
		["体无完肤", ""],
		["替罪羊", ""],
		["天道", ""],
		["天年", ""],
		["天书", ""],
		["天体", ""],
		["天下大乱", ""],
		["天宇", ""],
		["天主教", ""],
		["条幅", ""],
		["铁丝网", ""],
		["听法", ""],
		["通天", ""],
		["同号", ""],
		["同僚", ""],
		["同门", ""],
		["同乡会", ""],
		["同心协力", ""],
		["痛不欲生", ""],
		["痛定思痛", ""],
		["痛改前非", ""],
		["痛哭流涕", ""],
		["痛心疾首", ""],
		["头破血流", ""],
		["头前抱轮", ""],
		["屠刀", ""],
		["土崩瓦解", ""],
		["脱胎换骨", ""],
		["歪风邪气", ""],
		["歪理", ""],
		["歪门邪道", ""],
		["外交官", ""],
		["外强中干", ""],
		["顽固不化", ""],
		["万恶", ""],
		["万古", ""],
		["万劫不复", ""],
		["万世", ""],
		["万事万物", ""],
		["王位", ""],
		["枉费心机", ""],
		["威逼", ""],
		["威德", ""],
		["威迫", ""],
		["威胁利诱", ""],
		["危言耸听", ""],
		["违犯", ""],
		["违抗", ""],
		["违心", ""],
		["围捕", ""],
		["唯利是图", ""],
		["为非作歹", ""],
		["为虎作伥", ""],
		["为所欲为", ""],
		["伪君子", ""],
		["我的认识", ""],
		["修法", ""],
		["污秽", ""],
		["污蔑", ""],
		["污辱", ""],
		["污言秽语", ""],
		["诬告", ""],
		["无地自容", ""],
		["无动于衷", ""],
		["无恶不作", ""],
		["无坚不摧", ""],
		["无理取闹", ""],
		["无生之门", ""],
		["无私无畏", ""],
		["无所不用其极", ""],
		["无所畏惧", ""],
		["无言以对", ""],
		["无中生有", ""],
		["五毒", ""],
		["五花大绑", ""],
		["五行", ""],
		["五脏六腑", ""],
		["物极必反", ""],
		["悟透", ""],
		["误传", ""],
		["误入歧途", ""],
		["西法", ""],
		["西方反华势力", ""],
		["牺牲品", ""],
		["讲法", ""],
		["宪法", ""],
		["习炼", ""],
		["习气", ""],
		["下议院", ""],
		["向内找", ""],
		["向上爬", ""],
		["消亡", ""],
		["邪变", ""],
		["邪不压正", ""],
		["大肆敛财", ""],
		["新教", ""],
		["新闻联播", ""],
		["信息员", ""],
		["刑具", ""],
		["刑讯", ""],
		["刑侦大队", ""],
		["行政手段", ""],
		["醒悟", ""],
		["凶暴", ""],
		["凶恶", ""],
		["凶犯", ""],
		["凶徒", ""],
		["凶相毕露", ""],
		["修道", ""],
		["修发", ""],
		["修练", ""],
		["修善", ""],
		["修习", ""],
		["修做", ""],
		["血迹斑斑", ""],
		["血泪", ""],
		["血淋淋", ""],
		["血腥", ""],
		["血印", ""],
		["巡捕", ""],
		["殉难", ""],
		["殉葬", ""],
		["训话", ""],
		["压制", ""],
		["押解", ""],
		["严刑", ""],
		["扬恶抑善", ""],
		["一言堂", ""],
		["一正压百邪", ""],
		["依法铲除", ""],
		["依法取缔", ""],
		["遗臭万年", ""],
		["以法为师", ""],
		["以法治国", ""],
		["阴德", ""],
		["救度", ""],
		["用刑", ""],
		["犹太人", ""],
		["油水", ""],
		["诱供", ""],
		["欲盖弥彰", ""],
		["冤假错桉", ""],
		["冤情", ""],
		["冤屈", ""],
		["小参考", ""],
		["援救", ""],
		["圆滑", ""],
		["造谣惑众", ""],
		["掌权", ""],
		["仗势欺人", ""],
		["真法", ""],
		["真佛", ""],
		["真果", ""],
		["真经", ""],
		["真修", ""],
		["争权", ""],
		["性关系", ""],
		["正义终将战胜邪恶", ""],
		["政保", ""],
		["政敌", ""],
		["政法", ""],
		["政法委", ""],
		["政见", ""],
		["政界", ""],
		["政客", ""],
		["政论", ""],
		["政委", ""],
		["政劙", ""],
		["政要", ""],
		["证法", ""],
		["证悟", ""],
		["致残", ""],
		["致死", ""],
		["治国", ""],
		["中饱", ""],
		["暴烈", ""],
		["死穴", ""],
		["中华人民共和国", ""],
		["中纪委", ""],
		["中联办", ""],
		["重修", ""],
		["众弟", ""],
		["众议院", ""],
		["转生", ""],
		["转世", ""],
		["自杀", ""],
		["自残", ""],
		["惨剧", ""],
		["宗派", ""],
		["走后门", ""],
		["走资派", ""],
		["罪大恶极", ""],
		["罪恶滔天", ""],
		["罪恶行径", ""],
		["罪恶昭彰", ""],
		["罪责难逃", ""],
		["右派", ""],
		["左派", ""],
		["走卒", ""],
		["做而不求", ""],
		["作法自毙", ""],
		["亘古未有", ""],
		["寰宇", ""],
		["泱泱大国", ""],
		["泯灭", ""],
		["逍遥法外", ""],
		["娼妓", ""],
		["嫖妓", ""],
		["贻害", ""],
		["敕令", ""],
		["罄竹难书", ""],
		["做鸡", ""],
		["做鸭", ""],
		["割头", ""],
		["插插", ""],
		["色狼", ""],
		["偷情", ""],
		["房价", ""],
		["医疗", ""],
		["飞鞋", ""],
		["王府井", ""],
		["两会", ""],
		["转基因", ""],
		["苍生", ""],
		["大赦", ""],
		["得度", ""],
		["点化", ""],
		["电棒", ""],
		["电椅", ""],
		["吊打", ""],
		["动功", ""],
		["独修", ""],
		["度化", ""],
		["二不保证", ""],
		["发出强大正念", ""],
		["发出正念", ""],
		["发完正念", ""],
		["发正念", ""],
		["封闭班", ""],
		["工潮", ""],
		["功友", ""],
		["功柱", ""],
		["公愤", ""],
		["公判", ""],
		["公审", ""],
		["公署", ""],
		["灌食", ""],
		["含冤", ""],
		["洪传", ""],
		["洪大", ""],
		["洪恩", ""],
		["洪吟", ""],
		["饥荒", ""],
		["集训队", ""],
		["集中营", ""],
		["佳木斯", ""],
		["假经", ""],
		["教友", ""],
		["结社", ""],
		["解教", ""],
		["决心书", ""],
		["绝裂书", ""],
		["苦渡", ""],
		["苦炼", ""],
		["苦役", ""],
		["酷吏", ""],
		["滥捕", ""],
		["炼不炼", ""],
		["轮转", ""],
		["蒙冤", ""],
		["欧共体", ""],
		["奴役", ""],
		["气功", ""],
		["启悟", ""],
		["亲共", ""],
		["轻舟网文", ""],
		["请功", ""],
		["学员", ""],
		["整根", ""],
		["肢体", ""],
		["三保", ""],
		["三不", ""],
		["三句话", ""],
		["三条", ""],
		["上议院", ""],
		["手无寸铁", ""],
		["特赦", ""],
		["土匪", ""],
		["下议院", ""],
		["宇宙之声", ""],
		["再教育", ""],
		["灵道", ""],
		["撸管", ""],
		["流出", ""],
		["河蟹", ""],
		["诺贝尔", ""],
		["挪威", ""],
		["千人", ""],
		["万人", ""],
		["年前", ""],
		["事件", ""],
		["文字", ""],
		["联盟", ""],
		["代表", ""],
		["点击", ""],
		["电信", ""],
		["BL", "ВL"],
		["08", "О8"],
		["零八", ""],
		["老师", ""],
		["教师", ""],
		["运动", ""],
		["98", "⑨8"],
		["敏感", ""],
		["考后", ""],
		["学生", ""],
		["找人", ""],
		["有意", ""],
		["六级", ""],
		["地下", ""],
		["6级", ""],
		["四级", ""],
		["必过", ""],
		["高考", ""],
		["通过", ""],
		["QQ", ""],
		["情趣", ""],
		["4级", ""],
		["哥哥", ""],
		["提供", ""],
		["广场", ""],
		["628", "б28"],
		["传送", ""],
		["不要点", ""],
		["加我", ""],
		["回复", ""],
		["好棒", ""],
		["骨干", ""],
		["团伙", ""],
		["窝点", ""],
		["读后感", ""],
		["研讨会", ""],
		["同修", ""],
		["电子书", ""],
		["屠夫", ""],
		["控诉", ""],
		["二不", ""],
		["万岁", ""],
		["法治", ""],
		["法制", ""],
		["反抗", ""],
		["复辟", ""],
		["港府", ""],
		["跟踪", ""],
		["公正", ""],
		["公众", ""],
		["末日", ""],
		["政策", ""],
		["清白", ""],
		["极乐世界", ""],
		["讲师", ""],
		["交流会", ""],
		["开慧", ""],
		["良民", ""],
		["明镜", ""],
		["末世", ""],
		["批斗", ""],
		["申诉", ""],
		["伸冤", ""],
		["消业", ""],
		["央视", ""],
		["CCTV", "СCTV"],
		["影碟", ""],
		["光盘", ""],
		["上门", ""],
		["喉咙", ""],
		["政治", ""],
		["知法", ""],
		["中国", ""],
		["法律", ""],
		["暴行", ""],
		["走狗", ""],
		["做好人", ""],
		["猛男", ""],
		["阉割", ""],
		["铃音", ""],
		["推广", ""],
		["煽动", ""],
		["颠覆", ""],
		["暴露", ""],
		["暴涨", ""],
		["考试", ""],
		["建国", ""],
		["宪政", ""],
		["官德", ""],
		["砒霜", ""],
		["沃土", ""],
		["天网", ""],
		["反分裂", ""],
		["开战", ""],
		["抗日", ""],
		["九一八", ""],
		["信誉", ""],
		["药品", ""],
		["藏区", ""],
		["交管", ""],
		["派出所", ""],
		["巡警", ""],
		["交警", ""],
		["刑警", ""],
		["特警", ""],
		["出逃", ""],
		["美领馆", ""],
		["活摘", ""],
		["康生", ""],
		["江青", ""],
		["于春生", ""],
		["马勇霞", ""],
		["王炜", ""],
		["王长河", ""],
		["王立英", ""],
		["王仲田", ""],
		["王华庆", ""],
		["王会生", ""],
		["王怀臣", ""],
		["王忠民", ""],
		["王和民", ""],
		["王宜林", ""],
		["王森泰", ""],
		["王晓龙", ""],
		["王家胜", ""],
		["王宾宜", ""],
		["王瑞生", ""],
		["丹珠昂奔", ""],
		["尹晋华", ""],
		["石生龙", ""],
		["叶青纯", ""],
		["付建华", ""],
		["冯惠敏", ""],
		["弘强", ""],
		["曲青山", ""],
		["曲淑辉", ""],
		["吕建成", ""],
		["刘赐贵", ""],
		["安立敏", ""],
		["苏波", ""],
		["杜金富", ""],
		["李宁", ""],
		["李刚", ""],
		["李熙", ""],
		["李五四", ""],
		["李书磊", ""],
		["李兆前", ""],
		["李法泉", ""],
		["李建波", ""],
		["李适时", ""],
		["李秋芳", ""],
		["李家祥", ""],
		["杨立顺", ""],
		["杨明生", ""],
		["杨晓渡", ""],
		["吴刚", ""],
		["吴杰明", ""],
		["岑旭", ""],
		["何平", ""],
		["辛维光", ""],
		["汪民", ""],
		["宋明昌", ""],
		["宋璇涛", ""],
		["张力", ""],
		["张勇", ""],
		["张立军", ""],
		["张昌平", ""],
		["张晓兰", ""],
		["陈伦", ""],
		["陈训秋", ""],
		["陈绪国", ""],
		["陈新权", ""],
		["苗华", ""],
		["金书波", ""],
		["郑国光", ""],
		["胡玉敏", ""],
		["胡问鸣", ""],
		["侯长安", ""],
		["侯贺华", ""],
		["袁彦鹏", ""],
		["耿文清", ""],
		["耿燎原", ""],
		["柴绍良", ""],
		["徐敬业", ""],
		["郭永平", ""],
		["郭向远", ""],
		["黄先耀", ""],
		["黄建盛", ""],
		["黄殿中", ""],
		["曹培玺", ""],
		["梁滨", ""],
		["韩亨林", ""],
		["谢杭生", ""],
		["谢国明", ""],
		["臧献甫", ""],
		["熊维平", ""],
		["黎晓宏", ""]
	],
	high: [
		["局", "jú"],
		["政", "zhèng"],
		["警", "jǐng"],
		["法", "fǎ"],
		["杀", "shā"],
		["尸", "shī"],
		["罢", "bà"],
		["党", "dǎng"],
		["权", "泉"],
		["官", "guān"],
		["骚", "sāo"],
		["奸", "jiān"],
		["华", "huá"],
		["国", "囯"],
		["宪", "xiàn"],
		["炸", "zhà"],
		["爆", "bào"],
		["袭", "xí"],
		["暴", "bào"],
		["枪", "qiāng"],
		["虐", "nuè"],
		["血", "xuè"],
		["插", "擦"],
		["屠", "tú"],
		["棍", "gùn"],
		["禁", "jìn"],
		["刀", "dāo"],
		["药", "yào"],
		["毒", "dú"],
		["淫", "yín"],
		["奶", "nǎi"],
		["爸", "bà"],
		["妈", "mā"],
		["爷", "yé"],
		["乳", "rǔ"],
		["操", "cāo"],
		["草", "cǎo"],
		["逼", "bī"],
		["尿", "niào"],
		["穴", "xué"],
		["肛", "钢"],
		["喷", "烹"],
		["霸", "坝"],
		["鸡", "基"],
		["狗", "苟"],
		["鸭", "压"],
		["日", "曰"],
		["蒋", "桨"],
		["猪", "租"],
		["蠢", "惷"],
		["愚", "鱼"],
		["傻", "洒"],
		["娘", "酿"],
		["贱", "剑"],
		["婊", "裱"],
		["耻", "齿"],
		["蛋", "弹"],
		["渣", "氵查"],
		["脱", "拖"],
		["裸", "倮"],
		["嫩", "nèn"],
		["江", "jiāng"],
		["胡", "hú"],
		["温", "wēn"],
		["邓", "dèng"],
		["毛", "máo"],
		["寇", "kòu"],
		["痴", "chī"],
		["呆", "dāi"],
		["刑", "xíng"],
		["拘", "jū"],
		["恶", "è"],
		["邪", "xié"],
		["歹", "dǎi"],
		["死", "sǐ"],
		["痒", "养"],
		["搓", "cuō"],
		["粗", "cū"],
		["臀", "tún"],
		["嫖", "瞟"],
		["亡", "王"],
		["罪", "zuì"],
		["贪", "tān"],
		["兵", "bīng"],
		["军", "jun"],
		["求", "qiú"],
		["灭", "miè"],
		["割", "gē"],
		["拆", "chāi"],
		["砸", "zá"],
		["绑", "bǎng"],
		["贼", "zéi"],
		["妓", "技"],
		["肏", "cào"],
		["婊", "biǎo"],
		["戳", "chuō"],
		["屎", "shǐ"],
		["舔", "tiǎn"],
		["吮", "shǔn "],
		["删", "册刂"],
		["姦", "jiān"],
		["尻", "kāo"],
		["捅", "tǒng"],
		["腿", "tuǐ"],
		["胯", "kuà"],
		["捏", "niē"],
		["娇", "jiāo"],
		["泻", "xiè"],
		["泄", "xiè"],
		["揉 ", "róu"],
		["牝", "pìn"],
		["含", "hán"],
		["流", "liú"],
		["摸", "mō"],
		["弄", "nòng"],
		["亲", "qīn"],
		["爽", "shuǎng"],
		["吞", "tūn"],
		["吻", "wěn"],
		["吸", "xī"],
		["习", "xí"],
		["ply", ""],
		["彭", "péng"],
		["杨", "yáng"],
		["佳", "jiā"],
		["BK", ""],
		["藏", "zàng"],
		["乌", "wū"],
		["针", "zhēn"],
		["售", "shòu"],
		["ZF", ""],
		["hyb", ""],
		["卖", "mài"],
		["买", "mǎi"],
		["色", "sè"],
		["刘", "liú"],
		["茉", "mò"],
		["花", "huā"]
	]
};

export default exports as typeof import('./minganci');
